(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8cd9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8cd9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c094de5bd35107a3$export$3ba232387fd5d6dd; }, function (v) { return $c094de5bd35107a3$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$3ba232387fd5d6dd;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
function $c094de5bd35107a3$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$3ba232387fd5d6dd = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("eWCkp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1436a51f26d258$export$2e2bcd8739ae039; });

var $hyxPM = parcelRequire("hyxPM");
var $ae1436a51f26d258$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ae1436a51f26d258$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $hyxPM.default)(function(prop) {
    return $ae1436a51f26d258$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("hyxPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc7fdb626f425e02$export$2e2bcd8739ae039; });
function $cc7fdb626f425e02$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8iuPV", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "avatar.13d31d7e.svg";

});

parcelRegister("evEpp", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "avatarLoggedIn.d656bbc2.svg";

});

parcelRegister("4izHh", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "heart.adf00049.svg";

});

parcelRegister("lXTIH", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "search.2a213cc7.svg";

});

parcelRegister("cQfsc", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "close.5e84e66d.svg";

});

parcelRegister("7E9SH", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "burger.922621e7.svg";

});

parcelRegister("5J5rr", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "arrow.029bd5fc.svg";

});

parcelRegister("cmHZg", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "orders.6a2c0f01.svg";

});

parcelRegister("aYv9L", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "location.3815adcf.svg";

});

parcelRegister("gyiKh", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "payment.52cce142.svg";

});

parcelRegister("fo5QP", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "settings.8f57efee.svg";

});

parcelRegister("9yd5C", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "amex-outline.7fa30abf.svg";

});

parcelRegister("cUin7", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "applepay-outline.cb18d391.svg";

});

parcelRegister("4myvM", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "paypal-outline.870bde74.svg";

});

parcelRegister("f4cpI", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "visa-outline.c1a78baa.svg";

});

parcelRegister("4DTTn", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "mastercard-outline.d3104191.svg";

});

parcelRegister("aHxV5", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "tiktok.f7adf06d.png";

});

parcelRegister("860s1", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "instagram.38ce5c98.png";

});

parcelRegister("iEFTJ", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "facebook.542a6840.png";

});

parcelRegister("XjDIu", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "twitter.15732c0b.png";

});

parcelRegister("dgvCr", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "sign-in.aabbd4f1.png";

});

parcelRegister("4IMgc", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "arrow-down.99472fef.svg";

});

parcelRegister("JLGTD", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "delete.81ab61f5.svg";

});

parcelRegister("kGTY5", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "edit.a5bb8834.svg";

});

parcelRegister("aX0ER", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "visa-color.b7cad046.svg";

});

parcelRegister("bgWyS", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "mastercard-color.44ffea03.svg";

});

parcelRegister("iKWwa", function(module, exports) {

module.exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "upload.c724dfc0.svg";

});

parcelRegister("86xDK", function(module, exports) {


module.exports = (parcelRequire("9FZDf"))((parcelRequire("lGKbD")).resolve("jD60Z")).then(()=>parcelRequire("cNIke"));

});
parcelRegister("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case "preload":
            return $6c92f53da2785287$var$cachedPreloads;
        case "prefetch":
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;




parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
const $5ddea511a1df74b4$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $b588e509ec7465c1$export$700979bc83e7db82 = (0, $5ddea511a1df74b4$export$4e09c449d6c407f7) ? (0, $6cds3.useLayoutEffect) : (0, $6cds3.useEffect);


function $3ada8cab384c9a26$export$80c2a3957bcb42ea() {
    const isMounted = (0, $6cds3.useRef)(false);
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $dcf17e8536d5fb4f$export$8793edee2d425525 = (any)=>any;


const $141b563636682491$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


class $04326321df67f623$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $04326321df67f623$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $04326321df67f623$var$Queue();
    let nextFrame = new $04326321df67f623$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $bc1a7c89d5fd79e5$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $bc1a7c89d5fd79e5$var$maxElapsed = 40;
function $bc1a7c89d5fd79e5$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $bc1a7c89d5fd79e5$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $04326321df67f623$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>{
        steps[stepId].process(state);
    };
    const processBatch = ()=>{
        const timestamp = (0, $141b563636682491$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $bc1a7c89d5fd79e5$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $bc1a7c89d5fd79e5$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $bc1a7c89d5fd79e5$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$bc1a7c89d5fd79e5$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $abdd74f2cc691999$export$2cef06c20297c17d, cancel: $abdd74f2cc691999$export$ec99c0ef4978dccb, state: $abdd74f2cc691999$export$fff89137e9e818ce, steps: $abdd74f2cc691999$export$be3f796aed065412 } = (0, $bc1a7c89d5fd79e5$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $dcf17e8536d5fb4f$export$8793edee2d425525), true);


function $b290eb7c0f34fa74$export$91db9bc4f8ac944a() {
    const isMounted = (0, $3ada8cab384c9a26$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $6cds3.useState)(0);
    const forceRender = (0, $6cds3.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $6cds3.useCallback)(()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/**
 * @public
 */ const $e40c1c7ce208ba78$export$f224e4635b6f8ce2 = (0, $6cds3.createContext)(null);



var $6cds3 = parcelRequire("6cds3");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $491d0f9d7a26c5a8$export$fe4300aa8eebea86(init) {
    const ref = (0, $6cds3.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/**
 * @public
 */ const $874d1c1409e5f81e$export$22a697fb29aac98d = (0, $6cds3.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $4ca2d8047b4739e2$var$PopChildMeasure extends $6cds3.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $4ca2d8047b4739e2$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $6cds3.useId)();
    const ref = (0, $6cds3.useRef)(null);
    const size = (0, $6cds3.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $6cds3.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $6cds3.createElement($4ca2d8047b4739e2$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $6cds3.cloneElement(children, {
        ref: ref
    }));
}


const $ed269eff01268d92$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)($ed269eff01268d92$var$newChildrenMap);
    const id = (0, $6cds3.useId)();
    const context = (0, $6cds3.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $6cds3.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $6cds3.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $6cds3.createElement((0, $4ca2d8047b4739e2$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $6cds3.createElement((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $ed269eff01268d92$var$newChildrenMap() {
    return new Map();
}



var $6cds3 = parcelRequire("6cds3");
const $5f7d717553e210fe$export$a3579ca508007a95 = (0, $6cds3.createContext)({});




var $6cds3 = parcelRequire("6cds3");
function $1261c2c53e6b9f12$export$f3a192d0cbd30b96(callback) {
    return (0, $6cds3.useEffect)(()=>()=>callback(), []);
}



let $faee95b32f04793f$export$491112666e282270 = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
let $faee95b32f04793f$export$f5708dca728d7177 = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
var $faee95b32f04793f$var$check, $faee95b32f04793f$var$message, $faee95b32f04793f$var$check1, $faee95b32f04793f$var$message1;


const $35bf9e9aed03b88e$var$getChildKey = (child)=>child.key || "";
function $35bf9e9aed03b88e$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $35bf9e9aed03b88e$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $35bf9e9aed03b88e$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $6cds3.Children).forEach(children, (child)=>{
        if ((0, $6cds3.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $35bf9e9aed03b88e$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $faee95b32f04793f$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95)).forceRender || (0, $b290eb7c0f34fa74$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $3ada8cab384c9a26$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $35bf9e9aed03b88e$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $6cds3.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $6cds3.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $6cds3.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $6cds3.useRef)(true);
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $35bf9e9aed03b88e$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $1261c2c53e6b9f12$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $6cds3.createElement($6cds3.Fragment, null, childrenToRender.map((child)=>$6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
            key: $35bf9e9aed03b88e$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($35bf9e9aed03b88e$var$getChildKey);
    const targetKeys = filteredChildren.map($35bf9e9aed03b88e$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $35bf9e9aed03b88e$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
                key: $35bf9e9aed03b88e$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $6cds3.createElement((0, $ed269eff01268d92$export$979daf65881a382a), {
            key: $35bf9e9aed03b88e$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $6cds3.createElement($6cds3.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $6cds3.cloneElement)(child)));
};


var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
const $ebdd93538295fd0b$export$2285bbca2c666415 = (0, $6cds3.createContext)({});



var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");
const $027323c169da8fa9$export$40f10139ecf1f171 = (0, $6cds3.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $3bc74152d744365d$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $acf7e02863b7c6a2$export$ed7b8fa9dbf0105d = "framerAppearId";
const $acf7e02863b7c6a2$export$8592e1c077c890a6 = "data-" + (0, $3bc74152d744365d$export$9fd24a634729c672)($acf7e02863b7c6a2$export$ed7b8fa9dbf0105d);



const { schedule: $e7af5054e8b29038$export$bb76eed83315504c, cancel: $e7af5054e8b29038$export$3252729004b8456e } = (0, $bc1a7c89d5fd79e5$export$510b0596a933801a)(queueMicrotask, false);


function $40a69983ea87a7ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415));
    const lazyContext = (0, $6cds3.useContext)((0, $027323c169da8fa9$export$40f10139ecf1f171));
    const presenceContext = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $6cds3.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $6cds3.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $6cds3.useRef)(Boolean(props[0, $acf7e02863b7c6a2$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $b588e509ec7465c1$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        (0, $e7af5054e8b29038$export$bb76eed83315504c).postRender(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $6cds3.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $6cds3 = parcelRequire("6cds3");
function $1c79ac3705c6b6d1$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $90806267369c30cf$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $6cds3.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $6cds3 = parcelRequire("6cds3");

/**
 * Decides if the supplied variable is variant label
 */ function $23e2b8e45e65dfac$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $cba7aa384b255de7$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $20855a5d0b260125$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $20855a5d0b260125$export$1405a65085f40b9 = [
    "initial",
    ...$20855a5d0b260125$export$16e45afcc206d3a8
];


function $9b5ea444b3556797$export$4b3c3bd8d910d78d(props) {
    return (0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(props.animate) || (0, $20855a5d0b260125$export$1405a65085f40b9).some((name)=>(0, $23e2b8e45e65dfac$export$720b90e312cea233)(props[name]));
}
function $9b5ea444b3556797$export$ce46fa4165cdec40(props) {
    return Boolean($9b5ea444b3556797$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $3f04b40ab69fc8fb$export$12fc32fc096a04a3(props, context) {
    if ((0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $23e2b8e45e65dfac$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $23e2b8e45e65dfac$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $520ddbac949d6fdc$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $3f04b40ab69fc8fb$export$12fc32fc096a04a3)(props, (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415)));
    return (0, $6cds3.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $520ddbac949d6fdc$var$variantLabelsAsDependency(initial),
        $520ddbac949d6fdc$var$variantLabelsAsDependency(animate)
    ]);
}
function $520ddbac949d6fdc$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a953b6ada2f72db5$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a953b6ada2f72db5$export$65570e08d843624d = {};
for(const key in $a953b6ada2f72db5$var$featureProps)$a953b6ada2f72db5$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a953b6ada2f72db5$var$featureProps[key].some((name)=>!!props[name])
};


function $aca4ab24ef876987$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a953b6ada2f72db5$export$65570e08d843624d)[key] = {
        ...(0, $a953b6ada2f72db5$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $6cds3 = parcelRequire("6cds3");
/**
 * Internal, exported only for usage in Framer
 */ const $80cd083093aee758$export$da5f7b802957459a = (0, $6cds3.createContext)({});


const $3b011ee003f444b4$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $60bdad86d4074aed$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $aca4ab24ef876987$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $6cds3.useContext)((0, $874d1c1409e5f81e$export$22a697fb29aac98d)),
            ...props,
            layoutId: $60bdad86d4074aed$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $520ddbac949d6fdc$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $5ddea511a1df74b4$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $40a69983ea87a7ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $6cds3.useContext)((0, $80cd083093aee758$export$da5f7b802957459a));
            const isStrict = (0, $6cds3.useContext)((0, $027323c169da8fa9$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $6cds3.createElement((0, $ebdd93538295fd0b$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $6cds3.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $90806267369c30cf$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $6cds3.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $3b011ee003f444b4$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $60bdad86d4074aed$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $31c6675f74aec206$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $60bdad86d4074aed$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $2692c437a8fd9588$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $13b7dd579aa6d2ca$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $2692c437a8fd9588$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
const $f4236abcb41ce1af$export$91ddd985b97788d1 = {};
function $f4236abcb41ce1af$export$de9e7791c71225fd(correctors) {
    Object.assign($f4236abcb41ce1af$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $d1c315412dc4e663$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $d1c315412dc4e663$export$7b42a0094fb00b6e = new Set($d1c315412dc4e663$export$280dc01950909d86);


function $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $f4236abcb41ce1af$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $251f7d673c9c86a3$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $bd773126b9f243d5$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $bd773126b9f243d5$var$numTransforms = (0, $d1c315412dc4e663$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $bd773126b9f243d5$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $bd773126b9f243d5$var$numTransforms; i++){
        const key = (0, $d1c315412dc4e663$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $bd773126b9f243d5$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $58159485ea5b9511$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $58159485ea5b9511$export$9de1236619d9e756 = $58159485ea5b9511$var$checkStringStartsWith("--");
const $58159485ea5b9511$var$startsAsVariableToken = $58159485ea5b9511$var$checkStringStartsWith("var(--");
const $58159485ea5b9511$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $58159485ea5b9511$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $58159485ea5b9511$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $58159485ea5b9511$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $f97b248c59f08e79$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $fa84546edb6e889a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $9ad8a8be30ce5844$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $9ad8a8be30ce5844$export$58f0f39f63f3cf42 = {
    ...$9ad8a8be30ce5844$export$98e628dec113755e,
    transform: (v)=>(0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $9ad8a8be30ce5844$export$dcdf75081b88279d = {
    ...$9ad8a8be30ce5844$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $338f435df31a3d26$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $338f435df31a3d26$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $338f435df31a3d26$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $338f435df31a3d26$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $338f435df31a3d26$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $d414efec423ce291$var$createUnitType = (unit)=>({
        test: (v)=>(0, $338f435df31a3d26$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $d414efec423ce291$export$41fc368e1a942b97 = $d414efec423ce291$var$createUnitType("deg");
const $d414efec423ce291$export$626336c2cd4b14de = $d414efec423ce291$var$createUnitType("%");
const $d414efec423ce291$export$91c0eda1d06bf008 = $d414efec423ce291$var$createUnitType("px");
const $d414efec423ce291$export$f91e8c45a95a32f2 = $d414efec423ce291$var$createUnitType("vh");
const $d414efec423ce291$export$aed3d7b7d206c196 = $d414efec423ce291$var$createUnitType("vw");
const $d414efec423ce291$export$44e2e1705876d7ed = {
    ...$d414efec423ce291$export$626336c2cd4b14de,
    parse: (v)=>$d414efec423ce291$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$d414efec423ce291$export$626336c2cd4b14de.transform(v * 100)
};



const $c36e63324803d105$export$7d260a2a5f8bc19e = {
    ...(0, $9ad8a8be30ce5844$export$98e628dec113755e),
    transform: Math.round
};


const $5cd21c5d2c5b7cec$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderRightWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    radius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    maxWidth: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    height: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    maxHeight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    size: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    top: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    right: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    bottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    left: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingTop: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingRight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingBottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    paddingLeft: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    margin: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginTop: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginRight: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginBottom: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    marginLeft: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateX: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateY: (0, $d414efec423ce291$export$41fc368e1a942b97),
    rotateZ: (0, $d414efec423ce291$export$41fc368e1a942b97),
    scale: $9ad8a8be30ce5844$export$dcdf75081b88279d,
    scaleX: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    scaleY: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    scaleZ: (0, $9ad8a8be30ce5844$export$dcdf75081b88279d),
    skew: (0, $d414efec423ce291$export$41fc368e1a942b97),
    skewX: (0, $d414efec423ce291$export$41fc368e1a942b97),
    skewY: (0, $d414efec423ce291$export$41fc368e1a942b97),
    distance: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateX: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateY: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    translateZ: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    x: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    y: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    z: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    perspective: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    transformPerspective: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    opacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    originX: (0, $d414efec423ce291$export$44e2e1705876d7ed),
    originY: (0, $d414efec423ce291$export$44e2e1705876d7ed),
    originZ: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $c36e63324803d105$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $d414efec423ce291$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42),
    numOctaves: (0, $c36e63324803d105$export$7d260a2a5f8bc19e)
};


function $371459a1640f998f$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $58159485ea5b9511$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $5cd21c5d2c5b7cec$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $f97b248c59f08e79$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $bd773126b9f243d5$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $ccea98651e8f869c$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $d67c8c7c4130cfba$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $251f7d673c9c86a3$export$605d60a2578142d3)(source[key]) && !(0, $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $d67c8c7c4130cfba$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $6cds3.useMemo)(()=>{
        const state = (0, $ccea98651e8f869c$export$8940b483cf52eeda)();
        (0, $371459a1640f998f$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $d67c8c7c4130cfba$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $d67c8c7c4130cfba$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $d67c8c7c4130cfba$var$useInitialMotionValues(props, visualState, isStatic));
    return style;
}
function $d67c8c7c4130cfba$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $d67c8c7c4130cfba$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $96d9d0f780f718ca$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $96d9d0f780f718ca$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $96d9d0f780f718ca$var$validMotionProps.has(key);
}


let $46bf78dd23632642$var$shouldForward = (key)=>!(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key);
function $46bf78dd23632642$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $46bf78dd23632642$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $46bf78dd23632642$export$59d6962c470509a5((parcelRequire("eWCkp")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $46bf78dd23632642$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($46bf78dd23632642$var$shouldForward(key) || forwardMotionProps === true && (0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) || !isDom && !(0, $96d9d0f780f718ca$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $6cds3 = parcelRequire("6cds3");



function $b77b3238a5e2cf7d$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $b77b3238a5e2cf7d$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $b77b3238a5e2cf7d$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $b77b3238a5e2cf7d$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $6b5e1ea882fb62b1$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $6b5e1ea882fb62b1$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $6b5e1ea882fb62b1$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $6b5e1ea882fb62b1$var$dashKeys : $6b5e1ea882fb62b1$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $d414efec423ce291$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $85a07f77d14903fc$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $371459a1640f998f$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $b77b3238a5e2cf7d$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $6b5e1ea882fb62b1$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $ccea98651e8f869c$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $7ee347ff6d81ac56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $91d65fc990f1a95d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $6cds3.useMemo)(()=>{
        const state = (0, $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9)();
        (0, $85a07f77d14903fc$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $d67c8c7c4130cfba$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $895c6e7acd0991b4$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? (0, $91d65fc990f1a95d$export$84309c4f53cb1bd5) : (0, $d67c8c7c4130cfba$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $46bf78dd23632642$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $6cds3.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $6cds3.useMemo)(()=>(0, $251f7d673c9c86a3$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $6cds3.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $9bc9ba6c7615124c$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $671a4e7e4df97a9a$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $afcd7ecf658716d9$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $9bc9ba6c7615124c$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $671a4e7e4df97a9a$export$28931db5d57958e5).has(key) ? (0, $3bc74152d744365d$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a95906244a2d7e5e$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevProps.style[key]) || (0, $c7c26ba3aa2ea131$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $79ce2b625ef60476$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a95906244a2d7e5e$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(props[key]) || (0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $d1c315412dc4e663$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $6cds3 = parcelRequire("6cds3");


function $c0f30ec55cd531d9$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $cdfb45bee9c27be9$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $4d89fd6dc8b0f394$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $4d89fd6dc8b0f394$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $acbc391d093466b3$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $4d89fd6dc8b0f394$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $464ec9c807f3e0b4$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $464ec9c807f3e0b4$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $464ec9c807f3e0b4$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $6cds3.useContext)((0, $ebdd93538295fd0b$export$2285bbca2c666415));
        const presenceContext = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
        const make = ()=>$464ec9c807f3e0b4$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $491d0f9d7a26c5a8$export$fe4300aa8eebea86)(make);
    };
function $464ec9c807f3e0b4$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $9b5ea444b3556797$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $287e28872a2d5f38$export$44dabd3fae512e85 = {
    useVisualState: (0, $464ec9c807f3e0b4$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $79ce2b625ef60476$export$16da615486abaa45),
        createRenderState: (0, $75ca4a7bad37c3e8$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).render(()=>{
                (0, $85a07f77d14903fc$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $afcd7ecf658716d9$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $f10027b5076f7c66$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $464ec9c807f3e0b4$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a95906244a2d7e5e$export$16da615486abaa45,
        createRenderState: (0, $ccea98651e8f869c$export$8940b483cf52eeda)
    })
};


function $cb5f7861a7a27279$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? (0, $287e28872a2d5f38$export$44dabd3fae512e85) : (0, $f10027b5076f7c66$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $895c6e7acd0991b4$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $3b9e8293424667bf$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $e686dca3072f0847$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $230784ee47833b0a$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $230784ee47833b0a$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $e686dca3072f0847$export$a4cf9c8a4b063a6e)(event) && handler(event, $230784ee47833b0a$export$12f84bb882d06e1a(event));
};


function $59727fd3e6cd9f0c$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(target, eventName, (0, $230784ee47833b0a$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $81c10aac384f5ba3$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $81c10aac384f5ba3$export$a4627e546088548d = (...transformers)=>transformers.reduce($81c10aac384f5ba3$var$combineFunctions);


function $6b9c534ca65d1916$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $6b9c534ca65d1916$var$globalHorizontalLock = $6b9c534ca65d1916$export$518c5fc2dcb7974b("dragHorizontal");
const $6b9c534ca65d1916$var$globalVerticalLock = $6b9c534ca65d1916$export$518c5fc2dcb7974b("dragVertical");
function $6b9c534ca65d1916$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $6b9c534ca65d1916$var$globalVerticalLock();
    else if (drag === "x") lock = $6b9c534ca65d1916$var$globalHorizontalLock();
    else {
        const openHorizontal = $6b9c534ca65d1916$var$globalHorizontalLock();
        const openVertical = $6b9c534ca65d1916$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $6b9c534ca65d1916$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $6b9c534ca65d1916$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $617d59ae1886b5b2$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


function $c4db1434d52a9998$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $6b9c534ca65d1916$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) props[callbackName](event, info);
    };
    return (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $c4db1434d52a9998$export$93a81ea037eac456 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $81c10aac384f5ba3$export$a4627e546088548d)($c4db1434d52a9998$var$addHoverEvent(this.node, true), $c4db1434d52a9998$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $d2f509fd0b24572d$export$d4826db40d47595b extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $81c10aac384f5ba3$export$a4627e546088548d)((0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $0c844bc4120cf1fc$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $0c844bc4120cf1fc$export$e841ada32ff745b(parent, child.parentElement);
};



function $5052b2c80097d882$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $230784ee47833b0a$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $5052b2c80097d882$export$f026abdbba7f0c9e extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeEndListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ !globalTapTarget && !(0, $0c844bc4120cf1fc$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
            };
            const removePointerUpListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $5052b2c80097d882$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) onTap(event, info);
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $5052b2c80097d882$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $5052b2c80097d882$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) onTapStart(event, info);
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $6b9c534ca65d1916$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) onTapCancel(event, info);
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $59ac27f66aea5dfe$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $59ac27f66aea5dfe$var$observers = new WeakMap();
const $59ac27f66aea5dfe$var$fireObserverCallback = (entry)=>{
    const callback = $59ac27f66aea5dfe$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $59ac27f66aea5dfe$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($59ac27f66aea5dfe$var$fireObserverCallback);
};
function $59ac27f66aea5dfe$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$59ac27f66aea5dfe$var$observers.has(lookupRoot)) $59ac27f66aea5dfe$var$observers.set(lookupRoot, {});
    const rootObservers = $59ac27f66aea5dfe$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($59ac27f66aea5dfe$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $59ac27f66aea5dfe$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $59ac27f66aea5dfe$var$initIntersectionObserver(options);
    $59ac27f66aea5dfe$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $59ac27f66aea5dfe$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $39c5bf68d6322b93$var$thresholdNames = {
    some: 0,
    all: 1
};
class $39c5bf68d6322b93$export$150851c8cc2f0c72 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $39c5bf68d6322b93$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $59ac27f66aea5dfe$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($39c5bf68d6322b93$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $39c5bf68d6322b93$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $9f80faa8a4e07d80$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $39c5bf68d6322b93$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $5052b2c80097d882$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $d2f509fd0b24572d$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $c4db1434d52a9998$export$93a81ea037eac456)
    }
};





function $b72ed983341c6484$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $09bc9ca971307c1d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $09bc9ca971307c1d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $09bc9ca971307c1d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $09bc9ca971307c1d$var$getCurrent(visualElement), $09bc9ca971307c1d$var$getVelocity(visualElement));
}






/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $a9e2d00978e30fa4$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $f3507eb24a522f61$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $f3507eb24a522f61$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $f3507eb24a522f61$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $f3507eb24a522f61$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $f3507eb24a522f61$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $f3507eb24a522f61$var$keyframesTransition;
    else if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $f3507eb24a522f61$var$criticallyDampedSpring(keyframes[1]) : $f3507eb24a522f61$var$underDampedSpring;
    return $f3507eb24a522f61$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $6dd602398ed69a9c$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $6dd602398ed69a9c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $8fa4692997fef09a$export$888a3d84909f9e3d = {
    current: false
};


const $71f528837f15cf2e$var$isNotNull = (value)=>value !== null;
function $71f528837f15cf2e$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($71f528837f15cf2e$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





let $3e17eaada8a9f521$var$now;
function $3e17eaada8a9f521$var$clearTime() {
    $3e17eaada8a9f521$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $3e17eaada8a9f521$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($3e17eaada8a9f521$var$now === undefined) $3e17eaada8a9f521$export$2da9be4cfdb689b1.set((0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing || (0, $141b563636682491$export$dd826089e3c5e502).useManualTiming ? (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp : performance.now());
        return $3e17eaada8a9f521$var$now;
    },
    set: (newTime)=>{
        $3e17eaada8a9f521$var$now = newTime;
        queueMicrotask($3e17eaada8a9f521$var$clearTime);
    }
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $96f381b193ee6086$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $63ed2da846c28a44$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $96f381b193ee6086$export$ade84c85e44a6cb1)(value);
    else return true;
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $586a8c9354c052af$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $17d46babbc343972$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $17d46babbc343972$export$b9f0c1f373aee2b0(current) {
    const match = $17d46babbc343972$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $17d46babbc343972$var$maxDepth = 4;
function $17d46babbc343972$export$289398774300c991(current, element, depth = 1) {
    (0, $faee95b32f04793f$export$f5708dca728d7177)(depth <= $17d46babbc343972$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $17d46babbc343972$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $586a8c9354c052af$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $58159485ea5b9511$export$31f9caa2600b5723)(fallback) ? $17d46babbc343972$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $c124c5f5f2629442$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c124c5f5f2629442$export$8e5250d1aa9bf370 = (v)=>v === (0, $9ad8a8be30ce5844$export$98e628dec113755e) || v === (0, $d414efec423ce291$export$91c0eda1d06bf008);
const $c124c5f5f2629442$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c124c5f5f2629442$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $c124c5f5f2629442$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $c124c5f5f2629442$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c124c5f5f2629442$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c124c5f5f2629442$var$nonTranslationalTransformKeys = (0, $d1c315412dc4e663$export$280dc01950909d86).filter((key)=>!$c124c5f5f2629442$var$transformKeys.has(key));
function $c124c5f5f2629442$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $c124c5f5f2629442$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $c124c5f5f2629442$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c124c5f5f2629442$var$getTranslateFromMatrix(4, 13),
    y: $c124c5f5f2629442$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c124c5f5f2629442$export$781d46a8aa670d52.translateX = $c124c5f5f2629442$export$781d46a8aa670d52.x;
$c124c5f5f2629442$export$781d46a8aa670d52.translateY = $c124c5f5f2629442$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $d8af184010c14e94$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $f2ef0e515384c134$export$d176691c1998a1f5 = [
    (0, $9ad8a8be30ce5844$export$98e628dec113755e),
    (0, $d414efec423ce291$export$91c0eda1d06bf008),
    (0, $d414efec423ce291$export$626336c2cd4b14de),
    (0, $d414efec423ce291$export$41fc368e1a942b97),
    (0, $d414efec423ce291$export$aed3d7b7d206c196),
    (0, $d414efec423ce291$export$f91e8c45a95a32f2),
    (0, $d8af184010c14e94$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $f2ef0e515384c134$export$eefdd52e3ccae428 = (v)=>$f2ef0e515384c134$export$d176691c1998a1f5.find((0, $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd)(v));




const $e98e01a5b45d1d79$var$toResolve = new Set();
let $e98e01a5b45d1d79$var$isScheduled = false;
let $e98e01a5b45d1d79$var$anyNeedsMeasurement = false;
function $e98e01a5b45d1d79$var$measureAllKeyframes() {
    if ($e98e01a5b45d1d79$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($e98e01a5b45d1d79$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $c124c5f5f2629442$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, (0, $c124c5f5f2629442$export$39d4bc9655f3f632)(element));
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $e98e01a5b45d1d79$var$anyNeedsMeasurement = false;
    $e98e01a5b45d1d79$var$isScheduled = false;
    $e98e01a5b45d1d79$var$toResolve.forEach((resolver)=>resolver.complete());
    $e98e01a5b45d1d79$var$toResolve.clear();
}
function $e98e01a5b45d1d79$var$readAllKeyframes() {
    $e98e01a5b45d1d79$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $e98e01a5b45d1d79$var$anyNeedsMeasurement = true;
    });
}
function $e98e01a5b45d1d79$export$78b96d2a12593b05() {
    $e98e01a5b45d1d79$var$readAllKeyframes();
    $e98e01a5b45d1d79$var$measureAllKeyframes();
}
class $e98e01a5b45d1d79$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $e98e01a5b45d1d79$var$toResolve.add(this);
            if (!$e98e01a5b45d1d79$var$isScheduled) {
                $e98e01a5b45d1d79$var$isScheduled = true;
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).read($e98e01a5b45d1d79$var$readAllKeyframes);
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).resolveKeyframes($e98e01a5b45d1d79$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $e98e01a5b45d1d79$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $e98e01a5b45d1d79$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $dcbec077bb7f84f2$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $338f435df31a3d26$export$844ec244b1367d54)(v) && (0, $338f435df31a3d26$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $dcbec077bb7f84f2$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $338f435df31a3d26$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $338f435df31a3d26$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $7eb780a36d447b78$var$clampRgbUnit = (v)=>(0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $7eb780a36d447b78$export$7a99c86b5b1f4c9e = {
    ...(0, $9ad8a8be30ce5844$export$98e628dec113755e),
    transform: (v)=>Math.round($7eb780a36d447b78$var$clampRgbUnit(v))
};
const $7eb780a36d447b78$export$4e46ac54fc82cf3b = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $dcbec077bb7f84f2$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(red) + ", " + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(green) + ", " + $7eb780a36d447b78$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)((0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $033e89ee5ceff2b5$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $033e89ee5ceff2b5$export$834dfc94dde4b3d8 = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("#"),
    parse: $033e89ee5ceff2b5$var$parseHex,
    transform: (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform
};






const $3430a9d7e3ad25df$export$810b04175080204c = {
    test: (0, $dcbec077bb7f84f2$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $dcbec077bb7f84f2$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $d414efec423ce291$export$626336c2cd4b14de).transform((0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $d414efec423ce291$export$626336c2cd4b14de).transform((0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)((0, $9ad8a8be30ce5844$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $4dc0621296be153e$export$35e9368ef982300f = {
    test: (v)=>(0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).test(v) || (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8).test(v) || (0, $3430a9d7e3ad25df$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).test(v)) return (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $3430a9d7e3ad25df$export$810b04175080204c).test(v)) return (0, $3430a9d7e3ad25df$export$810b04175080204c).parse(v);
        else return (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $338f435df31a3d26$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform(v) : (0, $3430a9d7e3ad25df$export$810b04175080204c).transform(v);
    }
};



function $7c24e3fb3ccfb2d4$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $338f435df31a3d26$export$844ec244b1367d54)(v) && (((_a = v.match((0, $338f435df31a3d26$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $338f435df31a3d26$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $7c24e3fb3ccfb2d4$var$NUMBER_TOKEN = "number";
const $7c24e3fb3ccfb2d4$var$COLOR_TOKEN = "color";
const $7c24e3fb3ccfb2d4$var$VAR_TOKEN = "var";
const $7c24e3fb3ccfb2d4$var$VAR_FUNCTION_TOKEN = "var(";
const $7c24e3fb3ccfb2d4$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $7c24e3fb3ccfb2d4$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($7c24e3fb3ccfb2d4$var$complexRegex, (parsedValue)=>{
        if ((0, $4dc0621296be153e$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($7c24e3fb3ccfb2d4$var$COLOR_TOKEN);
            values.push((0, $4dc0621296be153e$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($7c24e3fb3ccfb2d4$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($7c24e3fb3ccfb2d4$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($7c24e3fb3ccfb2d4$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $7c24e3fb3ccfb2d4$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($7c24e3fb3ccfb2d4$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $7c24e3fb3ccfb2d4$var$parseComplexValue(v) {
    return $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(v).values;
}
function $7c24e3fb3ccfb2d4$var$createTransformer(source) {
    const { split: split, types: types } = $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $7c24e3fb3ccfb2d4$var$NUMBER_TOKEN) output += (0, $338f435df31a3d26$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $7c24e3fb3ccfb2d4$var$COLOR_TOKEN) output += (0, $4dc0621296be153e$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $7c24e3fb3ccfb2d4$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $7c24e3fb3ccfb2d4$var$getAnimatableNone(v) {
    const parsed = $7c24e3fb3ccfb2d4$var$parseComplexValue(v);
    const transformer = $7c24e3fb3ccfb2d4$var$createTransformer(v);
    return transformer(parsed.map($7c24e3fb3ccfb2d4$var$convertNumbersToZero));
}
const $7c24e3fb3ccfb2d4$export$83a0e34f1302825b = {
    test: $7c24e3fb3ccfb2d4$var$test,
    parse: $7c24e3fb3ccfb2d4$var$parseComplexValue,
    createTransformer: $7c24e3fb3ccfb2d4$var$createTransformer,
    getAnimatableNone: $7c24e3fb3ccfb2d4$var$getAnimatableNone
};




/**
 * Properties that should default to 1 or 100%
 */ const $f5689d8b8e6d59f7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $f5689d8b8e6d59f7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $338f435df31a3d26$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $f5689d8b8e6d59f7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $f5689d8b8e6d59f7$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $f5689d8b8e6d59f7$export$3dea766d36a8935f = {
    ...(0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($f5689d8b8e6d59f7$var$functionRegex);
        return functions ? functions.map($f5689d8b8e6d59f7$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $0b53a6efb3642986$export$98cd7c72c5a731fb = {
    ...(0, $5cd21c5d2c5b7cec$export$eec14432cd1cb67b),
    color: // Color props
    $4dc0621296be153e$export$35e9368ef982300f,
    backgroundColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    outlineColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    fill: (0, $4dc0621296be153e$export$35e9368ef982300f),
    stroke: (0, $4dc0621296be153e$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderTopColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderRightColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderBottomColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    borderLeftColor: (0, $4dc0621296be153e$export$35e9368ef982300f),
    filter: $f5689d8b8e6d59f7$export$3dea766d36a8935f,
    WebkitFilter: (0, $f5689d8b8e6d59f7$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $0b53a6efb3642986$export$67d1babe0338d23b = (key)=>$0b53a6efb3642986$export$98cd7c72c5a731fb[key];


function $52c5d0266b29e428$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $f5689d8b8e6d59f7$export$3dea766d36a8935f)) defaultValueType = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ function $7442785ee58dd8e5$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        if (typeof unresolvedKeyframes[i] === "string" && unresolvedKeyframes[i] !== "none" && unresolvedKeyframes[i] !== "0") animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $52c5d0266b29e428$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $022c4da44fe7fb65$export$4983792d11b61017 extends (0, $e98e01a5b45d1d79$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            const keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string" && (0, $58159485ea5b9511$export$31f9caa2600b5723)(keyframe)) {
                const resolved = (0, $17d46babbc343972$export$289398774300c991)(keyframe, element.current);
                if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
            }
        }
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $c124c5f5f2629442$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return this.resolveNoneKeyframes();
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $f2ef0e515384c134$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $c124c5f5f2629442$export$8e5250d1aa9bf370)(originType) && (0, $c124c5f5f2629442$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $63ed2da846c28a44$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $7442785ee58dd8e5$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $c124c5f5f2629442$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $c124c5f5f2629442$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $03368a0fa40656d3$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $3371f0ca4fc89c46$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $47dd55ced5b0b9f6$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $47dd55ced5b0b9f6$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $3371f0ca4fc89c46$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $3371f0ca4fc89c46$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $faee95b32f04793f$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $47dd55ced5b0b9f6$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



class $fd6f4404fe16a3b6$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved) (0, $e98e01a5b45d1d79$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $47dd55ced5b0b9f6$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $8fa4692997fef09a$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $71f528837f15cf2e$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $fc31a30583b4fe53$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $ffa64122c9b9a90f$var$velocitySampleDuration = 5; // ms
function $ffa64122c9b9a90f$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $ffa64122c9b9a90f$var$velocitySampleDuration, 0);
    return (0, $fc31a30583b4fe53$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $cab5cc8e79bc5280$var$safeMin = 0.001;
const $cab5cc8e79bc5280$export$a3cdb76e84ee608e = 0.01;
const $cab5cc8e79bc5280$export$1824b851fad8862b = 10.0;
const $cab5cc8e79bc5280$export$ff08f2d53484465 = 0.05;
const $cab5cc8e79bc5280$export$201ca48e54038115 = 1;
function $cab5cc8e79bc5280$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $faee95b32f04793f$export$491112666e282270)(duration <= (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)($cab5cc8e79bc5280$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)($cab5cc8e79bc5280$export$ff08f2d53484465, $cab5cc8e79bc5280$export$201ca48e54038115, dampingRatio);
    duration = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)($cab5cc8e79bc5280$export$a3cdb76e84ee608e, $cab5cc8e79bc5280$export$1824b851fad8862b, (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cab5cc8e79bc5280$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cab5cc8e79bc5280$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cab5cc8e79bc5280$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cab5cc8e79bc5280$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cab5cc8e79bc5280$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cab5cc8e79bc5280$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cab5cc8e79bc5280$var$rootIterations = 12;
function $cab5cc8e79bc5280$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cab5cc8e79bc5280$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $cab5cc8e79bc5280$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $d0316fb58456992f$var$durationKeys = [
    "duration",
    "bounce"
];
const $d0316fb58456992f$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $d0316fb58456992f$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $d0316fb58456992f$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$d0316fb58456992f$var$isSpringType(options, $d0316fb58456992f$var$physicsKeys) && $d0316fb58456992f$var$isSpringType(options, $d0316fb58456992f$var$durationKeys)) {
        const derived = (0, $cab5cc8e79bc5280$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $d0316fb58456992f$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $d0316fb58456992f$var$getSpringOptions({
        ...options,
        velocity: -(0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $cab5cc8e79bc5280$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $ffa64122c9b9a90f$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $2ec82feee7e066a4$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $d0316fb58456992f$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $ffa64122c9b9a90f$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b68ec7dd50aa8255$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b68ec7dd50aa8255$var$subdivisionPrecision = 0.0000001;
const $b68ec7dd50aa8255$var$subdivisionMaxIterations = 12;
function $b68ec7dd50aa8255$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b68ec7dd50aa8255$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b68ec7dd50aa8255$var$subdivisionPrecision && ++i < $b68ec7dd50aa8255$var$subdivisionMaxIterations);
    return currentT;
}
function $b68ec7dd50aa8255$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $dcf17e8536d5fb4f$export$8793edee2d425525;
    const getTForX = (aX)=>$b68ec7dd50aa8255$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b68ec7dd50aa8255$var$calcBezier(getTForX(t), mY1, mY2);
}


const $4b2d8ea621676e4a$export$929e5a82286172a6 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $4b2d8ea621676e4a$export$57636bb43b1ccbb0 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $4b2d8ea621676e4a$export$c07234257a03d5e9 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $7d2532405ded3ea5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $69035d8d09bc295c$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $819cd53771ed6265$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $d6fb562c03554c29$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $d6fb562c03554c29$export$c8d67a19199d1a50 = (0, $819cd53771ed6265$export$2c07eeff45156d4d)($d6fb562c03554c29$export$e444123e42d03385);
const $d6fb562c03554c29$export$30d3455eee55bed5 = (0, $69035d8d09bc295c$export$f946554fb8aeaf0d)($d6fb562c03554c29$export$e444123e42d03385);





const $2ffe3caa5694044a$export$77edfce482316a60 = (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $2ffe3caa5694044a$export$b01116c84cdfe1a2 = (0, $819cd53771ed6265$export$2c07eeff45156d4d)($2ffe3caa5694044a$export$77edfce482316a60);
const $2ffe3caa5694044a$export$ddc5fd596f6c71b2 = (0, $69035d8d09bc295c$export$f946554fb8aeaf0d)($2ffe3caa5694044a$export$b01116c84cdfe1a2);



const $b671f13caff3e8c0$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $2ffe3caa5694044a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $a4ee59a17d946ff8$var$easingLookup = {
    linear: (0, $dcf17e8536d5fb4f$export$8793edee2d425525),
    easeIn: $4b2d8ea621676e4a$export$929e5a82286172a6,
    easeInOut: $4b2d8ea621676e4a$export$c07234257a03d5e9,
    easeOut: $4b2d8ea621676e4a$export$57636bb43b1ccbb0,
    circIn: $d6fb562c03554c29$export$e444123e42d03385,
    circInOut: $d6fb562c03554c29$export$30d3455eee55bed5,
    circOut: $d6fb562c03554c29$export$c8d67a19199d1a50,
    backIn: $2ffe3caa5694044a$export$b01116c84cdfe1a2,
    backInOut: $2ffe3caa5694044a$export$ddc5fd596f6c71b2,
    backOut: $2ffe3caa5694044a$export$77edfce482316a60,
    anticipate: $b671f13caff3e8c0$export$6b0af63b873d419e
};
const $a4ee59a17d946ff8$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $faee95b32f04793f$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $b68ec7dd50aa8255$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $faee95b32f04793f$export$f5708dca728d7177)($a4ee59a17d946ff8$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $a4ee59a17d946ff8$var$easingLookup[definition];
    }
    return definition;
};





/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $2ee7103c100c6f99$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $6d40377c43cb841e$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $6d40377c43cb841e$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $6d40377c43cb841e$var$hueToRgb(p, q, hue + 1 / 3);
        green = $6d40377c43cb841e$var$hueToRgb(p, q, hue);
        blue = $6d40377c43cb841e$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $6f56b7a85018a9a1$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $6f56b7a85018a9a1$var$colorTypes = [
    (0, $033e89ee5ceff2b5$export$834dfc94dde4b3d8),
    (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b),
    (0, $3430a9d7e3ad25df$export$810b04175080204c)
];
const $6f56b7a85018a9a1$var$getColorType = (v)=>$6f56b7a85018a9a1$var$colorTypes.find((type)=>type.test(v));
function $6f56b7a85018a9a1$var$asRGBA(color) {
    const type = $6f56b7a85018a9a1$var$getColorType(color);
    (0, $faee95b32f04793f$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $3430a9d7e3ad25df$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $6d40377c43cb841e$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $6f56b7a85018a9a1$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $6f56b7a85018a9a1$var$asRGBA(from);
    const toRGBA = $6f56b7a85018a9a1$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $6f56b7a85018a9a1$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $6f56b7a85018a9a1$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $6f56b7a85018a9a1$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $7eb780a36d447b78$export$4e46ac54fc82cf3b).transform(blended);
    };
};







function $10bd68e67488b260$var$mixImmediate(a, b) {
    return (p)=>p > 0 ? b : a;
}
function $10bd68e67488b260$var$mixNumber(a, b) {
    return (p)=>(0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $10bd68e67488b260$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $10bd68e67488b260$var$mixNumber;
    else if (typeof a === "string") return (0, $58159485ea5b9511$export$31f9caa2600b5723)(a) ? $10bd68e67488b260$var$mixImmediate : (0, $4dc0621296be153e$export$35e9368ef982300f).test(a) ? (0, $6f56b7a85018a9a1$export$51e568cf5c039bac) : $10bd68e67488b260$export$65516310a87d8205;
    else if (Array.isArray(a)) return $10bd68e67488b260$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $4dc0621296be153e$export$35e9368ef982300f).test(a) ? (0, $6f56b7a85018a9a1$export$51e568cf5c039bac) : $10bd68e67488b260$export$ebc23b6840c51ba1;
    return $10bd68e67488b260$var$mixImmediate;
}
function $10bd68e67488b260$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$10bd68e67488b260$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $10bd68e67488b260$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $10bd68e67488b260$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $10bd68e67488b260$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $10bd68e67488b260$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $7c24e3fb3ccfb2d4$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) return (0, $81c10aac384f5ba3$export$a4627e546088548d)($10bd68e67488b260$export$3bbefa2f402845c4($10bd68e67488b260$var$matchOrder(originStats, targetStats), targetStats.values), template);
    else {
        (0, $faee95b32f04793f$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $10bd68e67488b260$var$mixImmediate(origin, target);
    }
};



function $51baf253a5779be7$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $10bd68e67488b260$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $cd3a4e99a88f1222$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $51baf253a5779be7$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $dcf17e8536d5fb4f$export$8793edee2d425525) : ease;
            mixer = (0, $81c10aac384f5ba3$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $cd3a4e99a88f1222$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $faee95b32f04793f$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $cd3a4e99a88f1222$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $efee312df0ae1acd$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $009cfdc0ed035ef1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $efee312df0ae1acd$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $0f38857b669e010e$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $712034bcad0bd3f0$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $4b2d8ea621676e4a$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $712034bcad0bd3f0$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $7d2532405ded3ea5$export$216948827bbdc797)(ease) ? ease.map((0, $a4ee59a17d946ff8$export$ef97fe084f156ca4)) : (0, $a4ee59a17d946ff8$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $0f38857b669e010e$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $009cfdc0ed035ef1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $cd3a4e99a88f1222$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $712034bcad0bd3f0$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3d7ae8dd746b979b$export$f4ff70a5b4808fd8 = 20000;
function $3d7ae8dd746b979b$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $3d7ae8dd746b979b$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $3d7ae8dd746b979b$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $e9fbb24340aa08f3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing ? (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp : (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now()
    };
};



const $dac169d1ce979e3d$var$generators = {
    decay: (0, $2ec82feee7e066a4$export$ee3ff3a17106998),
    inertia: $2ec82feee7e066a4$export$ee3ff3a17106998,
    tween: (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e),
    keyframes: (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e),
    spring: $d0316fb58456992f$export$b36281d89752ae66
};
const $dac169d1ce979e3d$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $dac169d1ce979e3d$export$fd98d9cca67a58bc extends (0, $fd6f4404fe16a3b6$export$d1e4f34b9c2550c1) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $e98e01a5b45d1d79$export$74d34ca3182f1750), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $dac169d1ce979e3d$var$generators[type] || (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $712034bcad0bd3f0$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $81c10aac384f5ba3$export$a4627e546088548d)($dac169d1ce979e3d$var$percentToProgress, (0, $51baf253a5779be7$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $3d7ae8dd746b979b$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $71f528837f15cf2e$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $e9fbb24340aa08f3$export$c1033964b5ad7fef), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.teardown();
        const { onStop: onStop } = this.options;
        onStop && onStop();
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $dac169d1ce979e3d$export$ee9b76de7353d815(options) {
    return new $dac169d1ce979e3d$export$fd98d9cca67a58bc(options);
}


const $ccf562d41de2cfd9$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $098e26d9afc788ba$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $098e26d9afc788ba$export$2cf569f5e2221176[easing] || (0, $ccf562d41de2cfd9$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($098e26d9afc788ba$export$fcdd8f3f2160beda));
}
const $098e26d9afc788ba$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $098e26d9afc788ba$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $098e26d9afc788ba$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $098e26d9afc788ba$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $ccf562d41de2cfd9$export$ff43f99925d7366b)(easing) ? $098e26d9afc788ba$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($098e26d9afc788ba$export$916ea73bcd3a6030) : $098e26d9afc788ba$export$2cf569f5e2221176[easing];
}


function $e6d1c43098e794ae$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $098e26d9afc788ba$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $fedae75f86c56197$var$supportsWaapi = (0, $03368a0fa40656d3$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $fedae75f86c56197$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $fedae75f86c56197$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $fedae75f86c56197$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $fedae75f86c56197$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || options.name === "backgroundColor" || !(0, $098e26d9afc788ba$export$fcdd8f3f2160beda)(options.ease);
}
function $fedae75f86c56197$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $dac169d1ce979e3d$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $fedae75f86c56197$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $fedae75f86c56197$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $fedae75f86c56197$var$sampleDelta,
        ease: "linear"
    };
}
class $fedae75f86c56197$export$2a45abb4e6513325 extends (0, $fd6f4404fe16a3b6$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $022c4da44fe7fb65$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($fedae75f86c56197$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $fedae75f86c56197$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            duration = pregeneratedAnimation.duration;
            this.options.times = pregeneratedAnimation.times;
            this.options.ease = pregeneratedAnimation.ease;
        }
        const animation = (0, $e6d1c43098e794ae$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $71f528837f15cf2e$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $dcf17e8536d5fb4f$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $dcf17e8536d5fb4f$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $dac169d1ce979e3d$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes
            });
            const sampleTime = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $fedae75f86c56197$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $fedae75f86c56197$var$sampleDelta);
        }
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $fedae75f86c56197$var$supportsWaapi() && name && $fedae75f86c56197$var$acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}



const $9672f3cc4d35c47f$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $6dd602398ed69a9c$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $6dd602398ed69a9c$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $f3507eb24a522f61$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $8fa4692997fef09a$export$888a3d84909f9e3d).current || (0, $141b563636682491$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $71f528837f15cf2e$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $fedae75f86c56197$export$2a45abb4e6513325).supports(options)) return new (0, $fedae75f86c56197$export$2a45abb4e6513325)(options);
        else return new (0, $dac169d1ce979e3d$export$fd98d9cca67a58bc)(options);
    };



function $58059ad17277dd8f$export$98397f3adbf6259f(value) {
    return Boolean((0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) && value.add);
}



function $c96f8df7c05c7795$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $c96f8df7c05c7795$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $c96f8df7c05c7795$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $4f660a66e171c06b$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $79d69d565640708f$var$MAX_VELOCITY_DELTA = 30;
const $79d69d565640708f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $79d69d565640708f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $79d69d565640708f$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.0.20";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.canTrackVelocity = $79d69d565640708f$var$isFloat(this.current);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($79d69d565640708f$export$67fcd818a264039d.current) $79d69d565640708f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $79d69d565640708f$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $79d69d565640708f$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $fc31a30583b4fe53$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $79d69d565640708f$export$ce8bdc721e76545f(init, options) {
    return new $79d69d565640708f$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $284183dc41cada08$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(value));
}
function $284183dc41cada08$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $4d89fd6dc8b0f394$export$5485128c47bd48bb)(target[key]);
        $284183dc41cada08$var$setMotionValue(visualElement, key, value);
    }
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cc3ad3de4cb35171$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cc3ad3de4cb35171$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cc3ad3de4cb35171$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $6dd602398ed69a9c$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $acf7e02863b7c6a2$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key);
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) {
                willChange.add(key);
                animation.then(()=>willChange.remove(key));
            }
            animations.push(animation);
        }
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $284183dc41cada08$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $76b8fd27e9a24a2a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cc3ad3de4cb35171$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $76b8fd27e9a24a2a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $76b8fd27e9a24a2a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($76b8fd27e9a24a2a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($76b8fd27e9a24a2a$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $76b8fd27e9a24a2a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}



function $25633fa26ef1b230$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $76b8fd27e9a24a2a$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $76b8fd27e9a24a2a$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cc3ad3de4cb35171$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}


const $dd83ae5ab182dd8d$var$reversePriorityOrder = [
    ...(0, $20855a5d0b260125$export$16e45afcc206d3a8)
].reverse();
const $dd83ae5ab182dd8d$var$numAnimationTypes = (0, $20855a5d0b260125$export$16e45afcc206d3a8).length;
function $dd83ae5ab182dd8d$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $25633fa26ef1b230$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $dd83ae5ab182dd8d$export$bb53502b7a672aa8(visualElement) {
    let animate = $dd83ae5ab182dd8d$var$animateList(visualElement);
    const state = $dd83ae5ab182dd8d$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $09bc9ca971307c1d$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $dd83ae5ab182dd8d$var$numAnimationTypes; i++){
            const type = $dd83ae5ab182dd8d$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $23e2b8e45e65dfac$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $dd83ae5ab182dd8d$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(next) && (0, $cdfb45bee9c27be9$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b72ed983341c6484$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                fallbackAnimation[key] = fallbackTarget === undefined ? null : fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $dd83ae5ab182dd8d$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b72ed983341c6484$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $dd83ae5ab182dd8d$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $dd83ae5ab182dd8d$var$createState() {
    return {
        animate: $dd83ae5ab182dd8d$var$createTypeState(true),
        whileInView: $dd83ae5ab182dd8d$var$createTypeState(),
        whileHover: $dd83ae5ab182dd8d$var$createTypeState(),
        whileTap: $dd83ae5ab182dd8d$var$createTypeState(),
        whileDrag: $dd83ae5ab182dd8d$var$createTypeState(),
        whileFocus: $dd83ae5ab182dd8d$var$createTypeState(),
        exit: $dd83ae5ab182dd8d$var$createTypeState()
    };
}



class $c25a4516189cca97$export$b45b3fe5caabdca extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $dd83ae5ab182dd8d$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $cba7aa384b255de7$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $056087ff4c0a12f5$var$id = 0;
class $056087ff4c0a12f5$export$4989d1eb6104cc6c extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $056087ff4c0a12f5$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $1a6859e1b2177404$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $c25a4516189cca97$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $056087ff4c0a12f5$export$4989d1eb6104cc6c)
    }
};









const $ca59ff59f5b9b641$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $ca59ff59f5b9b641$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $ca59ff59f5b9b641$export$9f17032d917177de(a.x, b.x);
    const yDelta = $ca59ff59f5b9b641$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $0edc1aba4122b85c$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $0edc1aba4122b85c$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $ca59ff59f5b9b641$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $abdd74f2cc691999$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $0edc1aba4122b85c$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $e686dca3072f0847$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $230784ee47833b0a$export$12f84bb882d06e1a)(event);
        const initialInfo = $0edc1aba4122b85c$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $abdd74f2cc691999$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $0edc1aba4122b85c$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $81c10aac384f5ba3$export$a4627e546088548d)((0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $0edc1aba4122b85c$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $0edc1aba4122b85c$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $0edc1aba4122b85c$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $0edc1aba4122b85c$var$subtractPoint(point, $0edc1aba4122b85c$var$lastDevicePoint(history)),
        offset: $0edc1aba4122b85c$var$subtractPoint(point, $0edc1aba4122b85c$var$startDevicePoint(history)),
        velocity: $0edc1aba4122b85c$var$getVelocity(history, 0.1)
    };
}
function $0edc1aba4122b85c$var$startDevicePoint(history) {
    return history[0];
}
function $0edc1aba4122b85c$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $0edc1aba4122b85c$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $0edc1aba4122b85c$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $a9e2d00978e30fa4$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $a9e2d00978e30fa4$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $981dbb7bd35e3220$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $981dbb7bd35e3220$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $981dbb7bd35e3220$export$c1c127004b72a37(target) / $981dbb7bd35e3220$export$c1c127004b72a37(source);
    if ($981dbb7bd35e3220$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($981dbb7bd35e3220$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $981dbb7bd35e3220$export$c0d25e96fc67d310(delta, source, target, origin) {
    $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $981dbb7bd35e3220$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $981dbb7bd35e3220$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $981dbb7bd35e3220$export$c1c127004b72a37(relative);
}
function $981dbb7bd35e3220$export$426154f9d100f99(target, relative, parent) {
    $981dbb7bd35e3220$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $981dbb7bd35e3220$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $981dbb7bd35e3220$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $981dbb7bd35e3220$export$c1c127004b72a37(layout);
}
function $981dbb7bd35e3220$export$2785bfcc929c5650(target, layout, parent) {
    $981dbb7bd35e3220$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $981dbb7bd35e3220$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $feceabd437ab568a$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $feceabd437ab568a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $feceabd437ab568a$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $feceabd437ab568a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $feceabd437ab568a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $feceabd437ab568a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $feceabd437ab568a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $feceabd437ab568a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $feceabd437ab568a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $feceabd437ab568a$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(source);
    const targetLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $feceabd437ab568a$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $feceabd437ab568a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $feceabd437ab568a$export$7c5eaef8f4723d22(dragElastic = $feceabd437ab568a$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $feceabd437ab568a$export$a3366d3bac43a742;
    return {
        x: $feceabd437ab568a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $feceabd437ab568a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $feceabd437ab568a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $feceabd437ab568a$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $130a04a50c584572$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $130a04a50c584572$export$3d227df54007d73a = ()=>({
        x: $130a04a50c584572$export$ff25708b37f72782(),
        y: $130a04a50c584572$export$ff25708b37f72782()
    });
const $130a04a50c584572$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $130a04a50c584572$export$6459fc9e86be362e = ()=>({
        x: $130a04a50c584572$export$6db76765312617ac(),
        y: $130a04a50c584572$export$6db76765312617ac()
    });


function $561ecab7bc487cb5$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $6113e12a67eb6306$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $6113e12a67eb6306$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $6113e12a67eb6306$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $245b5e64e7ae0d35$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $245b5e64e7ae0d35$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$245b5e64e7ae0d35$var$isIdentityScale(scale) || !$245b5e64e7ae0d35$var$isIdentityScale(scaleX) || !$245b5e64e7ae0d35$var$isIdentityScale(scaleY);
}
function $245b5e64e7ae0d35$export$a545127cf1fbb600(values) {
    return $245b5e64e7ae0d35$export$bdf30dca883ea463(values) || $245b5e64e7ae0d35$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $245b5e64e7ae0d35$export$bf80f5f8f4dc327f(values) {
    return $245b5e64e7ae0d35$var$is2DTranslate(values.x) || $245b5e64e7ae0d35$var$is2DTranslate(values.y);
}
function $245b5e64e7ae0d35$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d7183edf0eab2b8a$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d7183edf0eab2b8a$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d7183edf0eab2b8a$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d7183edf0eab2b8a$export$d80074982803af5c(box, { x: x, y: y }) {
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d7183edf0eab2b8a$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d7183edf0eab2b8a$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d7183edf0eab2b8a$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) $d7183edf0eab2b8a$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d7183edf0eab2b8a$var$snapToDefault(treeScale.x);
    treeScale.y = $d7183edf0eab2b8a$var$snapToDefault(treeScale.y);
}
function $d7183edf0eab2b8a$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d7183edf0eab2b8a$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d7183edf0eab2b8a$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d7183edf0eab2b8a$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d7183edf0eab2b8a$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d7183edf0eab2b8a$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d7183edf0eab2b8a$export$58b16271041fbfb(box, transform) {
    $d7183edf0eab2b8a$export$625f1dd140a2f5e7(box.x, transform, $d7183edf0eab2b8a$var$xKeys);
    $d7183edf0eab2b8a$export$625f1dd140a2f5e7(box.y, transform, $d7183edf0eab2b8a$var$yKeys);
}


function $251bbb6a3c87ae07$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $6113e12a67eb6306$export$d3955c6a8f65a36b)((0, $6113e12a67eb6306$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $251bbb6a3c87ae07$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $251bbb6a3c87ae07$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $ac41a0567f61a1d6$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};


const $af92ecd6ba1f7e78$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $af92ecd6ba1f7e78$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $130a04a50c584572$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $230784ee47833b0a$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $6b9c534ca65d1916$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) onDragStart(event, info);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $af92ecd6ba1f7e78$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $0edc1aba4122b85c$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $ac41a0567f61a1d6$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) onDragEnd(event, info);
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $feceabd437ab568a$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $feceabd437ab568a$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $feceabd437ab568a$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $feceabd437ab568a$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $faee95b32f04793f$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $251bbb6a3c87ae07$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $feceabd437ab568a$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $6113e12a67eb6306$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $6113e12a67eb6306$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement));
    }
    stopAnimation() {
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $feceabd437ab568a$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            if (!$af92ecd6ba1f7e78$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $af92ecd6ba1f7e78$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $3b9e8293424667bf$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $feceabd437ab568a$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $af92ecd6ba1f7e78$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $af92ecd6ba1f7e78$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $d1975e8dea510822$export$5d97dc2872682820 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.removeListeners = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
        this.controls = new (0, $af92ecd6ba1f7e78$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $e22e1dd92051f0a0$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) handler(event, info);
    };
class $e22e1dd92051f0a0$export$b4f8f1ee75ce5859 extends (0, $617d59ae1886b5b2$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $0edc1aba4122b85c$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $ac41a0567f61a1d6$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $e22e1dd92051f0a0$var$asyncHandler(onPanSessionStart),
            onStart: $e22e1dd92051f0a0$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) onPanEnd(event, info);
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $59727fd3e6cd9f0c$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $35c3ca91a4fc3062$export$2a8c16d82a0a0e26() {
    const context = (0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $6cds3.useId)();
    (0, $6cds3.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $35c3ca91a4fc3062$export$8249053f690ea39a() {
    return $35c3ca91a4fc3062$export$ee27c052bca048fb((0, $6cds3.useContext)((0, $e40c1c7ce208ba78$export$f224e4635b6f8ce2)));
}
function $35c3ca91a4fc3062$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $1ba477217000c17f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $f033999f3b94341e$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $f033999f3b94341e$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $d414efec423ce291$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $f033999f3b94341e$export$fafff692be55225d(latest, node.target.x);
        const y = $f033999f3b94341e$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $5fbaf6db683a9111$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





class $bf0011aeb54a8603$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $f4236abcb41ce1af$export$de9e7791c71225fd)($bf0011aeb54a8603$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $1ba477217000c17f$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $e7af5054e8b29038$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $bf0011aeb54a8603$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $35c3ca91a4fc3062$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $6cds3.useContext)((0, $5f7d717553e210fe$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($bf0011aeb54a8603$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $6cds3.useContext)((0, $80cd083093aee758$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $bf0011aeb54a8603$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $f033999f3b94341e$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $f033999f3b94341e$export$5eafb6257a5844c),
    boxShadow: (0, $5fbaf6db683a9111$export$eb0bc629e74dcf8)
};








const $5b730dc57489e238$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $5b730dc57489e238$var$numBorders = $5b730dc57489e238$var$borders.length;
const $5b730dc57489e238$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $5b730dc57489e238$var$isPx = (value)=>typeof value === "number" || (0, $d414efec423ce291$export$91c0eda1d06bf008).test(value);
function $5b730dc57489e238$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $5b730dc57489e238$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $5b730dc57489e238$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $5b730dc57489e238$var$numBorders; i++){
        const borderLabel = `border${$5b730dc57489e238$var$borders[i]}Radius`;
        let followRadius = $5b730dc57489e238$var$getRadius(follow, borderLabel);
        let leadRadius = $5b730dc57489e238$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $5b730dc57489e238$var$isPx(followRadius) === $5b730dc57489e238$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)($5b730dc57489e238$var$asNumber(followRadius), $5b730dc57489e238$var$asNumber(leadRadius), progress), 0);
            if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(leadRadius) || (0, $d414efec423ce291$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $5b730dc57489e238$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $5b730dc57489e238$var$easeCrossfadeIn = $5b730dc57489e238$var$compress(0, 0.5, (0, $d6fb562c03554c29$export$c8d67a19199d1a50));
const $5b730dc57489e238$var$easeCrossfadeOut = $5b730dc57489e238$var$compress(0.5, 0.95, (0, $dcf17e8536d5fb4f$export$8793edee2d425525));
function $5b730dc57489e238$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $6fc1d9b67c5d7cd4$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5f205044d0db3736$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5f205044d0db3736$export$c53fd88f45d77e4b(box, originBox) {
    $5f205044d0db3736$export$a0230ae482601ae8(box.x, originBox.x);
    $5f205044d0db3736$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $7ad777e49fa4a365$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d7183edf0eab2b8a$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d7183edf0eab2b8a$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $7ad777e49fa4a365$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $d414efec423ce291$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $7ad777e49fa4a365$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $7ad777e49fa4a365$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7ad777e49fa4a365$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $7ad777e49fa4a365$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $7ad777e49fa4a365$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $7ad777e49fa4a365$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7ad777e49fa4a365$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $7ad777e49fa4a365$export$42b76f1d0d16d5b(box.x, transforms, $7ad777e49fa4a365$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $7ad777e49fa4a365$export$42b76f1d0d16d5b(box.y, transforms, $7ad777e49fa4a365$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6(delta) {
    return $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta.x) && $9d2bb0d64b3cd7fc$var$isAxisDeltaZero(delta.y);
}
function $9d2bb0d64b3cd7fc$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $9d2bb0d64b3cd7fc$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $9d2bb0d64b3cd7fc$export$c5706146bc63213(box) {
    return (0, $981dbb7bd35e3220$export$c1c127004b72a37)(box.x) / (0, $981dbb7bd35e3220$export$c1c127004b72a37)(box.y);
}



class $1a1417a9e50596e8$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $c7f5fc751b151e12$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $4e9dc7afe657b330$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $d5623a75f1f312b3$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $c96f8df7c05c7795$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $c96f8df7c05c7795$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $4e9dc7afe657b330$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $aaecb8b12257cf1a$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $abdd74f2cc691999$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(checkElapsed);
}



function $f8a34acd939b8b40$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $a45afbf9cac8c0ab$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $cb991438c56936ca$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value : (0, $79d69d565640708f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $9672f3cc4d35c47f$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}







const $172c8329ecf90fdd$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $172c8329ecf90fdd$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $172c8329ecf90fdd$var$animationTarget = 1000;
let $172c8329ecf90fdd$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $172c8329ecf90fdd$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $172c8329ecf90fdd$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $172c8329ecf90fdd$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $172c8329ecf90fdd$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $172c8329ecf90fdd$var$projectionFrameData.totalNodes = $172c8329ecf90fdd$var$projectionFrameData.resolvedTargetDeltas = $172c8329ecf90fdd$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($172c8329ecf90fdd$export$131f2f0cc5fe9609);
                this.nodes.forEach($172c8329ecf90fdd$var$resolveTargetDelta);
                this.nodes.forEach($172c8329ecf90fdd$var$calcProjection);
                this.nodes.forEach($172c8329ecf90fdd$export$c2664f37bc951031);
                (0, $f8a34acd939b8b40$export$e5185e241753e543)($172c8329ecf90fdd$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $d5623a75f1f312b3$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $a45afbf9cac8c0ab$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $aaecb8b12257cf1a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($172c8329ecf90fdd$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $172c8329ecf90fdd$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $9d2bb0d64b3cd7fc$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $6dd602398ed69a9c$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $172c8329ecf90fdd$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($172c8329ecf90fdd$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($172c8329ecf90fdd$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($172c8329ecf90fdd$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ if (window.HandoffCancelAllAnimations) window.HandoffCancelAllAnimations();
            this.nodes.forEach($172c8329ecf90fdd$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($172c8329ecf90fdd$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($172c8329ecf90fdd$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $3e17eaada8a9f521$export$2da9be4cfdb689b1).now();
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).delta = (0, $fa84546edb6e889a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp);
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp = now;
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing = true;
            (0, $abdd74f2cc691999$export$be3f796aed065412).update.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$be3f796aed065412).preRender.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$be3f796aed065412).render.process((0, $abdd74f2cc691999$export$fff89137e9e818ce));
            (0, $abdd74f2cc691999$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $e7af5054e8b29038$export$bb76eed83315504c).read(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($172c8329ecf90fdd$var$clearSnapshot);
            this.sharedNodes.forEach($172c8329ecf90fdd$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $abdd74f2cc691999$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $abdd74f2cc691999$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $172c8329ecf90fdd$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $130a04a50c584572$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d7183edf0eab2b8a$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $245b5e64e7ae0d35$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $7ad777e49fa4a365$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) (0, $7ad777e49fa4a365$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $981dbb7bd35e3220$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d7183edf0eab2b8a$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $172c8329ecf90fdd$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $245b5e64e7ae0d35$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $245b5e64e7ae0d35$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $abdd74f2cc691999$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d7183edf0eab2b8a$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $130a04a50c584572$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $c7f5fc751b151e12$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $172c8329ecf90fdd$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $130a04a50c584572$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($172c8329ecf90fdd$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $172c8329ecf90fdd$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $172c8329ecf90fdd$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $172c8329ecf90fdd$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $9d2bb0d64b3cd7fc$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $5b730dc57489e238$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $abdd74f2cc691999$export$2cef06c20297c17d).update(()=>{
                (0, $1ba477217000c17f$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $cb991438c56936ca$export$335a17c977067b99)(0, $172c8329ecf90fdd$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($172c8329ecf90fdd$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $172c8329ecf90fdd$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $130a04a50c584572$export$6459fc9e86be362e)();
                const xLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5f205044d0db3736$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d7183edf0eab2b8a$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $1a1417a9e50596e8$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $172c8329ecf90fdd$var$transformAxes.length; i++){
                $172c8329ecf90fdd$var$resetDistortingTransform(`rotate${$172c8329ecf90fdd$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $172c8329ecf90fdd$var$resetDistortingTransform(`skew${$172c8329ecf90fdd$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $172c8329ecf90fdd$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $245b5e64e7ae0d35$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $c7f5fc751b151e12$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $f4236abcb41ce1af$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $f4236abcb41ce1af$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $acbc391d093466b3$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($172c8329ecf90fdd$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $172c8329ecf90fdd$var$updateLayout(node) {
    node.updateLayout();
}
function $172c8329ecf90fdd$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($172c8329ecf90fdd$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $561ecab7bc487cb5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $981dbb7bd35e3220$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
        (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $130a04a50c584572$export$3d227df54007d73a)();
        if (isShared) (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $981dbb7bd35e3220$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $9d2bb0d64b3cd7fc$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $130a04a50c584572$export$6459fc9e86be362e)();
                    (0, $981dbb7bd35e3220$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $9d2bb0d64b3cd7fc$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $172c8329ecf90fdd$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $172c8329ecf90fdd$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $172c8329ecf90fdd$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $172c8329ecf90fdd$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $172c8329ecf90fdd$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $172c8329ecf90fdd$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $172c8329ecf90fdd$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $172c8329ecf90fdd$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $172c8329ecf90fdd$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $172c8329ecf90fdd$var$calcProjection(node) {
    node.calcProjection();
}
function $172c8329ecf90fdd$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $172c8329ecf90fdd$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $172c8329ecf90fdd$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $2ee7103c100c6f99$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $172c8329ecf90fdd$export$6ffd3e6ae339a132(output, from, to, p) {
    $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $172c8329ecf90fdd$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $172c8329ecf90fdd$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $172c8329ecf90fdd$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $172c8329ecf90fdd$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $172c8329ecf90fdd$var$roundPoint = $172c8329ecf90fdd$var$userAgentContains("applewebkit/") && !$172c8329ecf90fdd$var$userAgentContains("chrome/") ? Math.round : (0, $dcf17e8536d5fb4f$export$8793edee2d425525);
function $172c8329ecf90fdd$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $172c8329ecf90fdd$var$roundPoint(axis.min);
    axis.max = $172c8329ecf90fdd$var$roundPoint(axis.max);
}
function $172c8329ecf90fdd$var$roundBox(box) {
    $172c8329ecf90fdd$var$roundAxis(box.x);
    $172c8329ecf90fdd$var$roundAxis(box.y);
}
function $172c8329ecf90fdd$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $981dbb7bd35e3220$export$28d0384c4b79bde2)((0, $9d2bb0d64b3cd7fc$export$c5706146bc63213)(snapshot), (0, $9d2bb0d64b3cd7fc$export$c5706146bc63213)(layout), 0.2);
}




const $720cddb211c53192$export$2d029a49a09b6177 = (0, $172c8329ecf90fdd$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $3b9e8293424667bf$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $553ab14d0d1abf3e$export$b91509fcf893b648 = {
    current: undefined
};
const $553ab14d0d1abf3e$export$b61a9eb3dbde8858 = (0, $172c8329ecf90fdd$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$553ab14d0d1abf3e$export$b91509fcf893b648.current) {
            const documentNode = new (0, $720cddb211c53192$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $553ab14d0d1abf3e$export$b91509fcf893b648.current = documentNode;
        }
        return $553ab14d0d1abf3e$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $20334d379c4993a0$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $e22e1dd92051f0a0$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $d1975e8dea510822$export$5d97dc2872682820),
        ProjectionNode: (0, $553ab14d0d1abf3e$export$b61a9eb3dbde8858),
        MeasureLayout: $bf0011aeb54a8603$export$779f5fb01ad751cd
    }
};













// Does this device prefer reduced motion? Returns `null` server-side.
const $3ff2c43741033fcf$export$ff7706047246b98b = {
    current: null
};
const $3ff2c43741033fcf$export$6476d16e2fd2d0db = {
    current: false
};


function $cc01182a0cb35a51$export$ca9f41fb23dded3d() {
    (0, $3ff2c43741033fcf$export$6476d16e2fd2d0db).current = true;
    if (!(0, $5ddea511a1df74b4$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $3ff2c43741033fcf$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $3ff2c43741033fcf$export$ff7706047246b98b).current = false;
}














function $f0581c7b281c0faf$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $79d69d565640708f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $a77b1e6783fc58b3$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $b2f7b57e3e0175ec$var$valueTypes = [
    ...(0, $f2ef0e515384c134$export$d176691c1998a1f5),
    (0, $4dc0621296be153e$export$35e9368ef982300f),
    (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $b2f7b57e3e0175ec$export$950e7e59ea1ffed7 = (v)=>$b2f7b57e3e0175ec$var$valueTypes.find((0, $e73715ad81b54c5b$export$6eae4d0a6a7ca7cd)(v));





const $37894a1df55e8899$var$featureNames = Object.keys((0, $a953b6ada2f72db5$export$65570e08d843624d));
const $37894a1df55e8899$var$numFeatures = $37894a1df55e8899$var$featureNames.length;
const $37894a1df55e8899$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $37894a1df55e8899$var$numVariantProps = (0, $20855a5d0b260125$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $37894a1df55e8899$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $e98e01a5b45d1d79$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $abdd74f2cc691999$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $9b5ea444b3556797$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $9b5ea444b3556797$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $58059ad17277dd8f$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $a77b1e6783fc58b3$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $3ff2c43741033fcf$export$6476d16e2fd2d0db).current) (0, $cc01182a0cb35a51$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $3ff2c43741033fcf$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $a77b1e6783fc58b3$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $abdd74f2cc691999$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $abdd74f2cc691999$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $37894a1df55e8899$var$numFeatures; i++){
            const name = $37894a1df55e8899$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a953b6ada2f72db5$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $1c79ac3705c6b6d1$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $130a04a50c584572$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $37894a1df55e8899$var$propEventHandlers.length; i++){
            const key = $37894a1df55e8899$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $f0581c7b281c0faf$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $37894a1df55e8899$var$numVariantProps; i++){
            const name = (0, $20855a5d0b260125$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $23e2b8e45e65dfac$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $79d69d565640708f$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $586a8c9354c052af$export$65583ed5a868f2d9)(value) || (0, $96f381b193ee6086$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $b2f7b57e3e0175ec$export$950e7e59ea1ffed7)(value) && (0, $7c24e3fb3ccfb2d4$export$83a0e34f1302825b).test(target)) value = (0, $52c5d0266b29e428$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $251f7d673c9c86a3$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a, _b;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_b = (0, $c0f30ec55cd531d9$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom)) === null || _b === void 0 ? void 0 : _b[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $251f7d673c9c86a3$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $4f660a66e171c06b$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $c1bbb76a693c1a23$export$e49735c2a366bdc7 extends (0, $37894a1df55e8899$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $022c4da44fe7fb65$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $359688a01e55b9fb$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $359688a01e55b9fb$export$23fea75b03ac16b3 extends (0, $c1bbb76a693c1a23$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $359688a01e55b9fb$export$3735103072e4a80(instance);
            const value = ((0, $58159485ea5b9511$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $251bbb6a3c87ae07$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $371459a1640f998f$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a95906244a2d7e5e$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $251f7d673c9c86a3$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9bc9ba6c7615124c$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $4ebd0c9a7e192544$export$86bcdffbaf733d84 extends (0, $c1bbb76a693c1a23$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $d1c315412dc4e663$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $0b53a6efb3642986$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $671a4e7e4df97a9a$export$28931db5d57958e5).has(key) ? (0, $3bc74152d744365d$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $130a04a50c584572$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $79ce2b625ef60476$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $85a07f77d14903fc$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $afcd7ecf658716d9$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $7ee347ff6d81ac56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $d2d301fdeaaca8eb$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $13b7dd579aa6d2ca$export$88f3fc2fd3766989)(Component) ? new (0, $4ebd0c9a7e192544$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $359688a01e55b9fb$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $21c81956e95d4088$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $553ab14d0d1abf3e$export$b61a9eb3dbde8858),
        MeasureLayout: $bf0011aeb54a8603$export$779f5fb01ad751cd
    }
};


const $9aca5855743a2e6f$var$preloadedFeatures = {
    ...(0, $1a6859e1b2177404$export$7f9953c70dacfd7f),
    ...(0, $9f80faa8a4e07d80$export$e5b72898e5a201f1),
    ...(0, $20334d379c4993a0$export$d7d5d435647ed5a0),
    ...(0, $21c81956e95d4088$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $9aca5855743a2e6f$export$e25e478948902b8b = /*@__PURE__*/ (0, $31c6675f74aec206$export$a28d6df673050e18)((Component, config)=>(0, $cb5f7861a7a27279$export$732916c0e88175fb)(Component, config, $9aca5855743a2e6f$var$preloadedFeatures, (0, $d2d301fdeaaca8eb$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $9aca5855743a2e6f$export$546614c4a05701f9(key) {
    return (0, $60bdad86d4074aed$export$46b7e4b9dc6110c3)((0, $cb5f7861a7a27279$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $9aca5855743a2e6f$var$preloadedFeatures, (0, $d2d301fdeaaca8eb$export$56ba0183203348f5)));
}


function $3b4e05b540ea4d30$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $3b4e05b540ea4d30$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $3b4e05b540ea4d30$var$passiveTestOptions = {
        get passive () {
            $3b4e05b540ea4d30$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $3b4e05b540ea4d30$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $3b4e05b540ea4d30$var$passiveTestOptions);
}
var $3b4e05b540ea4d30$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $3b4e05b540ea4d30$var$locks = [];
var $3b4e05b540ea4d30$var$documentListenerAdded = false;
var $3b4e05b540ea4d30$var$initialClientY = -1;
var $3b4e05b540ea4d30$var$previousBodyOverflowSetting = void 0;
var $3b4e05b540ea4d30$var$previousBodyPosition = void 0;
var $3b4e05b540ea4d30$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $3b4e05b540ea4d30$var$allowTouchMove = function allowTouchMove(el) {
    return $3b4e05b540ea4d30$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $3b4e05b540ea4d30$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($3b4e05b540ea4d30$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $3b4e05b540ea4d30$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($3b4e05b540ea4d30$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $3b4e05b540ea4d30$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($3b4e05b540ea4d30$var$previousBodyOverflowSetting === undefined) {
        $3b4e05b540ea4d30$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $3b4e05b540ea4d30$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($3b4e05b540ea4d30$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $3b4e05b540ea4d30$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $3b4e05b540ea4d30$var$previousBodyPaddingRight = undefined;
    }
    if ($3b4e05b540ea4d30$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $3b4e05b540ea4d30$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $3b4e05b540ea4d30$var$previousBodyOverflowSetting = undefined;
    }
};
var $3b4e05b540ea4d30$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($3b4e05b540ea4d30$var$previousBodyPosition === undefined) {
            $3b4e05b540ea4d30$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $3b4e05b540ea4d30$var$restorePositionSetting = function restorePositionSetting() {
    if ($3b4e05b540ea4d30$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $3b4e05b540ea4d30$var$previousBodyPosition.position;
        document.body.style.top = $3b4e05b540ea4d30$var$previousBodyPosition.top;
        document.body.style.left = $3b4e05b540ea4d30$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $3b4e05b540ea4d30$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $3b4e05b540ea4d30$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $3b4e05b540ea4d30$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $3b4e05b540ea4d30$var$initialClientY;
    if ($3b4e05b540ea4d30$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $3b4e05b540ea4d30$var$preventDefault(event);
    if ($3b4e05b540ea4d30$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $3b4e05b540ea4d30$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $3b4e05b540ea4d30$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($3b4e05b540ea4d30$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $3b4e05b540ea4d30$var$locks = [].concat($3b4e05b540ea4d30$var$_toConsumableArray($3b4e05b540ea4d30$var$locks), [
        lock
    ]);
    if ($3b4e05b540ea4d30$var$isIosDevice) $3b4e05b540ea4d30$var$setPositionFixed();
    else $3b4e05b540ea4d30$var$setOverflowHidden(options);
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3b4e05b540ea4d30$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3b4e05b540ea4d30$var$handleScroll(event, targetElement);
        };
        if (!$3b4e05b540ea4d30$var$documentListenerAdded) {
            document.addEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = true;
        }
    }
};
var $3b4e05b540ea4d30$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $3b4e05b540ea4d30$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($3b4e05b540ea4d30$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $3b4e05b540ea4d30$var$initialClientY = -1;
    }
    if ($3b4e05b540ea4d30$var$isIosDevice) $3b4e05b540ea4d30$var$restorePositionSetting();
    else $3b4e05b540ea4d30$var$restoreOverflowSetting();
    $3b4e05b540ea4d30$var$locks = [];
};
var $3b4e05b540ea4d30$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $3b4e05b540ea4d30$var$locks = $3b4e05b540ea4d30$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($3b4e05b540ea4d30$var$documentListenerAdded && $3b4e05b540ea4d30$var$locks.length === 0) {
            document.removeEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = false;
        }
    }
    if ($3b4e05b540ea4d30$var$isIosDevice) $3b4e05b540ea4d30$var$restorePositionSetting();
    else $3b4e05b540ea4d30$var$restoreOverflowSetting();
};


/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");

/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
const $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
const $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            let indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $96b280a33643b696$var$decodePath(pathname);
        matches = $96b280a33643b696$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $96b280a33643b696$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $96b280a33643b696$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $96b280a33643b696$var$paramRe = /^:[\w-]+$/;
const $96b280a33643b696$var$dynamicSegmentValue = 3;
const $96b280a33643b696$var$indexRouteValue = 2;
const $96b280a33643b696$var$emptySegmentValue = 1;
const $96b280a33643b696$var$staticSegmentValue = 10;
const $96b280a33643b696$var$splatPenalty = -2;
const $96b280a33643b696$var$isSplat = (s)=>s === "*";
function $96b280a33643b696$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter((s)=>!$96b280a33643b696$var$isSplat(s)).reduce((score, segment)=>score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue), initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $96b280a33643b696$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $96b280a33643b696$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $96b280a33643b696$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $96b280a33643b696$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $96b280a33643b696$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $96b280a33643b696$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $96b280a33643b696$export$42a99a7a4bc0e76a extends Error {
}
class $96b280a33643b696$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $96b280a33643b696$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $96b280a33643b696$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $96b280a33643b696$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
const $96b280a33643b696$var$validRequestMethodsArr = [
    "get",
    ...$96b280a33643b696$var$validMutationMethodsArr
];
const $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
const $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $96b280a33643b696$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $96b280a33643b696$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $96b280a33643b696$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $96b280a33643b696$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$96b280a33643b696$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $96b280a33643b696$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $96b280a33643b696$var$findNearestBoundary(matches).route.id,
            {
                type: $96b280a33643b696$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $96b280a33643b696$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $96b280a33643b696$var$_extends({
            matches: matches
        }, $96b280a33643b696$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $96b280a33643b696$var$ResultType.error,
            error: $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $96b280a33643b696$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $96b280a33643b696$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $96b280a33643b696$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$96b280a33643b696$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($96b280a33643b696$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $96b280a33643b696$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $96b280a33643b696$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($96b280a33643b696$var$isRedirectResult(actionResult) || $96b280a33643b696$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $96b280a33643b696$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($96b280a33643b696$var$isDeferredResult(result)) result = await $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($96b280a33643b696$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $96b280a33643b696$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $96b280a33643b696$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $96b280a33643b696$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $96b280a33643b696$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($96b280a33643b696$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $96b280a33643b696$var$ResultType.redirect,
                        response: $96b280a33643b696$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $96b280a33643b696$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $96b280a33643b696$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $96b280a33643b696$var$ResultType.error,
                    error: $96b280a33643b696$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$96b280a33643b696$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $96b280a33643b696$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $96b280a33643b696$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $96b280a33643b696$var$isResponse(result) ? result : $96b280a33643b696$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($96b280a33643b696$var$isHandlerResult(e) && $96b280a33643b696$var$isResponse(e.result)) {
                if (e.type === $96b280a33643b696$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($96b280a33643b696$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($96b280a33643b696$var$isDeferredResult(result)) {
            let error = $96b280a33643b696$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $96b280a33643b696$var$_extends({}, context, {
                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $96b280a33643b696$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $96b280a33643b696$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $96b280a33643b696$var$callDataStrategyImpl(unstable_dataStrategy || $96b280a33643b696$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($96b280a33643b696$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $96b280a33643b696$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($96b280a33643b696$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $96b280a33643b696$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    let newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: $96b280a33643b696$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $96b280a33643b696$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $96b280a33643b696$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $96b280a33643b696$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $96b280a33643b696$var$ResultType.data,
                    result: undefined
                });
            };
            return $96b280a33643b696$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$96b280a33643b696$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $96b280a33643b696$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $96b280a33643b696$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $96b280a33643b696$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $96b280a33643b696$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $96b280a33643b696$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $96b280a33643b696$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($96b280a33643b696$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $96b280a33643b696$var$ResultType.error,
                error: e
            };
        }
        if (type === $96b280a33643b696$var$ResultType.error) return {
            type: $96b280a33643b696$var$ResultType.error,
            error: new $96b280a33643b696$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $96b280a33643b696$var$ResultType.error) return {
        type: $96b280a33643b696$var$ResultType.error,
        error: result,
        statusCode: $96b280a33643b696$export$972111febbeef05b(result) ? result.status : status
    };
    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $96b280a33643b696$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $96b280a33643b696$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $96b280a33643b696$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $96b280a33643b696$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($96b280a33643b696$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $96b280a33643b696$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $96b280a33643b696$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $96b280a33643b696$var$ResultType.data || result.type === $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isRedirectHandlerResult(result) {
    return $96b280a33643b696$var$isResponse(result.result) && $96b280a33643b696$var$redirectStatusCodes.has(result.result.status);
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
async function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $96b280a33643b696$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $96b280a33643b696$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $96b280a33643b696$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $96b280a33643b696$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");

function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    let outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: parentMatches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    let error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    let message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
class $4a3e215446c0ed92$var$RenderErrorBoundary extends $6cds3.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4a3e215446c0ed92$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4a3e215446c0ed92$var$DataRouterHook || {});
var $4a3e215446c0ed92$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4a3e215446c0ed92$var$DataRouterStateHook || {});
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    let route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    let route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    let dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return $6cds3.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches);
    return $6cds3.useMemo(()=>matches.map((m)=>(0, $96b280a33643b696$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6cds3.useState("");
    let blockerFunction = $6cds3.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(()=>{
        let key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    let { router: router } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable);
    let id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
const $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        if (v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl) $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6cds3.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6cds3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4a3e215446c0ed92$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6cds3.useMemo(()=>{
        let trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4a3e215446c0ed92$var$AwaitRenderStatus || {});
const $4a3e215446c0ed92$var$neverSettledPromise = new Promise(()=>{});
class $4a3e215446c0ed92$var$AwaitErrorBoundary extends $6cds3.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4a3e215446c0ed92$var$neverSettledPromise;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6cds3.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6cds3.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0e36e707c39d0f3a$var$defaultMethod = "get";
const $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
const $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0e36e707c39d0f3a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6cds3.createContext({
    isTransitioning: false
});
const $0e36e707c39d0f3a$export$148fd98d095596d4 = /*#__PURE__*/ $6cds3.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
const $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
const $0e36e707c39d0f3a$var$FLUSH_SYNC = "flushSync";
const $0e36e707c39d0f3a$var$flushSyncImpl = $6d4849ee44552f5f$exports[$0e36e707c39d0f3a$var$FLUSH_SYNC];
const $0e36e707c39d0f3a$var$USE_ID = "useId";
const $0e36e707c39d0f3a$var$useIdImpl = $6cds3[$0e36e707c39d0f3a$var$USE_ID];
function $0e36e707c39d0f3a$var$startTransitionSafe(cb) {
    if ($0e36e707c39d0f3a$var$startTransitionImpl) $0e36e707c39d0f3a$var$startTransitionImpl(cb);
    else cb();
}
function $0e36e707c39d0f3a$var$flushSyncSafe(cb) {
    if ($0e36e707c39d0f3a$var$flushSyncImpl) $0e36e707c39d0f3a$var$flushSyncImpl(cb);
    else cb();
}
class $0e36e707c39d0f3a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0e36e707c39d0f3a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let [pendingState, setPendingState] = $6cds3.useState();
    let [vtContext, setVtContext] = $6cds3.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6cds3.useState();
    let [transition, setTransition] = $6cds3.useState();
    let [interruption, setInterruption] = $6cds3.useState();
    let fetcherData = $6cds3.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6cds3.useCallback((cb)=>{
        if (v7_startTransition) $0e36e707c39d0f3a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6cds3.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6cds3.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0e36e707c39d0f3a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6cds3.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $0e36e707c39d0f3a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4a3e215446c0ed92$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref7, $0e36e707c39d0f3a$var$_excluded);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref8, $0e36e707c39d0f3a$var$_excluded2);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0e36e707c39d0f3a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0e36e707c39d0f3a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref9, $0e36e707c39d0f3a$var$_excluded3);
    let submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
// Internal hooks
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback((event)=>{
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6cds3.useRef(false);
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let searchParams = $6cds3.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let setSearchParams = $6cds3.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0e36e707c39d0f3a$var$fetcherId = 0;
let $0e36e707c39d0f3a$var$getUniqueFetcherId = ()=>"__" + String(++$0e36e707c39d0f3a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0e36e707c39d0f3a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher);
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6cds3.useContext($0e36e707c39d0f3a$export$148fd98d095596d4);
    let route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0e36e707c39d0f3a$var$useIdImpl ? $0e36e707c39d0f3a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6cds3.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0e36e707c39d0f3a$var$getUniqueFetcherId());
    // Registration/cleanup
    $6cds3.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6cds3.useCallback((href, opts)=>{
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let submit = $6cds3.useCallback((target, opts)=>{
        submitImpl(target, $0e36e707c39d0f3a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6cds3.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a7fed597f4b8afd8, $0e36e707c39d0f3a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $96b280a33643b696$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6cds3.useMemo(()=>$0e36e707c39d0f3a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0e36e707c39d0f3a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    let navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4a3e215446c0ed92$export$b273b3273281a049)(when);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0e36e707c39d0f3a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6cds3.useContext($0e36e707c39d0f3a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $6cds3 = parcelRequire("6cds3");
const $587b42263799c6ca$export$5a5aa09ce3350424 = /*#__PURE__*/ (0, $6cds3.createContext)({
    switchForm: false,
    setSwitchForm: ()=>{}
});
const $587b42263799c6ca$export$ac2a972d23ebc682 = ({ children: children })=>{
    const [switchForm, setSwitchForm] = (0, $6cds3.useState)(false);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($587b42263799c6ca$export$5a5aa09ce3350424.Provider, {
        value: {
            switchForm: switchForm,
            setSwitchForm: setSwitchForm
        },
        children: children
    });
};



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
const $f321b107431e002f$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $6cds3.createContext)({
    auth: {
        token: ""
    },
    setAuth: ()=>{}
});
const $f321b107431e002f$export$87091915187a1a85 = ({ children: children })=>{
    const [auth, setAuth] = (0, $6cds3.useState)({
        token: ""
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($f321b107431e002f$export$a0fd8390cfe8ae69.Provider, {
        value: {
            auth: auth,
            setAuth: setAuth
        },
        children: children
    });
};


const $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $6cds3.useContext)((0, $f321b107431e002f$export$a0fd8390cfe8ae69));
};


"use strict";
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== "object") return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest("HTMLFormElement");
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest("RegExp");
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $4457f145f4fd6a49$var$DIGIT = "0123456789";
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest("AsyncFunction");
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf);
    else return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $5a7d4ee62d502cb1$export$d622b2ad8d90c771($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $5dbdf283f7ef4044$require$Buffer = $c114c26e12685207$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $ca291930ae00924d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





"use strict";
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


"use strict";
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = ((product)=>{
    return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$e7f6cfbce8ef57c2$exports,
    ...(0, $933095d2c2007f0e$export$2e2bcd8739ae039)
};


"use strict";
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $97723c9940354b38$var$$internals = Symbol("internals");
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


"use strict";
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







"use strict";
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


"use strict";
function $089238041fc30567$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request aborted", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Network Error", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f311d0388b14bc21$var$renderReason).join("\n") : " " + $f311d0388b14bc21$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $0c953052fb93d857$export$a4ad2735b021c132 = "1.6.7";



"use strict";
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $0c953052fb93d857$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("options must be an object", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



"use strict";
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






"use strict";
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);


(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).defaults.withCredentials = true;
const $a9b114d4c5390c4c$export$8134c072fddab6a5 = async ()=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get("https://online-shop-backend.maciejkloda.pl/api");
    return data;
};
const $a9b114d4c5390c4c$export$8bd21d103ad1522b = async ()=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get("https://online-shop-backend.maciejkloda.pl/api/bestsellers");
    return data;
};
const $a9b114d4c5390c4c$export$4a24d6ea857d784a = async (gender)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/api/gender", gender);
    return data;
};
const $a9b114d4c5390c4c$export$ef4373c7e62b2278 = async (searchValue)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/api/search", {
        name: searchValue
    });
    return data;
};
const $a9b114d4c5390c4c$export$878a0e4415d4b711 = async (id)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get(`https://online-shop-backend.maciejkloda.pl/api/item/${id}`);
    return data;
};
const $a9b114d4c5390c4c$export$2835898f2b1b1017 = async (email)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/newsletter", {
        email: email
    }, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return data;
};
const $a9b114d4c5390c4c$export$e943aa06367afd58 = async (loginData)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/auth/login", JSON.stringify(loginData), {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return data;
};
const $a9b114d4c5390c4c$export$16015adca85344a = async (registerData)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/auth/register", JSON.stringify(registerData), {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return data;
};
const $a9b114d4c5390c4c$export$318ed307220606e = async ()=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get("https://online-shop-backend.maciejkloda.pl/auth/refresh");
    return data;
};
const $a9b114d4c5390c4c$export$e8df664d4863167e = async ()=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/auth/logout");
    return data;
};
const $a9b114d4c5390c4c$export$dc726c8e334dd814 = async (email)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/auth/reset-password", {
        email: email
    });
    return data;
};
const $a9b114d4c5390c4c$export$b0a3b9ff4bc3863b = async (password, confirmPassword, token)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/auth/reset-password/set", {
        password: password,
        confirmPassword: confirmPassword,
        token: token
    });
    return data;
};
const $a9b114d4c5390c4c$export$3f90b926bc531097 = async (id, token)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/user", {
        id: id
    }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
    return data;
};
const $a9b114d4c5390c4c$export$e3ac7a5d19605772 = async (formData)=>{
    const { data: data } = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://online-shop-backend.maciejkloda.pl/user/update", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return data;
};



const $775be0450cc3470d$export$9a5b97a7aba1a585 = ()=>{
    const { setAuth: setAuth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    return async ()=>{
        await (0, $a9b114d4c5390c4c$export$e8df664d4863167e)();
        setAuth({
            token: ""
        });
    };
};



var $6cds3 = parcelRequire("6cds3");
var $41c00733f21c33db$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $41c00733f21c33db$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $41c00733f21c33db$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $41c00733f21c33db$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $41c00733f21c33db$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $41c00733f21c33db$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $41c00733f21c33db$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $41c00733f21c33db$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $41c00733f21c33db$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $41c00733f21c33db$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $41c00733f21c33db$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $41c00733f21c33db$var$root = $41c00733f21c33db$var$freeGlobal || $41c00733f21c33db$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $41c00733f21c33db$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41c00733f21c33db$var$objectToString = $41c00733f21c33db$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $41c00733f21c33db$var$nativeMax = Math.max, $41c00733f21c33db$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $41c00733f21c33db$var$now = function() {
    return $41c00733f21c33db$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $41c00733f21c33db$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($41c00733f21c33db$var$FUNC_ERROR_TEXT);
    wait = $41c00733f21c33db$var$toNumber(wait) || 0;
    if ($41c00733f21c33db$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $41c00733f21c33db$var$nativeMax($41c00733f21c33db$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $41c00733f21c33db$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $41c00733f21c33db$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($41c00733f21c33db$var$now());
    }
    function debounced() {
        var time = $41c00733f21c33db$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $41c00733f21c33db$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $41c00733f21c33db$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $41c00733f21c33db$var$isSymbol(value) {
    return typeof value == "symbol" || $41c00733f21c33db$var$isObjectLike(value) && $41c00733f21c33db$var$objectToString.call(value) == $41c00733f21c33db$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $41c00733f21c33db$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($41c00733f21c33db$var$isSymbol(value)) return $41c00733f21c33db$var$NAN;
    if ($41c00733f21c33db$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $41c00733f21c33db$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($41c00733f21c33db$var$reTrim, "");
    var isBinary = $41c00733f21c33db$var$reIsBinary.test(value);
    return isBinary || $41c00733f21c33db$var$reIsOctal.test(value) ? $41c00733f21c33db$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $41c00733f21c33db$var$reIsBadHex.test(value) ? $41c00733f21c33db$var$NAN : +value;
}
$41c00733f21c33db$exports = $41c00733f21c33db$var$debounce;


// src/useBoolean/useBoolean.ts
function $38a3408ff9214f5d$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $6cds3.useState)(defaultValue);
    const setTrue = (0, $6cds3.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $6cds3.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $6cds3.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $38a3408ff9214f5d$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $6cds3.useLayoutEffect) : (0, $6cds3.useEffect);
// src/useEventListener/useEventListener.ts
function $38a3408ff9214f5d$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $6cds3.useRef)(handler);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $6cds3.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $38a3408ff9214f5d$export$5139c081cbc6c8bb(handler) {
    $38a3408ff9214f5d$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $38a3408ff9214f5d$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $6cds3.useState)(null);
    const copy = (0, $6cds3.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $38a3408ff9214f5d$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $6cds3.useState)(initialValue ?? 0);
    const increment = (0, $6cds3.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $6cds3.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $6cds3.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $38a3408ff9214f5d$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $6cds3.useRef)(callback);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $38a3408ff9214f5d$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $38a3408ff9214f5d$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $38a3408ff9214f5d$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $6cds3.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $6cds3.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $38a3408ff9214f5d$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $38a3408ff9214f5d$export$ee5b5d04074a389e(fn) {
    const ref = (0, $6cds3.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $6cds3.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $38a3408ff9214f5d$var$IS_SERVER = typeof window === "undefined";
function $38a3408ff9214f5d$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $6cds3.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $6cds3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $6cds3.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($38a3408ff9214f5d$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $38a3408ff9214f5d$export$ee5b5d04074a389e((value)=>{
        if ($38a3408ff9214f5d$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $38a3408ff9214f5d$export$ee5b5d04074a389e(()=>{
        if ($38a3408ff9214f5d$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $6cds3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $6cds3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("storage", handleStorageChange);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $38a3408ff9214f5d$var$IS_SERVER2 = typeof window === "undefined";
function $38a3408ff9214f5d$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($38a3408ff9214f5d$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $38a3408ff9214f5d$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $38a3408ff9214f5d$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $38a3408ff9214f5d$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $38a3408ff9214f5d$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $38a3408ff9214f5d$export$32d5543ab307c01($38a3408ff9214f5d$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $38a3408ff9214f5d$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $38a3408ff9214f5d$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $6cds3.useRef)(func);
    funcRef.current = func;
    (0, $6cds3.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $38a3408ff9214f5d$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $6cds3.useRef)();
    $38a3408ff9214f5d$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $6cds3.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($41c00733f21c33db$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $6cds3.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($41c00733f21c33db$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $38a3408ff9214f5d$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $6cds3.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $6cds3.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $38a3408ff9214f5d$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $38a3408ff9214f5d$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $6cds3.useRef)(null);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $38a3408ff9214f5d$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $38a3408ff9214f5d$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $6cds3.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $38a3408ff9214f5d$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $38a3408ff9214f5d$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $6cds3.useState)(null);
    const [state, setState] = (0, $6cds3.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $6cds3.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $6cds3.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $38a3408ff9214f5d$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $38a3408ff9214f5d$export$80c2a3957bcb42ea() {
    const isMounted = (0, $6cds3.useRef)(false);
    (0, $6cds3.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $6cds3.useCallback)(()=>isMounted.current, []);
}
function $38a3408ff9214f5d$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $6cds3.useState)(new Map(initialState));
    const actions = {
        set: (0, $6cds3.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $6cds3.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $6cds3.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $6cds3.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $38a3408ff9214f5d$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $38a3408ff9214f5d$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $38a3408ff9214f5d$var$IS_SERVER3 = typeof window === "undefined";
function $38a3408ff9214f5d$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($38a3408ff9214f5d$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $6cds3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $6cds3.useCallback)(()=>{
        if ($38a3408ff9214f5d$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $6cds3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $6cds3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("storage", handleStorageChange);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $38a3408ff9214f5d$var$initialSize = {
    width: void 0,
    height: void 0
};
function $38a3408ff9214f5d$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $6cds3.useState)($38a3408ff9214f5d$var$initialSize);
    const isMounted = $38a3408ff9214f5d$export$80c2a3957bcb42ea();
    const previousSize = (0, $6cds3.useRef)({
        ...$38a3408ff9214f5d$var$initialSize
    });
    const onResize = (0, $6cds3.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $6cds3.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $38a3408ff9214f5d$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $38a3408ff9214f5d$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $38a3408ff9214f5d$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $38a3408ff9214f5d$var$IS_SERVER4 = typeof window === "undefined";
function $38a3408ff9214f5d$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($38a3408ff9214f5d$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($38a3408ff9214f5d$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $38a3408ff9214f5d$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $38a3408ff9214f5d$export$7080b3e976bc91ab("resize", handleSize);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $38a3408ff9214f5d$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $38a3408ff9214f5d$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $38a3408ff9214f5d$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $6cds3.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $38a3408ff9214f5d$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $6cds3.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $38a3408ff9214f5d$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $38a3408ff9214f5d$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $38a3408ff9214f5d$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $38a3408ff9214f5d$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $38a3408ff9214f5d$var$IS_SERVER5 = typeof window === "undefined";
function $38a3408ff9214f5d$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $6cds3.useState)(false);
    const target = (0, $6cds3.useRef)(null);
    const originalStyle = (0, $6cds3.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        if ($38a3408ff9214f5d$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $38a3408ff9214f5d$var$IS_SERVER6 = typeof window === "undefined";
function $38a3408ff9214f5d$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $6cds3.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $6cds3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $6cds3.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($38a3408ff9214f5d$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $38a3408ff9214f5d$export$ee5b5d04074a389e((value)=>{
        if ($38a3408ff9214f5d$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $38a3408ff9214f5d$export$ee5b5d04074a389e(()=>{
        if ($38a3408ff9214f5d$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $6cds3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $6cds3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("storage", handleStorageChange);
    $38a3408ff9214f5d$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $38a3408ff9214f5d$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $6cds3.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $6cds3.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $6cds3.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $6cds3.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $6cds3.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $38a3408ff9214f5d$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $38a3408ff9214f5d$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $38a3408ff9214f5d$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $38a3408ff9214f5d$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $38a3408ff9214f5d$export$32d5543ab307c01($38a3408ff9214f5d$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $38a3408ff9214f5d$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $38a3408ff9214f5d$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $6cds3.useRef)(callback);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $38a3408ff9214f5d$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $6cds3.useState)(!!defaultValue);
    const toggle = (0, $6cds3.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $38a3408ff9214f5d$var$IS_SERVER7 = typeof window === "undefined";
function $38a3408ff9214f5d$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($38a3408ff9214f5d$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $6cds3.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $38a3408ff9214f5d$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $38a3408ff9214f5d$export$7080b3e976bc91ab("resize", handleSize);
    $38a3408ff9214f5d$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

function $0ec1752947769151$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $faee95b32f04793f$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $f9ecdc810e5ad764$var$thresholds = {
    some: 0,
    all: 1
};
function $f9ecdc810e5ad764$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $0ec1752947769151$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $f9ecdc810e5ad764$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $a4467854d8e7cfc0$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $f9ecdc810e5ad764$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}




var $6cds3 = parcelRequire("6cds3");

const $edf56992e40d71f4$export$c5489c95288643f7 = ()=>{
    return (0, $6cds3.useContext)((0, $587b42263799c6ca$export$5a5aa09ce3350424));
};






function $a343d3e7a310970f$var$Backdrop({ setIsActive: setIsActive, children: children, isReset: isReset, setIsReset: setIsReset }) {
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const closeHandler = ()=>{
        if (isReset && setIsReset) {
            setIsActive(false);
            setIsReset(false);
            setTimeout(()=>{
                navigate("/");
            }, 500);
        } else setIsActive(false);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
        className: "backdrop",
        onClick: closeHandler,
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        children: children
    });
}
var $a343d3e7a310970f$export$2e2bcd8739ae039 = $a343d3e7a310970f$var$Backdrop;




var $6cds3 = parcelRequire("6cds3");





var $bc71620de13fd335$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $bc71620de13fd335$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$bc71620de13fd335$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$bc71620de13fd335$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$bc71620de13fd335$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $bc71620de13fd335$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $bc71620de13fd335$var$DIGIT_REGEX = /^\d+$/, $bc71620de13fd335$var$LEAD_DIGIT_REGEX = /^\d/, $bc71620de13fd335$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $bc71620de13fd335$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $bc71620de13fd335$var$MAX_CACHE_SIZE = 512;
var $bc71620de13fd335$var$pathCache = new $bc71620de13fd335$var$Cache($bc71620de13fd335$var$MAX_CACHE_SIZE), $bc71620de13fd335$var$setCache = new $bc71620de13fd335$var$Cache($bc71620de13fd335$var$MAX_CACHE_SIZE), $bc71620de13fd335$var$getCache = new $bc71620de13fd335$var$Cache($bc71620de13fd335$var$MAX_CACHE_SIZE);
var $bc71620de13fd335$var$config;
$bc71620de13fd335$exports = {
    Cache: $bc71620de13fd335$var$Cache,
    split: $bc71620de13fd335$var$split,
    normalizePath: $bc71620de13fd335$var$normalizePath,
    setter: function(path) {
        var parts = $bc71620de13fd335$var$normalizePath(path);
        return $bc71620de13fd335$var$setCache.get(path) || $bc71620de13fd335$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $bc71620de13fd335$var$normalizePath(path);
        return $bc71620de13fd335$var$getCache.get(path) || $bc71620de13fd335$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($bc71620de13fd335$var$isQuoted(part) || $bc71620de13fd335$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $bc71620de13fd335$var$forEach(Array.isArray(path) ? path : $bc71620de13fd335$var$split(path), cb, thisArg);
    }
};
function $bc71620de13fd335$var$normalizePath(path) {
    return $bc71620de13fd335$var$pathCache.get(path) || $bc71620de13fd335$var$pathCache.set(path, $bc71620de13fd335$var$split(path).map(function(part) {
        return part.replace($bc71620de13fd335$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $bc71620de13fd335$var$split(path) {
    return path.match($bc71620de13fd335$var$SPLIT_REGEX) || [
        ""
    ];
}
function $bc71620de13fd335$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($bc71620de13fd335$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $bc71620de13fd335$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $bc71620de13fd335$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $bc71620de13fd335$var$hasLeadingNumber(part) {
    return part.match($bc71620de13fd335$var$LEAD_DIGIT_REGEX) && !part.match($bc71620de13fd335$var$DIGIT_REGEX);
}
function $bc71620de13fd335$var$hasSpecialChars(part) {
    return $bc71620de13fd335$var$SPEC_CHAR_REGEX.test(part);
}
function $bc71620de13fd335$var$shouldBeQuoted(part) {
    return !$bc71620de13fd335$var$isQuoted(part) && ($bc71620de13fd335$var$hasLeadingNumber(part) || $bc71620de13fd335$var$hasSpecialChars(part));
}


var $be205156e9a97b32$exports = {};
const $be205156e9a97b32$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $be205156e9a97b32$var$words = (str)=>str.match($be205156e9a97b32$var$reWords) || [];
const $be205156e9a97b32$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $be205156e9a97b32$var$join = (str, d)=>$be205156e9a97b32$var$words(str).join(d).toLowerCase();
const $be205156e9a97b32$var$camelCase = (str)=>$be205156e9a97b32$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $be205156e9a97b32$var$pascalCase = (str)=>$be205156e9a97b32$var$upperFirst($be205156e9a97b32$var$camelCase(str));
const $be205156e9a97b32$var$snakeCase = (str)=>$be205156e9a97b32$var$join(str, "_");
const $be205156e9a97b32$var$kebabCase = (str)=>$be205156e9a97b32$var$join(str, "-");
const $be205156e9a97b32$var$sentenceCase = (str)=>$be205156e9a97b32$var$upperFirst($be205156e9a97b32$var$join(str, " "));
const $be205156e9a97b32$var$titleCase = (str)=>$be205156e9a97b32$var$words(str).map($be205156e9a97b32$var$upperFirst).join(" ");
$be205156e9a97b32$exports = {
    words: $be205156e9a97b32$var$words,
    upperFirst: $be205156e9a97b32$var$upperFirst,
    camelCase: $be205156e9a97b32$var$camelCase,
    pascalCase: $be205156e9a97b32$var$pascalCase,
    snakeCase: $be205156e9a97b32$var$snakeCase,
    kebabCase: $be205156e9a97b32$var$kebabCase,
    sentenceCase: $be205156e9a97b32$var$sentenceCase,
    titleCase: $be205156e9a97b32$var$titleCase
};


var $cfdc6657476e18d1$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $cfdc6657476e18d1$exports = function(edges) {
    return $cfdc6657476e18d1$var$toposort($cfdc6657476e18d1$var$uniqueNodes(edges), edges);
};
$cfdc6657476e18d1$exports.array = $cfdc6657476e18d1$var$toposort;
function $cfdc6657476e18d1$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $cfdc6657476e18d1$var$makeOutgoingEdges(edges), nodesHash = $cfdc6657476e18d1$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $cfdc6657476e18d1$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $cfdc6657476e18d1$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $cfdc6657476e18d1$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $9369df28be89e88b$var$toString = Object.prototype.toString;
const $9369df28be89e88b$var$errorToString = Error.prototype.toString;
const $9369df28be89e88b$var$regExpToString = RegExp.prototype.toString;
const $9369df28be89e88b$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $9369df28be89e88b$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $9369df28be89e88b$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $9369df28be89e88b$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $9369df28be89e88b$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $9369df28be89e88b$var$symbolToString.call(val).replace($9369df28be89e88b$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $9369df28be89e88b$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $9369df28be89e88b$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $9369df28be89e88b$var$regExpToString.call(val);
    return null;
}
function $9369df28be89e88b$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $9369df28be89e88b$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $9369df28be89e88b$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $9369df28be89e88b$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $9369df28be89e88b$var$_Symbol$toStringTag, $9369df28be89e88b$var$_Symbol$hasInstance, $9369df28be89e88b$var$_Symbol$toStringTag2;
let $9369df28be89e88b$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$9369df28be89e88b$var$_Symbol$toStringTag = Symbol.toStringTag;
class $9369df28be89e88b$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$9369df28be89e88b$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $9369df28be89e88b$var$toArray(errorOrErrors).forEach((err)=>{
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$9369df28be89e88b$var$_Symbol$hasInstance = Symbol.hasInstance;
$9369df28be89e88b$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $9369df28be89e88b$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($9369df28be89e88b$var$strReg, (_, key)=>$9369df28be89e88b$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $9369df28be89e88b$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$9369df28be89e88b$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $9369df28be89e88b$export$2191b9da168c6cf0);
    }
    static [$9369df28be89e88b$var$_Symbol$hasInstance](inst) {
        return $9369df28be89e88b$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $9369df28be89e88b$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$9369df28be89e88b$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$9369df28be89e88b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$9369df28be89e88b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $9369df28be89e88b$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $9369df28be89e88b$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $9369df28be89e88b$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $9369df28be89e88b$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $9369df28be89e88b$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $9369df28be89e88b$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $9369df28be89e88b$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$9369df28be89e88b$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$9369df28be89e88b$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $9369df28be89e88b$export$2191b9da168c6cf0.formatError($9369df28be89e88b$var$mixed.notType, params);
    }
};
var $9369df28be89e88b$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $9369df28be89e88b$var$mixed,
    string: $9369df28be89e88b$var$string,
    number: $9369df28be89e88b$var$number,
    date: $9369df28be89e88b$var$date,
    object: $9369df28be89e88b$var$object,
    array: $9369df28be89e88b$var$array,
    boolean: $9369df28be89e88b$var$boolean,
    tuple: $9369df28be89e88b$var$tuple
});
const $9369df28be89e88b$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $9369df28be89e88b$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $9369df28be89e88b$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$9369df28be89e88b$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $9369df28be89e88b$var$prefixes = {
    context: "$",
    value: "."
};
function $9369df28be89e88b$export$eff4d24c3ff7876e(key, options) {
    return new $9369df28be89e88b$var$Reference(key, options);
}
class $9369df28be89e88b$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $9369df28be89e88b$var$prefixes.context;
        this.isValue = this.key[0] === $9369df28be89e88b$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $9369df28be89e88b$var$prefixes.context : this.isValue ? $9369df28be89e88b$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $bc71620de13fd335$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$9369df28be89e88b$var$Reference.prototype.__isYupRef = true;
const $9369df28be89e88b$var$isAbsent = (value)=>value == null;
function $9369df28be89e88b$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $9369df28be89e88b$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $9369df28be89e88b$export$2191b9da168c6cf0($9369df28be89e88b$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $9369df28be89e88b$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $9369df28be89e88b$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $bc71620de13fd335$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $9369df28be89e88b$export$cfedb76369cc7782(obj, path, value, context) {
    return $9369df28be89e88b$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $9369df28be89e88b$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($9369df28be89e88b$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $9369df28be89e88b$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $9369df28be89e88b$var$clone(src, seen = new Map()) {
    if ($9369df28be89e88b$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $9369df28be89e88b$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $9369df28be89e88b$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($9369df28be89e88b$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $9369df28be89e88b$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $9369df28be89e88b$var$ReferenceSet();
        this._blacklist = new $9369df28be89e88b$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($9369df28be89e88b$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $9369df28be89e88b$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $9369df28be89e88b$var$isAbsent(result)) return result;
            let formattedValue = $9369df28be89e88b$export$5790025c6e6c2ba6(value);
            let formattedResult = $9369df28be89e88b$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $9369df28be89e88b$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $9369df28be89e88b$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($9369df28be89e88b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $9369df28be89e88b$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $9369df28be89e88b$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $9369df28be89e88b$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $9369df28be89e88b$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $9369df28be89e88b$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $9369df28be89e88b$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $9369df28be89e88b$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $9369df28be89e88b$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $9369df28be89e88b$var$toArray(keys).map((key)=>new $9369df28be89e88b$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $9369df28be89e88b$var$Condition(deps, options) : $9369df28be89e88b$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $9369df28be89e88b$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $9369df28be89e88b$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $9369df28be89e88b$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $9369df28be89e88b$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $9369df28be89e88b$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$9369df28be89e88b$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$9369df28be89e88b$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $9369df28be89e88b$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$9369df28be89e88b$export$19342e026b58ebb7.prototype[alias] = $9369df28be89e88b$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$9369df28be89e88b$export$19342e026b58ebb7.prototype[alias] = $9369df28be89e88b$export$19342e026b58ebb7.prototype.notOneOf;
const $9369df28be89e88b$var$returnsTrue = ()=>true;
function $9369df28be89e88b$export$9b30b6294c1449a8(spec) {
    return new $9369df28be89e88b$export$1e88358c94ddec71(spec);
}
class $9369df28be89e88b$export$1e88358c94ddec71 extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $9369df28be89e88b$var$returnsTrue
        }, spec));
    }
}
$9369df28be89e88b$export$9b30b6294c1449a8.prototype = $9369df28be89e88b$export$1e88358c94ddec71.prototype;
function $9369df28be89e88b$export$87b259aa03e3d267() {
    return new $9369df28be89e88b$export$c7980688f11e1f49();
}
class $9369df28be89e88b$export$c7980688f11e1f49 extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $9369df28be89e88b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $9369df28be89e88b$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $9369df28be89e88b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $9369df28be89e88b$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$9369df28be89e88b$export$87b259aa03e3d267.prototype = $9369df28be89e88b$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $9369df28be89e88b$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $9369df28be89e88b$var$parseIsoDate(date) {
    const struct = $9369df28be89e88b$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $9369df28be89e88b$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $9369df28be89e88b$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $9369df28be89e88b$var$toNumber(regexResult[1]),
        month: $9369df28be89e88b$var$toNumber(regexResult[2], 1) - 1,
        day: $9369df28be89e88b$var$toNumber(regexResult[3], 1),
        hour: $9369df28be89e88b$var$toNumber(regexResult[4]),
        minute: $9369df28be89e88b$var$toNumber(regexResult[5]),
        second: $9369df28be89e88b$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $9369df28be89e88b$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $9369df28be89e88b$var$toNumber(regexResult[10]),
        minuteOffset: $9369df28be89e88b$var$toNumber(regexResult[11])
    };
}
function $9369df28be89e88b$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $9369df28be89e88b$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $9369df28be89e88b$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $9369df28be89e88b$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $9369df28be89e88b$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $9369df28be89e88b$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $9369df28be89e88b$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $9369df28be89e88b$var$rIsoDateTime = new RegExp(`${$9369df28be89e88b$var$yearMonthDay}T${$9369df28be89e88b$var$hourMinuteSecond}(\\.\\d+)?${$9369df28be89e88b$var$zOrOffset}$`);
let $9369df28be89e88b$var$isTrimmed = (value)=>$9369df28be89e88b$var$isAbsent(value) || value === value.trim();
let $9369df28be89e88b$var$objStringTag = ({}).toString();
function $9369df28be89e88b$export$22b082955e083ec3() {
    return new $9369df28be89e88b$export$49bf8b2ede5138eb();
}
class $9369df28be89e88b$export$49bf8b2ede5138eb extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $9369df28be89e88b$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $9369df28be89e88b$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $9369df28be89e88b$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $9369df28be89e88b$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $9369df28be89e88b$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $9369df28be89e88b$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $9369df28be89e88b$var$string.email) {
        return this.matches($9369df28be89e88b$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $9369df28be89e88b$var$string.url) {
        return this.matches($9369df28be89e88b$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $9369df28be89e88b$var$string.uuid) {
        return this.matches($9369df28be89e88b$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($9369df28be89e88b$var$rIsoDateTime, {
            name: "datetime",
            message: message || $9369df28be89e88b$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $9369df28be89e88b$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $9369df28be89e88b$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $9369df28be89e88b$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $9369df28be89e88b$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $9369df28be89e88b$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $9369df28be89e88b$var$isTrimmed
        });
    }
    lowercase(message = $9369df28be89e88b$var$string.lowercase) {
        return this.transform((value)=>!$9369df28be89e88b$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$9369df28be89e88b$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $9369df28be89e88b$var$string.uppercase) {
        return this.transform((value)=>!$9369df28be89e88b$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$9369df28be89e88b$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$9369df28be89e88b$export$22b082955e083ec3.prototype = $9369df28be89e88b$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $9369df28be89e88b$var$isNaN$1 = (value)=>value != +value;
function $9369df28be89e88b$export$98e628dec113755e() {
    return new $9369df28be89e88b$export$f192ec5e9228ab19();
}
class $9369df28be89e88b$export$f192ec5e9228ab19 extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$9369df28be89e88b$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $9369df28be89e88b$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $9369df28be89e88b$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $9369df28be89e88b$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $9369df28be89e88b$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $9369df28be89e88b$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $9369df28be89e88b$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $9369df28be89e88b$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$9369df28be89e88b$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$9369df28be89e88b$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$9369df28be89e88b$export$98e628dec113755e.prototype = $9369df28be89e88b$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $9369df28be89e88b$var$invalidDate = new Date("");
let $9369df28be89e88b$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $9369df28be89e88b$export$324d90190a8b822a() {
    return new $9369df28be89e88b$export$18ec3cc5a157503f();
}
class $9369df28be89e88b$export$18ec3cc5a157503f extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $9369df28be89e88b$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $9369df28be89e88b$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $9369df28be89e88b$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$9369df28be89e88b$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $9369df28be89e88b$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $9369df28be89e88b$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$9369df28be89e88b$export$18ec3cc5a157503f.INVALID_DATE = $9369df28be89e88b$var$invalidDate;
$9369df28be89e88b$export$324d90190a8b822a.prototype = $9369df28be89e88b$export$18ec3cc5a157503f.prototype;
$9369df28be89e88b$export$324d90190a8b822a.INVALID_DATE = $9369df28be89e88b$var$invalidDate;
// @ts-expect-error
function $9369df28be89e88b$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $bc71620de13fd335$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($9369df28be89e88b$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($9369df28be89e88b$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cfdc6657476e18d1$exports))).array(Array.from(nodes), edges).reverse();
}
function $9369df28be89e88b$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $9369df28be89e88b$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $9369df28be89e88b$var$findIndex(keys, a) - $9369df28be89e88b$var$findIndex(keys, b);
    };
}
const $9369df28be89e88b$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $9369df28be89e88b$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $9369df28be89e88b$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $9369df28be89e88b$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($9369df28be89e88b$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $9369df28be89e88b$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $bc71620de13fd335$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $bc71620de13fd335$exports.getter)((0, $bc71620de13fd335$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $9369df28be89e88b$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $9369df28be89e88b$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $9369df28be89e88b$var$defaultSort = $9369df28be89e88b$var$sortByKeyOrder([]);
function $9369df28be89e88b$export$be5493f9613cbbe(spec) {
    return new $9369df28be89e88b$export$18b4fc70ec7eccf8(spec);
}
class $9369df28be89e88b$export$18b4fc70ec7eccf8 extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $9369df28be89e88b$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $9369df28be89e88b$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $9369df28be89e88b$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$9369df28be89e88b$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $9369df28be89e88b$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $9369df28be89e88b$var$sortFields(shape, excludedEdges);
        next._sortErrors = $9369df28be89e88b$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $9369df28be89e88b$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $bc71620de13fd335$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($9369df28be89e88b$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($9369df28be89e88b$var$parseJson);
    }
    noUnknown(noAllow = true, message = $9369df28be89e88b$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $9369df28be89e88b$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $9369df28be89e88b$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $be205156e9a97b32$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $be205156e9a97b32$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $be205156e9a97b32$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$9369df28be89e88b$export$be5493f9613cbbe.prototype = $9369df28be89e88b$export$18b4fc70ec7eccf8.prototype;
function $9369df28be89e88b$export$2f23118c22fb2630(type) {
    return new $9369df28be89e88b$export$4347112b8447a7d(type);
}
class $9369df28be89e88b$export$4347112b8447a7d extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($9369df28be89e88b$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$9369df28be89e88b$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $9369df28be89e88b$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $9369df28be89e88b$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $9369df28be89e88b$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $9369df28be89e88b$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$9369df28be89e88b$export$2f23118c22fb2630.prototype = $9369df28be89e88b$export$4347112b8447a7d.prototype;
// @ts-ignore
function $9369df28be89e88b$export$65e3907585753458(schemas) {
    return new $9369df28be89e88b$export$411c3b3687e8ecc8(schemas);
}
class $9369df28be89e88b$export$411c3b3687e8ecc8 extends $9369df28be89e88b$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($9369df28be89e88b$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$9369df28be89e88b$export$65e3907585753458.prototype = $9369df28be89e88b$export$411c3b3687e8ecc8.prototype;
function $9369df28be89e88b$export$488013bae63b21da(builder) {
    return new $9369df28be89e88b$var$Lazy(builder);
}
class $9369df28be89e88b$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$9369df28be89e88b$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $9369df28be89e88b$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $9369df28be89e88b$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $9369df28be89e88b$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $9369df28be89e88b$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$9369df28be89e88b$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}



const $c35849160b22084d$export$345c5736c8054f22 = (parcelRequire("8iuPV"));

const $c35849160b22084d$export$acffd473e57081cc = (parcelRequire("evEpp"));

const $c35849160b22084d$export$d658018a9147579e = (parcelRequire("4izHh"));

const $c35849160b22084d$export$d76128d007d19019 = (parcelRequire("lXTIH"));

const $c35849160b22084d$export$8360e631d277ea4d = (parcelRequire("cQfsc"));

const $c35849160b22084d$export$9f42c466da956b3 = (parcelRequire("7E9SH"));

const $c35849160b22084d$export$f2120bbfa5450bd2 = (parcelRequire("5J5rr"));

const $c35849160b22084d$export$ecf8513b200c5cc6 = (parcelRequire("cmHZg"));



function $a86c9ca7c8be96c3$var$Login({ setIsActiveLoginPanel: setIsActiveLoginPanel }) {
    const [errorInfo, setErrorInfo] = (0, $6cds3.useState)("");
    const [toggleLoader, setToggleLoader] = (0, $6cds3.useState)(false);
    const [loadComplete, setLoadComplete] = (0, $6cds3.useState)(false);
    const [resetPasswordStatus, setResetPasswordStatus] = (0, $6cds3.useState)(false);
    const [resetPasswordMessage, setResetPasswordMessage] = (0, $6cds3.useState)(" ");
    const emailRef = (0, $6cds3.useRef)(null);
    const emailRefReset = (0, $6cds3.useRef)(null);
    const passwordRef = (0, $6cds3.useRef)(null);
    const modalRef = (0, $6cds3.useRef)(null);
    const { setAuth: setAuth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    const { setSwitchForm: setSwitchForm } = (0, $edf56992e40d71f4$export$c5489c95288643f7)();
    const isInView = (0, $a4467854d8e7cfc0$export$2f62ee6831462844)(modalRef);
    const loginSchema = $9369df28be89e88b$export$be5493f9613cbbe({
        email: $9369df28be89e88b$export$22b082955e083ec3().email("Invalid email").min(5).max(30),
        password: $9369df28be89e88b$export$22b082955e083ec3().min(5).max(30)
    });
    const resetSchema = $9369df28be89e88b$export$be5493f9613cbbe({
        email: $9369df28be89e88b$export$22b082955e083ec3().email("Invalid email").min(5).max(30)
    });
    const toggleResetPassword = ()=>{
        setResetPasswordStatus(!resetPasswordStatus);
        emailRef.current?.classList.remove("login-modal__input--invalid");
        passwordRef.current?.classList.remove("login-modal__input--invalid");
        emailRefReset.current?.classList.remove("login-modal__input--invalid");
        setResetPasswordMessage(" ");
        setErrorInfo("");
    };
    const changeStyleReset = ()=>{
        emailRefReset.current?.classList.remove("login-modal__input--invalid");
        setResetPasswordMessage("");
    };
    const resetPasswordHandler = async (e)=>{
        e.preventDefault();
        const data = {
            email: emailRefReset.current?.value
        };
        if (data.email) try {
            await resetSchema.validate(data, {
                abortEarly: false
            });
            await (0, $a9b114d4c5390c4c$export$dc726c8e334dd814)(data.email);
            setResetPasswordMessage("We have sent you a link to change your password by email!");
            setTimeout(()=>{
                setResetPasswordStatus(false);
                setResetPasswordMessage(" ");
            }, 5000);
        } catch (err) {
            setResetPasswordMessage("Please enter valid email");
            emailRefReset.current?.classList.add("login-modal__input--invalid");
        }
    };
    (0, $6cds3.useEffect)(()=>{
        if (isInView) (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(modalRef);
        else (0, $3b4e05b540ea4d30$export$e5d0524c3725571e)(modalRef);
    }, [
        isInView
    ]);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const data = {
            email: emailRef.current?.value,
            password: passwordRef.current?.value
        };
        try {
            setToggleLoader(true);
            await loginSchema.validate(data, {
                abortEarly: false
            });
            const loginData = await (0, $a9b114d4c5390c4c$export$e943aa06367afd58)(data);
            if (loginData.status) {
                setLoadComplete(true);
                setTimeout(()=>{
                    setIsActiveLoginPanel(false);
                }, 1000);
                setAuth({
                    token: loginData.accessToken
                });
            } else if (!loginData.status) {
                setErrorInfo("Incorrect email or password");
                emailRef.current?.classList.add("login-modal__input--invalid");
                passwordRef.current?.classList.add("login-modal__input--invalid");
            }
        } catch (err) {
            setToggleLoader(false);
            setErrorInfo("Incorrect email or password");
            emailRef.current?.classList.add("login-modal__input--invalid");
            passwordRef.current?.classList.add("login-modal__input--invalid");
        }
    };
    const changeStyle = (event)=>{
        emailRef.current?.classList.remove("login-modal__input--invalid");
        passwordRef.current?.classList.remove("login-modal__input--invalid");
        setErrorInfo("");
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: !resetPasswordStatus ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "login-modal__wrap",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).button, {
                    className: "modal__button--close",
                    whileHover: {
                        scale: 1.1
                    },
                    whileTap: {
                        scale: 0.8
                    },
                    onClick: ()=>{
                        setIsActiveLoginPanel(false);
                    },
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: "modal__icon--close",
                        src: $c35849160b22084d$export$8360e631d277ea4d,
                        alt: "Close"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                    className: "login-modal__header",
                    children: "Sign in"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                    className: "login-modal__form",
                    onSubmit: handleSubmit,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter") handleSubmit(e);
                    },
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "login-modal__form-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    onChange: changeStyle,
                                    ref: emailRef,
                                    required: true,
                                    className: "login-modal__input",
                                    type: "text",
                                    id: "email",
                                    name: "email",
                                    placeholder: "E-mail"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "login-modal__label",
                                    htmlFor: "email",
                                    children: "E-mail"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "login-modal__form-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    onChange: changeStyle,
                                    ref: passwordRef,
                                    required: true,
                                    className: "login-modal__input",
                                    type: "password",
                                    id: "password",
                                    name: "password",
                                    placeholder: "Password"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "login-modal__label",
                                    htmlFor: "password",
                                    children: "Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "login-modal__link-text",
                            onClick: toggleResetPassword,
                            children: "Forgot your password?"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "login-modal_error-info",
                            children: errorInfo
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: toggleLoader ? "login-modal__loader" : "login-modal__loader-off",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: !loadComplete ? "circle-loader" : "circle-loader load-complete",
                                children: loadComplete && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "checkmark draw"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            className: "login-modal__button",
                            children: "SIGN IN"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                "Don't have an account? ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "login-modal__link",
                                    onClick: ()=>{
                                        setSwitchForm(true);
                                    },
                                    children: "Sign Up"
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "login-modal__wrap",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).button, {
                    className: "modal__button--close",
                    whileHover: {
                        scale: 1.1
                    },
                    whileTap: {
                        scale: 0.8
                    },
                    onClick: ()=>{
                        setIsActiveLoginPanel(false);
                    },
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: "modal__icon--close",
                        src: $c35849160b22084d$export$8360e631d277ea4d,
                        alt: "Close"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                    className: "login-modal__header",
                    children: "Reset password"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                    className: "login-modal__form",
                    onSubmit: resetPasswordHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter") resetPasswordHandler(e);
                    },
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "login-modal__form-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    onChange: changeStyleReset,
                                    ref: emailRefReset,
                                    required: true,
                                    className: "login-modal__input",
                                    type: "text",
                                    id: "email",
                                    name: "email",
                                    placeholder: "E-mail"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "login-modal__label",
                                    htmlFor: "email",
                                    children: "E-mail"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "login-modal_error-info",
                            children: errorInfo
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                "Already reset your password? ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "login-modal__link-text",
                                    onClick: toggleResetPassword,
                                    children: "Login"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "login-modal_error-info",
                            children: resetPasswordMessage
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: toggleLoader ? "login-modal__loader" : "login-modal__loader-off",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: !loadComplete ? "circle-loader" : "circle-loader load-complete",
                                children: loadComplete && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "checkmark draw"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            className: "login-modal__button",
                            children: "RESET"
                        })
                    ]
                })
            ]
        })
    });
}
var $a86c9ca7c8be96c3$export$2e2bcd8739ae039 = $a86c9ca7c8be96c3$var$Login;




var $6cds3 = parcelRequire("6cds3");






function $77750a31733f055e$var$Register({ setIsActiveLoginPanel: setIsActiveLoginPanel }) {
    const { setSwitchForm: setSwitchForm } = (0, $edf56992e40d71f4$export$c5489c95288643f7)();
    const [toggleLoader, setToggleLoader] = (0, $6cds3.useState)(false);
    const [loadComplete, setLoadComplete] = (0, $6cds3.useState)(false);
    const [formData, setFormData] = (0, $6cds3.useState)({
        name: "",
        surname: "",
        email: "",
        password: "",
        confirmPassword: "",
        dateOfBirth: Date
    });
    const nameRef = (0, $6cds3.useRef)(null);
    const surnameRef = (0, $6cds3.useRef)(null);
    const emailRef = (0, $6cds3.useRef)(null);
    const passwordRef = (0, $6cds3.useRef)(null);
    const repPasswordRef = (0, $6cds3.useRef)(null);
    const dateRef = (0, $6cds3.useRef)(null);
    const registerRefs = {
        name: nameRef,
        surname: surnameRef,
        email: emailRef,
        password: passwordRef,
        confirmPassword: repPasswordRef,
        dateOfBirth: dateRef
    };
    const changeStyle = (event)=>{
        const key = event.target.name;
        registerRefs[key]?.current?.classList.remove("register-modal__input--invalid");
    };
    const getCurrentDate = ()=>{
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };
    const passwordReg = new RegExp(/^(?=.*[0-9])(?=.*[- ?!@#$%^&*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\/\\]{8,30}$/);
    const emailReg = new RegExp(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/);
    const registerSchema = $9369df28be89e88b$export$be5493f9613cbbe({
        name: $9369df28be89e88b$export$22b082955e083ec3().min(1).max(20).required("Name is required"),
        surname: $9369df28be89e88b$export$22b082955e083ec3().min(1).max(20).required("Surname is required"),
        email: $9369df28be89e88b$export$22b082955e083ec3().email().min(5).max(30).matches(emailReg, "Invalid email"),
        password: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).matches(passwordReg, "Invalid password"),
        confirmPassword: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).test("password-should-match", "Passwords doesn't match", function(value) {
            return this.parent.password === value;
        }),
        dateOfBirth: $9369df28be89e88b$export$324d90190a8b822a()
    });
    const updateFormData = (event)=>{
        const { name: name, value: value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setToggleLoader(true);
        try {
            await registerSchema.validate(formData, {
                abortEarly: false
            });
            await (0, $a9b114d4c5390c4c$export$16015adca85344a)(formData);
            setLoadComplete(true);
            setTimeout(()=>{
                setSwitchForm(false);
            }, 1000);
        } catch (err) {
            setToggleLoader(false);
            err.inner.forEach((item)=>{
                if (item.path in registerRefs) {
                    const key = item.path;
                    registerRefs[key]?.current?.classList.add("register-modal__input--invalid");
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "register-modal",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).button, {
                className: "modal__button--close",
                whileHover: {
                    scale: 1.1
                },
                whileTap: {
                    scale: 0.8
                },
                onClick: ()=>{
                    setIsActiveLoginPanel(false);
                },
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: "modal__icon--close",
                    src: $c35849160b22084d$export$8360e631d277ea4d,
                    alt: "Close"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                className: "register-modal__header",
                children: "Sign up"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                className: "register-modal__form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "register-modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "register-modal__form-wrap ",
                                style: {
                                    margin: "0 5px 0 0"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                        className: "register-modal__input",
                                        type: "text",
                                        id: "name",
                                        name: "name",
                                        ref: nameRef,
                                        placeholder: "First name",
                                        onChange: (e)=>{
                                            updateFormData(e);
                                            changeStyle(e);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                        className: "register-modal__label",
                                        htmlFor: "name",
                                        children: "First Name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "register-modal__form-wrap",
                                style: {
                                    margin: "0 0 0 5px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                        className: "register-modal__input",
                                        type: "text",
                                        id: "surname",
                                        name: "surname",
                                        ref: surnameRef,
                                        placeholder: "Last Name",
                                        onChange: (e)=>{
                                            updateFormData(e);
                                            changeStyle(e);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                        className: "register-modal__label",
                                        htmlFor: "surname",
                                        children: "Last Name"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "register-modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                className: "register-modal__input",
                                type: "text",
                                id: "email",
                                name: "email",
                                ref: emailRef,
                                placeholder: "Email",
                                onChange: (e)=>{
                                    updateFormData(e);
                                    changeStyle(e);
                                }
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "register-modal__label",
                                htmlFor: "email",
                                children: "Email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "register-modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                className: "register-modal__input",
                                type: "password",
                                id: "password",
                                name: "password",
                                ref: passwordRef,
                                placeholder: "Password",
                                onChange: (e)=>{
                                    updateFormData(e);
                                    changeStyle(e);
                                }
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "register-modal__label",
                                htmlFor: "password",
                                children: "Password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "register-modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                className: "register-modal__input",
                                type: "password",
                                id: "confirmPassword",
                                name: "confirmPassword",
                                ref: repPasswordRef,
                                placeholder: "Confirm Password",
                                onChange: (e)=>{
                                    updateFormData(e);
                                    changeStyle(e);
                                }
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "register-modal__label",
                                htmlFor: "confirmPassword",
                                children: "Confirm Password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "register-modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                className: "register-modal__input",
                                type: "date",
                                id: "dateOfBirth",
                                name: "dateOfBirth",
                                ref: dateRef,
                                placeholder: "dateOfBirth",
                                min: "1900-01-01",
                                max: getCurrentDate(),
                                onChange: (e)=>{
                                    updateFormData(e);
                                    changeStyle(e);
                                }
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "register-modal__label",
                                htmlFor: "dateOfBirth",
                                children: "Date of birth"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: toggleLoader ? "register-modal__loader" : "register-modal__loader-off",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: !loadComplete ? "circle-loader" : "circle-loader load-complete",
                            children: loadComplete && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "checkmark draw"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "register-modal__button",
                        children: "SING UP"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            "Already have an account? ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "register-modal__link",
                                onClick: ()=>{
                                    setSwitchForm(false);
                                },
                                children: "Sign In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $77750a31733f055e$export$2e2bcd8739ae039 = $77750a31733f055e$var$Register;





var $6cds3 = parcelRequire("6cds3");







function $4c0a24ed177b037c$var$ResetPassword({ setIsActiveLoginPanel: setIsActiveLoginPanel, setIsReset: setIsReset }) {
    const [errorInfo, setErrorInfo] = (0, $6cds3.useState)("");
    const [toggleLoader, setToggleLoader] = (0, $6cds3.useState)(false);
    const [loadComplete, setLoadComplete] = (0, $6cds3.useState)(false);
    const passwordRef = (0, $6cds3.useRef)(null);
    const confirmPasswordRef = (0, $6cds3.useRef)(null);
    const modalRef = (0, $6cds3.useRef)(null);
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const isInView = (0, $a4467854d8e7cfc0$export$2f62ee6831462844)(modalRef);
    const { pathname: pathname } = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    const passwordReg = new RegExp(/^(?=.*[0-9])(?=.*[- ?!@#$%^&*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\/\\]{8,30}$/);
    const resetSchema = $9369df28be89e88b$export$be5493f9613cbbe({
        password: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).matches(passwordReg, "Invalid password"),
        confirmPassword: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).test("password-should-match", "Passwords doesn't match", function(value) {
            return this.parent.password === value;
        })
    });
    (0, $6cds3.useEffect)(()=>{
        if (isInView) (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(modalRef);
        else (0, $3b4e05b540ea4d30$export$e5d0524c3725571e)(modalRef);
    }, [
        isInView
    ]);
    const closeHandler = ()=>{
        setIsActiveLoginPanel(false);
        setIsReset(false);
        setTimeout(()=>{
            navigate("/");
        }, 500);
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        passwordRef.current?.classList.remove("modal__input--invalid");
        confirmPasswordRef.current?.classList.remove("modal__input--invalid");
        const match = pathname.match(/\/reset-password\/(.+)/);
        const data = {
            password: passwordRef.current?.value,
            confirmPassword: confirmPasswordRef.current?.value
        };
        if (data.password && data.confirmPassword && match) try {
            setToggleLoader(true);
            await resetSchema.validate(data, {
                abortEarly: false
            });
            const resetData = await (0, $a9b114d4c5390c4c$export$b0a3b9ff4bc3863b)(data.password, data.confirmPassword, match[1]);
            if (resetData) {
                setLoadComplete(true);
                setTimeout(()=>{
                    setIsActiveLoginPanel(false);
                }, 1000);
            } else if (!resetData.status) {
                setErrorInfo("Incorrect email or password");
                passwordRef.current?.classList.add("modal__input--invalid");
                confirmPasswordRef.current?.classList.add("modal__input--invalid");
            }
        } catch (err) {
            if (err.inner && Array.isArray(err.inner)) err.inner.forEach((item)=>{
                if (item.path === "password") setErrorInfo("Invalid password");
                if (item.path === "confirmPassword") setErrorInfo("Password doesn't match");
            });
            else setErrorInfo("An error occurred. Couldn't change password.");
            setToggleLoader(false);
            passwordRef.current?.classList.add("modal__input--invalid");
            confirmPasswordRef.current?.classList.add("modal__input--invalid");
        }
    };
    const changeStyle = (event)=>{
        passwordRef.current?.classList.remove("modal__input--invalid");
        confirmPasswordRef.current?.classList.remove("modal__input--invalid");
        setErrorInfo("");
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "modal__wrap",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).button, {
                className: "modal__button--close",
                whileHover: {
                    scale: 1.1
                },
                whileTap: {
                    scale: 0.8
                },
                onClick: closeHandler,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: "modal__icon--close",
                    src: $c35849160b22084d$export$8360e631d277ea4d,
                    alt: "Close"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                className: "modal__header",
                children: "Reset Password"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                className: "modal__form",
                onSubmit: handleSubmit,
                onKeyDown: (e)=>{
                    if (e.key === "Enter") handleSubmit(e);
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                onChange: changeStyle,
                                ref: passwordRef,
                                required: true,
                                className: "modal__input",
                                type: "password",
                                id: "password",
                                name: "password",
                                placeholder: "Password"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "modal__label",
                                htmlFor: "password",
                                children: "Password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "modal__form-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                onChange: changeStyle,
                                ref: confirmPasswordRef,
                                required: true,
                                className: "modal__input",
                                type: "password",
                                id: "confirmPasswor",
                                name: "confirmPasswor",
                                placeholder: "Confirm Password"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                className: "modal__label",
                                htmlFor: "confirmPasswor",
                                children: "Confirm Password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: "modal_error-info",
                        children: errorInfo
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: toggleLoader ? "modal__loader" : "modal__loader-off",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: !loadComplete ? "circle-loader" : "circle-loader load-complete",
                            children: loadComplete && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "checkmark draw"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "modal__button",
                        children: "RESET"
                    })
                ]
            })
        ]
    });
}
var $4c0a24ed177b037c$export$2e2bcd8739ae039 = $4c0a24ed177b037c$var$ResetPassword;


function $02c63cf7f567bd0d$var$Modal({ isActiveLoginPanel: isActiveLoginPanel, setIsActiveLoginPanel: setIsActiveLoginPanel, isReset: isReset, setIsReset: setIsReset }) {
    const modalRef = (0, $6cds3.useRef)(null);
    const isInView = (0, $a4467854d8e7cfc0$export$2f62ee6831462844)(modalRef);
    const { switchForm: switchForm } = (0, $edf56992e40d71f4$export$c5489c95288643f7)();
    (0, $6cds3.useEffect)(()=>{
        if (isInView) (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(modalRef);
        else (0, $3b4e05b540ea4d30$export$e5d0524c3725571e)(modalRef);
    }, [
        isInView
    ]);
    const options = {
        hidden: {
            y: "-105vh",
            opacity: 0
        },
        visible: {
            y: "0",
            opacity: 1,
            transition: {
                duration: 0.1,
                type: `spring`,
                stiffness: 500,
                damping: 25
            }
        },
        exit: {
            y: "-105vh",
            opacity: 0
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a343d3e7a310970f$export$2e2bcd8739ae039), {
        setIsActive: setIsActiveLoginPanel,
        setIsReset: setIsReset,
        isReset: isReset,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
            onClick: (event)=>{
                event.stopPropagation();
            },
            className: "modal",
            variants: options,
            initial: "hidden",
            animate: "visible",
            ref: modalRef,
            exit: "exit",
            children: isReset ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4c0a24ed177b037c$export$2e2bcd8739ae039), {
                setIsActiveLoginPanel: setIsActiveLoginPanel,
                setIsReset: setIsReset
            }) : switchForm ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $77750a31733f055e$export$2e2bcd8739ae039), {
                setIsActiveLoginPanel: setIsActiveLoginPanel
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86c9ca7c8be96c3$export$2e2bcd8739ae039), {
                setIsActiveLoginPanel: setIsActiveLoginPanel
            })
        })
    });
}
var $02c63cf7f567bd0d$export$2e2bcd8739ae039 = $02c63cf7f567bd0d$var$Modal;



var $a85b7140712e1610$exports = {};

$a85b7140712e1610$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "logo.3dadcef5.svg";




function $37be56838633f7f9$var$Nav() {
    const [isActiveLoginPanel, setIsActiveLoginPanel] = (0, $6cds3.useState)(false);
    const [isActiveSideNav, setIsActiveSideNav] = (0, $6cds3.useState)(false);
    const [isOpenSearchBar, setIsOpenSearchBar] = (0, $6cds3.useState)(false);
    const [toggleButton, setToggleButton] = (0, $6cds3.useState)(false);
    const [cartQuantity, setCartQuantity] = (0, $6cds3.useState)(0);
    const [searchValue, setSearchValue] = (0, $6cds3.useState)("");
    const [isReset, setIsReset] = (0, $6cds3.useState)(false);
    const sideNavRef = (0, $6cds3.useRef)(null);
    const buttonRef = (0, $6cds3.useRef)(null);
    const [cart, setCart] = (0, $38a3408ff9214f5d$export$86e2cef2561044ac)("cart", {});
    const logout = (0, $775be0450cc3470d$export$9a5b97a7aba1a585)();
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const { auth: auth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    const location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    (0, $6cds3.useEffect)(()=>{
        if (location.pathname.startsWith("/reset-password")) {
            setIsActiveLoginPanel(true);
            setIsReset(true);
        } else setIsActiveLoginPanel(false);
    }, [
        location.pathname
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (isActiveSideNav) (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(sideNavRef);
        else {
            (0, $3b4e05b540ea4d30$export$e5d0524c3725571e)(sideNavRef);
            setToggleButton(false);
        }
    }, [
        isActiveSideNav
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (isOpenSearchBar) (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(sideNavRef);
        else {
            (0, $3b4e05b540ea4d30$export$e5d0524c3725571e)(sideNavRef);
            setToggleButton(false);
        }
    }, [
        isOpenSearchBar
    ]);
    (0, $6cds3.useEffect)(()=>{
        let quantity = 0;
        for(const item in cart)quantity += Number(cart[item].quantity);
        setCartQuantity(quantity);
    }, [
        cart
    ]);
    const logoutHandler = async ()=>{
        await logout();
        navigate("/");
    };
    const profileHandler = ()=>{
        if (!auth.token) setIsActiveLoginPanel(true);
    };
    const searchHandler = ()=>{
        let searchParam = searchValue.trim().replaceAll(" ", "+").toLowerCase();
        if (searchParam) navigate(`/search/${searchParam}`);
    };
    const openSidePanel = (panel)=>{
        if (panel === "nav") setIsActiveSideNav(!isActiveSideNav);
        else if (panel === "search") setIsOpenSearchBar(!isOpenSearchBar);
        setToggleButton(!toggleButton);
    };
    const optionsSideNav = {
        initial: {
            x: "-100vw"
        },
        shown: {
            x: "0",
            transition: {
                staggerChildren: 0.08,
                type: "ease"
            }
        },
        closed: {
            x: "-100vw"
        }
    };
    const item = {
        initial: {
            x: "-100vw"
        },
        shown: {
            x: "0vw",
            transition: {
                type: "ease"
            }
        },
        closed: {
            x: "-100vw"
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $35bf9e9aed03b88e$export$3ae376d12526dd6f), {
                children: [
                    isActiveSideNav && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a343d3e7a310970f$export$2e2bcd8739ae039), {
                        setIsActive: setIsActiveSideNav,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).aside, {
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            className: "aside-nav",
                            variants: optionsSideNav,
                            ref: sideNavRef,
                            initial: "initial",
                            transition: {
                                type: "ease"
                            },
                            animate: "shown",
                            exit: "closed",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                className: "aside-nav__content",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "aside-nav__logo-wrap",
                                        variants: item,
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            onClick: ()=>{
                                                setIsActiveSideNav(!isActiveSideNav);
                                            },
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "aside-nav__logo",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a85b7140712e1610$exports))),
                                                alt: "Logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "aside-nav__underline",
                                        variants: item
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "nav__mobile",
                                        variants: item,
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                                            className: "nav__mobile-list",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                    to: "/stock/men",
                                                    onClick: ()=>{
                                                        setIsActiveSideNav(!isActiveSideNav);
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav__mobile-item",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "nav__mobile-content",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                    className: "nav__mobile-p",
                                                                    children: "Men"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    className: "nav_mobile-arrow",
                                                                    src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                                    alt: "Arrow icon"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                    to: "/stock/women",
                                                    onClick: ()=>{
                                                        setIsActiveSideNav(!isActiveSideNav);
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav__mobile-item",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "nav__mobile-content",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                    className: "nav__mobile-p",
                                                                    children: "Women"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    className: "nav_mobile-arrow",
                                                                    src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                                    alt: "Arrow icon"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                    to: "/stock/kids",
                                                    onClick: ()=>{
                                                        setIsActiveSideNav(!isActiveSideNav);
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav__mobile-item",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "nav__mobile-content",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                    className: "nav__mobile-p",
                                                                    children: "Kids"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    className: "nav_mobile-arrow",
                                                                    src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                                    alt: "Arrow icon"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "nav__mobile",
                                        variants: item,
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                                            className: "nav__mobile-list",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                    to: "/profile",
                                                    onClick: ()=>{
                                                        setIsActiveSideNav(!isActiveSideNav);
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav__mobile-item",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "nav__mobile-content",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                    className: "nav__mobile-p",
                                                                    children: "Profile"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    className: "nav_mobile-arrow",
                                                                    src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                                    alt: "Arrow icon"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                    to: "/favourites",
                                                    onClick: ()=>{
                                                        setIsActiveSideNav(!isActiveSideNav);
                                                    },
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav__mobile-item",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "nav__mobile-content",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                    className: "nav__mobile-p",
                                                                    children: "Favourites"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    className: "nav_mobile-arrow",
                                                                    src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                                    alt: "Arrow icon"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "nav__mobile",
                                        variants: item,
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                                            className: "nav__mobile-list",
                                            children: auth.token ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                className: "nav__mobile-item",
                                                onClick: logoutHandler,
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "nav__mobile-content",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                            className: "nav__mobile-p",
                                                            children: "Logout"
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                            className: "nav_mobile-arrow",
                                                            src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                            alt: "Arrow icon"
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                className: "nav__mobile-item",
                                                onClick: ()=>{
                                                    setIsActiveSideNav(!isActiveSideNav);
                                                    setIsActiveLoginPanel(!isActiveLoginPanel);
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "nav__mobile-content",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                            className: "nav__mobile-p",
                                                            children: "Login / Register"
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                            className: "nav_mobile-arrow",
                                                            src: $c35849160b22084d$export$f2120bbfa5450bd2,
                                                            alt: "Arrow icon"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    isOpenSearchBar && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a343d3e7a310970f$export$2e2bcd8739ae039), {
                        setIsActive: setIsOpenSearchBar,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).aside, {
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            className: "aside-nav",
                            style: {
                                width: "100vw"
                            },
                            variants: optionsSideNav,
                            ref: sideNavRef,
                            initial: "initial",
                            animate: "shown",
                            exit: "closed",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                className: "nav__search-container--side",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "nav__close--wrap",
                                        variants: item,
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                            className: "nav__burger opened nav__side--close",
                                            ref: buttonRef,
                                            onClick: (e)=>{
                                                setIsOpenSearchBar(!isOpenSearchBar);
                                                setToggleButton(false);
                                            },
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                                                width: "25",
                                                height: "25",
                                                viewBox: "0 0 100 100",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                        className: "line line1",
                                                        d: "M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                        className: "line line2",
                                                        d: "M 20,50 H 80"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                        className: "line line3",
                                                        d: "M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9aca5855743a2e6f$export$e25e478948902b8b).div, {
                                        className: "nav__search-wrap",
                                        variants: item,
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                className: "nav__search-input nav__search-input--side",
                                                type: "text",
                                                value: searchValue,
                                                onChange: (event)=>{
                                                    setSearchValue(event.target.value);
                                                },
                                                onKeyDown: (event)=>{
                                                    if (event.key === "Enter") {
                                                        searchHandler();
                                                        setToggleButton(!toggleButton);
                                                        setIsOpenSearchBar(!isOpenSearchBar);
                                                    }
                                                },
                                                placeholder: "Search"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    searchHandler();
                                                    setToggleButton(!toggleButton);
                                                    setIsOpenSearchBar(!isOpenSearchBar);
                                                },
                                                className: "nav__button nav__button--search",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "nav__icon nav__icon--search",
                                                    src: $c35849160b22084d$export$d76128d007d19019,
                                                    alt: "Search"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
                className: "nav",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "nav__container",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            className: `nav__burger ${toggleButton ? "opened" : " "} `,
                            ref: buttonRef,
                            onClick: (e)=>{
                                if (isOpenSearchBar) openSidePanel("search");
                                else openSidePanel("nav");
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                                width: "25",
                                height: "25",
                                viewBox: "0 0 100 100",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                        className: "line line1",
                                        d: "M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                        className: "line line2",
                                        d: "M 20,50 H 80"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                        className: "line line3",
                                        d: "M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                            className: "nav__menu",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: "/stock/men",
                                    className: "nav__menu-link",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                        className: "nav__menu-item",
                                        children: "Men"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: "/stock/women",
                                    className: "nav__menu-link",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                        className: "nav__menu-item",
                                        children: "Women"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: "/stock/kids",
                                    className: "nav__menu-link",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                        className: "nav__menu-item",
                                        children: "Kids"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: "nav__logo",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                className: "nav__logo",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a85b7140712e1610$exports))),
                                alt: "Logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "nav__icons",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "nav__search-wrap nav__search-wrap--hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            className: "nav__search-input",
                                            type: "text",
                                            value: searchValue,
                                            onChange: (event)=>{
                                                setSearchValue(event.target.value);
                                            },
                                            onKeyDown: (event)=>{
                                                if (event.key === "Enter") searchHandler();
                                            },
                                            placeholder: "Search"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                            onClick: searchHandler,
                                            className: "nav__button nav__button--search",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "nav__icon nav__icon--search",
                                                src: $c35849160b22084d$export$d76128d007d19019,
                                                alt: "Search"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "nav__search-wrap--mobile",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        onClick: ()=>{
                                            openSidePanel("search");
                                        },
                                        className: "nav__button nav__button--search",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "nav__icon nav__icon--search",
                                            src: $c35849160b22084d$export$d76128d007d19019,
                                            alt: "Search"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    className: "nav__button nav__button-heart",
                                    onClick: ()=>navigate("/favourites"),
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        className: "nav__icon",
                                        src: $c35849160b22084d$export$d658018a9147579e,
                                        alt: "Favourites button"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                    className: "nav__button",
                                    onClick: ()=>navigate("/cart"),
                                    children: [
                                        Object.keys(cart).length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "nav__cart--number",
                                            children: Object.keys(cart).length > 0 ? cartQuantity : ""
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "nav__icon",
                                            src: $c35849160b22084d$export$ecf8513b200c5cc6,
                                            alt: "Shopping cart button"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    className: "nav__button nav__button-profile",
                                    onClick: profileHandler,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        className: "nav__icon",
                                        src: auth.token.length ? $c35849160b22084d$export$acffd473e57081cc : $c35849160b22084d$export$345c5736c8054f22,
                                        alt: "Avatar button"
                                    })
                                }),
                                auth.token ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "nav__dropdown",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "dropdown__links",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile",
                                                className: "dropdown__link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Profile"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/favourites",
                                                className: "dropdown__link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Favourites"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/orders",
                                                className: "dropdown__link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Orders"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/settings",
                                                className: "dropdown__link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Settings"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                className: "dropdown__logout",
                                                onClick: logoutHandler,
                                                children: "Logout"
                                            })
                                        ]
                                    })
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $35bf9e9aed03b88e$export$3ae376d12526dd6f), {
                            children: isActiveLoginPanel && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $587b42263799c6ca$export$ac2a972d23ebc682), {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $02c63cf7f567bd0d$export$2e2bcd8739ae039), {
                                    isActiveLoginPanel: isActiveLoginPanel,
                                    setIsActiveLoginPanel: setIsActiveLoginPanel,
                                    isReset: isReset,
                                    setIsReset: setIsReset
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $37be56838633f7f9$export$2e2bcd8739ae039 = $37be56838633f7f9$var$Nav;





var $e0532d8d0a9557f5$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $e0532d8d0a9557f5$export$18a094aefa070634 = (obj, member, getter)=>{
    $e0532d8d0a9557f5$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $e0532d8d0a9557f5$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $e0532d8d0a9557f5$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $e0532d8d0a9557f5$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $e0532d8d0a9557f5$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $e0532d8d0a9557f5$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $e0532d8d0a9557f5$export$18a094aefa070634(obj, member, getter);
        }
    });
var $e0532d8d0a9557f5$export$fa92d15b718fce20 = (obj, member, method)=>{
    $e0532d8d0a9557f5$var$__accessCheck(obj, member, "access private method");
    return method;
};




// src/subscribable.ts
var $2bdd4a402e6e5ce5$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



// src/utils.ts
var $96e46b4f8c8392c0$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $96e46b4f8c8392c0$export$8793edee2d425525() {
    return void 0;
}
function $96e46b4f8c8392c0$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $96e46b4f8c8392c0$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $96e46b4f8c8392c0$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $96e46b4f8c8392c0$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $96e46b4f8c8392c0$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $96e46b4f8c8392c0$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $96e46b4f8c8392c0$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$96e46b4f8c8392c0$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $96e46b4f8c8392c0$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($96e46b4f8c8392c0$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $96e46b4f8c8392c0$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$96e46b4f8c8392c0$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $96e46b4f8c8392c0$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $96e46b4f8c8392c0$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $96e46b4f8c8392c0$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$96e46b4f8c8392c0$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $96e46b4f8c8392c0$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$96e46b4f8c8392c0$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $96e46b4f8c8392c0$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $96e46b4f8c8392c0$export$7a8558113332b71e(a) && $96e46b4f8c8392c0$export$7a8558113332b71e(b);
    if (array || $96e46b4f8c8392c0$export$53b83ca8eaab0383(a) && $96e46b4f8c8392c0$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $96e46b4f8c8392c0$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $96e46b4f8c8392c0$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $96e46b4f8c8392c0$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $96e46b4f8c8392c0$export$53b83ca8eaab0383(o) {
    if (!$96e46b4f8c8392c0$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$96e46b4f8c8392c0$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $96e46b4f8c8392c0$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $96e46b4f8c8392c0$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $96e46b4f8c8392c0$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $96e46b4f8c8392c0$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $96e46b4f8c8392c0$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $96e46b4f8c8392c0$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $96e46b4f8c8392c0$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $96e46b4f8c8392c0$export$1aa5a89531b7670d = Symbol();
function $96e46b4f8c8392c0$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $96e46b4f8c8392c0$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}


var $6baa0e82ffe3e9b9$var$_focused, $6baa0e82ffe3e9b9$var$_cleanup, $6baa0e82ffe3e9b9$var$_setup;
var $6baa0e82ffe3e9b9$export$86f1af424b2ca4de = class extends (0, $2bdd4a402e6e5ce5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $6baa0e82ffe3e9b9$var$_focused, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $6baa0e82ffe3e9b9$var$_cleanup, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $6baa0e82ffe3e9b9$var$_setup, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $6baa0e82ffe3e9b9$var$_setup, (onFocus)=>{
            if (!(0, $96e46b4f8c8392c0$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_cleanup)) this.setEventListener((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_cleanup)) == null || _a.call(this);
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $6baa0e82ffe3e9b9$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $6baa0e82ffe3e9b9$var$_setup, setup);
        (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_cleanup)) == null || _a.call(this);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $6baa0e82ffe3e9b9$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_focused) !== focused;
        if (changed) {
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $6baa0e82ffe3e9b9$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_focused) === "boolean") return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $6baa0e82ffe3e9b9$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$6baa0e82ffe3e9b9$var$_focused = new WeakMap();
$6baa0e82ffe3e9b9$var$_cleanup = new WeakMap();
$6baa0e82ffe3e9b9$var$_setup = new WeakMap();
var $6baa0e82ffe3e9b9$export$6bf54661be5b02cf = new $6baa0e82ffe3e9b9$export$86f1af424b2ca4de();



// src/notifyManager.ts
function $5d35a9f3710b2512$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $5d35a9f3710b2512$export$520687f44db6e1ab = $5d35a9f3710b2512$export$316a8efd03cd1458();










var $97f19485168d5510$var$_online, $97f19485168d5510$var$_cleanup, $97f19485168d5510$var$_setup;
var $97f19485168d5510$export$58774fb55d5ff7fc = class extends (0, $2bdd4a402e6e5ce5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $97f19485168d5510$var$_online, true);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $97f19485168d5510$var$_cleanup, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $97f19485168d5510$var$_setup, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $97f19485168d5510$var$_setup, (onOnline)=>{
            if (!(0, $96e46b4f8c8392c0$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_cleanup)) this.setEventListener((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_cleanup)) == null || _a.call(this);
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $97f19485168d5510$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $97f19485168d5510$var$_setup, setup);
        (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_cleanup)) == null || _a.call(this);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $97f19485168d5510$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_online) !== online;
        if (changed) {
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $97f19485168d5510$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $97f19485168d5510$var$_online);
    }
};
$97f19485168d5510$var$_online = new WeakMap();
$97f19485168d5510$var$_cleanup = new WeakMap();
$97f19485168d5510$var$_setup = new WeakMap();
var $97f19485168d5510$export$b113e788b2dd3fdc = new $97f19485168d5510$export$58774fb55d5ff7fc();



// src/thenable.ts
function $e8449c40fd9ca86c$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}



function $e2683b672d9da063$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e2683b672d9da063$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $97f19485168d5510$export$b113e788b2dd3fdc).isOnline() : true;
}
var $e2683b672d9da063$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e2683b672d9da063$export$986cc6445c1d323(value) {
    return value instanceof $e2683b672d9da063$export$a8430ed4188f35a9;
}
function $e2683b672d9da063$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $e8449c40fd9ca86c$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $e2683b672d9da063$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $6baa0e82ffe3e9b9$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $97f19485168d5510$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$e2683b672d9da063$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $96e46b4f8c8392c0$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e2683b672d9da063$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $96e46b4f8c8392c0$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}




var $0403a4a3b9013de6$var$_gcTimeout;
var $0403a4a3b9013de6$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $0403a4a3b9013de6$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $96e46b4f8c8392c0$export$e539f754e934e270)(this.gcTime)) (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0403a4a3b9013de6$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $96e46b4f8c8392c0$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0403a4a3b9013de6$var$_gcTimeout)) {
            clearTimeout((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0403a4a3b9013de6$var$_gcTimeout));
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0403a4a3b9013de6$var$_gcTimeout, void 0);
        }
    }
};
$0403a4a3b9013de6$var$_gcTimeout = new WeakMap();


var $e434149c2a85bd85$var$_initialState, $e434149c2a85bd85$var$_revertState, $e434149c2a85bd85$var$_cache, $e434149c2a85bd85$var$_retryer, $e434149c2a85bd85$var$_defaultOptions, $e434149c2a85bd85$var$_abortSignalConsumed, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn;
var $e434149c2a85bd85$export$62297b13309008b2 = class extends (0, $0403a4a3b9013de6$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_dispatch);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_initialState, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_revertState, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_cache, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_retryer, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_defaultOptions, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $e434149c2a85bd85$var$_abortSignalConsumed, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_abortSignalConsumed, false);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_initialState, $e434149c2a85bd85$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $96e46b4f8c8392c0$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $96e46b4f8c8392c0$export$8793edee2d425525)).catch((0, $96e46b4f8c8392c0$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $96e46b4f8c8392c0$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $96e46b4f8c8392c0$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) {
                    if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_abortSignalConsumed)) (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer)) {
                (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer).continueRetry();
                return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $96e46b4f8c8392c0$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $e2683b672d9da063$export$986cc6445c1d323)(error) && error.silent)) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $e2683b672d9da063$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            this.scheduleGc();
        };
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $e434149c2a85bd85$var$_retryer, (0, $e2683b672d9da063$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $e434149c2a85bd85$var$_dispatch, $e434149c2a85bd85$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_retryer).start();
    }
};
$e434149c2a85bd85$var$_initialState = new WeakMap();
$e434149c2a85bd85$var$_revertState = new WeakMap();
$e434149c2a85bd85$var$_cache = new WeakMap();
$e434149c2a85bd85$var$_retryer = new WeakMap();
$e434149c2a85bd85$var$_defaultOptions = new WeakMap();
$e434149c2a85bd85$var$_abortSignalConsumed = new WeakMap();
$e434149c2a85bd85$var$_dispatch = new WeakSet();
$e434149c2a85bd85$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$e434149c2a85bd85$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $e2683b672d9da063$export$986cc6445c1d323)(error) && error.revert && (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_revertState)) return {
                    ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $e434149c2a85bd85$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $e434149c2a85bd85$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $e2683b672d9da063$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $e434149c2a85bd85$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}





var $c9b2e87c81c45f80$var$_client, $c9b2e87c81c45f80$var$_currentQuery, $c9b2e87c81c45f80$var$_currentQueryInitialState, $c9b2e87c81c45f80$var$_currentResult, $c9b2e87c81c45f80$var$_currentResultState, $c9b2e87c81c45f80$var$_currentResultOptions, $c9b2e87c81c45f80$var$_currentThenable, $c9b2e87c81c45f80$var$_selectError, $c9b2e87c81c45f80$var$_selectFn, $c9b2e87c81c45f80$var$_selectResult, $c9b2e87c81c45f80$var$_lastQueryWithDefinedData, $c9b2e87c81c45f80$var$_staleTimeoutId, $c9b2e87c81c45f80$var$_refetchIntervalId, $c9b2e87c81c45f80$var$_currentRefetchInterval, $c9b2e87c81c45f80$var$_trackedProps, $c9b2e87c81c45f80$var$_executeFetch, $c9b2e87c81c45f80$var$executeFetch_fn, $c9b2e87c81c45f80$var$_updateStaleTimeout, $c9b2e87c81c45f80$var$updateStaleTimeout_fn, $c9b2e87c81c45f80$var$_computeRefetchInterval, $c9b2e87c81c45f80$var$computeRefetchInterval_fn, $c9b2e87c81c45f80$var$_updateRefetchInterval, $c9b2e87c81c45f80$var$updateRefetchInterval_fn, $c9b2e87c81c45f80$var$_updateTimers, $c9b2e87c81c45f80$var$updateTimers_fn, $c9b2e87c81c45f80$var$_clearStaleTimeout, $c9b2e87c81c45f80$var$clearStaleTimeout_fn, $c9b2e87c81c45f80$var$_clearRefetchInterval, $c9b2e87c81c45f80$var$clearRefetchInterval_fn, $c9b2e87c81c45f80$var$_updateQuery, $c9b2e87c81c45f80$var$updateQuery_fn, $c9b2e87c81c45f80$var$_notify, $c9b2e87c81c45f80$var$notify_fn;
var $c9b2e87c81c45f80$export$a06cf8c0066f0d4c = class extends (0, $2bdd4a402e6e5ce5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_executeFetch);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_updateStaleTimeout);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_computeRefetchInterval);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_updateRefetchInterval);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_updateTimers);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_clearStaleTimeout);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_clearRefetchInterval);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_updateQuery);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_notify);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_client, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentQuery, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentQueryInitialState, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentResult, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentResultState, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentResultOptions, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentThenable, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_selectError, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_selectFn, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_lastQueryWithDefinedData, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_staleTimeoutId, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_refetchIntervalId, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $c9b2e87c81c45f80$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_client, client);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectError, null);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentThenable, (0, $e8449c40fd9ca86c$export$d54630db02a12b72)());
        if (!this.options.experimental_prefetchInRender) (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).addObserver(this);
            if ($c9b2e87c81c45f80$var$shouldFetchOnMount((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery), this.options)) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_executeFetch, $c9b2e87c81c45f80$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateTimers, $c9b2e87c81c45f80$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $c9b2e87c81c45f80$var$shouldFetchOn((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $c9b2e87c81c45f80$var$shouldFetchOn((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_clearStaleTimeout, $c9b2e87c81c45f80$var$clearStaleTimeout_fn).call(this);
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_clearRefetchInterval, $c9b2e87c81c45f80$var$clearRefetchInterval_fn).call(this);
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery);
        this.options = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(this.options.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateQuery, $c9b2e87c81c45f80$var$updateQuery_fn).call(this);
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $96e46b4f8c8392c0$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $c9b2e87c81c45f80$var$shouldFetchOptionally((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_executeFetch, $c9b2e87c81c45f80$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery) !== prevQuery || (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(this.options.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) !== (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) || (0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(this.options.staleTime, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) !== (0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)))) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateStaleTimeout, $c9b2e87c81c45f80$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_computeRefetchInterval, $c9b2e87c81c45f80$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery) !== prevQuery || (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(this.options.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) !== (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) || nextRefetchInterval !== (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval))) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateRefetchInterval, $c9b2e87c81c45f80$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).getQueryCache().build((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client), options);
        const result = this.createResult(query, options);
        if ($c9b2e87c81c45f80$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResult, result);
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResultOptions, this.options);
            (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResultState, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).defaultQueryOptions(options);
        const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).getQueryCache().build((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_executeFetch, $c9b2e87c81c45f80$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult);
        const prevResultState = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResultState);
        const prevResultOptions = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $c9b2e87c81c45f80$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $c9b2e87c81c45f80$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $e434149c2a85bd85$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_selectFn)) data = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_selectResult);
            else try {
                (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $96e46b4f8c8392c0$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectResult, data);
                (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectError, null);
            } catch (selectError) {
                (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectError, null);
                } catch (selectError) {
                    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $96e46b4f8c8392c0$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_selectError)) {
            error = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_selectError);
            data = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $c9b2e87c81c45f80$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentThenable)
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentThenable, nextResult.promise = (0, $e8449c40fd9ca86c$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult);
        const nextResult = this.createResult((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery), this.options);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResultState, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).state);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResultOptions, this.options);
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResultState).data !== void 0) (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_lastQueryWithDefinedData, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery));
        if ((0, $96e46b4f8c8392c0$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_notify, $c9b2e87c81c45f80$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateTimers, $c9b2e87c81c45f80$var$updateTimers_fn).call(this);
    }
};
$c9b2e87c81c45f80$var$_client = new WeakMap();
$c9b2e87c81c45f80$var$_currentQuery = new WeakMap();
$c9b2e87c81c45f80$var$_currentQueryInitialState = new WeakMap();
$c9b2e87c81c45f80$var$_currentResult = new WeakMap();
$c9b2e87c81c45f80$var$_currentResultState = new WeakMap();
$c9b2e87c81c45f80$var$_currentResultOptions = new WeakMap();
$c9b2e87c81c45f80$var$_currentThenable = new WeakMap();
$c9b2e87c81c45f80$var$_selectError = new WeakMap();
$c9b2e87c81c45f80$var$_selectFn = new WeakMap();
$c9b2e87c81c45f80$var$_selectResult = new WeakMap();
$c9b2e87c81c45f80$var$_lastQueryWithDefinedData = new WeakMap();
$c9b2e87c81c45f80$var$_staleTimeoutId = new WeakMap();
$c9b2e87c81c45f80$var$_refetchIntervalId = new WeakMap();
$c9b2e87c81c45f80$var$_currentRefetchInterval = new WeakMap();
$c9b2e87c81c45f80$var$_trackedProps = new WeakMap();
$c9b2e87c81c45f80$var$_executeFetch = new WeakSet();
$c9b2e87c81c45f80$var$executeFetch_fn = function(fetchOptions) {
    (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateQuery, $c9b2e87c81c45f80$var$updateQuery_fn).call(this);
    let promise = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $96e46b4f8c8392c0$export$8793edee2d425525));
    return promise;
};
$c9b2e87c81c45f80$var$_updateStaleTimeout = new WeakSet();
$c9b2e87c81c45f80$var$updateStaleTimeout_fn = function() {
    (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_clearStaleTimeout, $c9b2e87c81c45f80$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(this.options.staleTime, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery));
    if ((0, $96e46b4f8c8392c0$export$6acf61af03e62db) || (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult).isStale || !(0, $96e46b4f8c8392c0$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $96e46b4f8c8392c0$export$811b83d62bcf47f0)((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$c9b2e87c81c45f80$var$_computeRefetchInterval = new WeakSet();
$c9b2e87c81c45f80$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$c9b2e87c81c45f80$var$_updateRefetchInterval = new WeakSet();
$c9b2e87c81c45f80$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_clearRefetchInterval, $c9b2e87c81c45f80$var$clearRefetchInterval_fn).call(this);
    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval, nextInterval);
    if ((0, $96e46b4f8c8392c0$export$6acf61af03e62db) || (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(this.options.enabled, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) === false || !(0, $96e46b4f8c8392c0$export$e539f754e934e270)((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval)) || (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval) === 0) return;
    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $6baa0e82ffe3e9b9$export$6bf54661be5b02cf).isFocused()) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_executeFetch, $c9b2e87c81c45f80$var$executeFetch_fn).call(this);
    }, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentRefetchInterval)));
};
$c9b2e87c81c45f80$var$_updateTimers = new WeakSet();
$c9b2e87c81c45f80$var$updateTimers_fn = function() {
    (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateStaleTimeout, $c9b2e87c81c45f80$var$updateStaleTimeout_fn).call(this);
    (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_updateRefetchInterval, $c9b2e87c81c45f80$var$updateRefetchInterval_fn).call(this, (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $c9b2e87c81c45f80$var$_computeRefetchInterval, $c9b2e87c81c45f80$var$computeRefetchInterval_fn).call(this));
};
$c9b2e87c81c45f80$var$_clearStaleTimeout = new WeakSet();
$c9b2e87c81c45f80$var$clearStaleTimeout_fn = function() {
    if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_staleTimeoutId)) {
        clearTimeout((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_staleTimeoutId));
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_staleTimeoutId, void 0);
    }
};
$c9b2e87c81c45f80$var$_clearRefetchInterval = new WeakSet();
$c9b2e87c81c45f80$var$clearRefetchInterval_fn = function() {
    if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_refetchIntervalId)) {
        clearInterval((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_refetchIntervalId));
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_refetchIntervalId, void 0);
    }
};
$c9b2e87c81c45f80$var$_updateQuery = new WeakSet();
$c9b2e87c81c45f80$var$updateQuery_fn = function() {
    const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).getQueryCache().build((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client), this.options);
    if (query === (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery)) return;
    const prevQuery = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery);
    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentQuery, query);
    (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $c9b2e87c81c45f80$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$c9b2e87c81c45f80$var$_notify = new WeakSet();
$c9b2e87c81c45f80$var$notify_fn = function(notifyOptions) {
    (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentResult));
        });
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_client).getQueryCache().notify({
            query: (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $c9b2e87c81c45f80$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $c9b2e87c81c45f80$var$shouldLoadOnMount(query, options) {
    return (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $c9b2e87c81c45f80$var$shouldFetchOnMount(query, options) {
    return $c9b2e87c81c45f80$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $c9b2e87c81c45f80$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $c9b2e87c81c45f80$var$shouldFetchOn(query, options, field) {
    if ((0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $c9b2e87c81c45f80$var$isStale(query, options);
    }
    return false;
}
function $c9b2e87c81c45f80$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $c9b2e87c81c45f80$var$isStale(query, options);
}
function $c9b2e87c81c45f80$var$isStale(query, options) {
    return (0, $96e46b4f8c8392c0$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $c9b2e87c81c45f80$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $96e46b4f8c8392c0$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

"use client";
var $03084753dc39ab74$export$da112d31b0149f31 = $6cds3.createContext(void 0);
var $03084753dc39ab74$export$22e77b9572c4fded = (queryClient)=>{
    const client = $6cds3.useContext($03084753dc39ab74$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $03084753dc39ab74$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $6cds3.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($03084753dc39ab74$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $6cds3 = parcelRequire("6cds3");

"use client";
function $a6328341275426c2$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $a6328341275426c2$var$QueryErrorResetBoundaryContext = $6cds3.createContext($a6328341275426c2$var$createValue());
var $a6328341275426c2$export$50dfac555130cafd = ()=>$6cds3.useContext($a6328341275426c2$var$QueryErrorResetBoundaryContext);
var $a6328341275426c2$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $6cds3.useState(()=>$a6328341275426c2$var$createValue());
    return /* @__PURE__ */ (0, $fba0f23e9e6a11bb$exports.jsx)($a6328341275426c2$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $6cds3 = parcelRequire("6cds3");
// src/utils.ts
function $e59130a3f3aaa0f4$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $e59130a3f3aaa0f4$export$8793edee2d425525() {}


"use client";
var $59b50d57e17405de$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $59b50d57e17405de$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $6cds3.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $59b50d57e17405de$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $e59130a3f3aaa0f4$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};



var $6cds3 = parcelRequire("6cds3");
"use client";
var $01805541a5bdaf82$var$IsRestoringContext = $6cds3.createContext(false);
var $01805541a5bdaf82$export$4da0178d6b5f553 = ()=>$6cds3.useContext($01805541a5bdaf82$var$IsRestoringContext);
var $01805541a5bdaf82$export$593807d4e94f9621 = $01805541a5bdaf82$var$IsRestoringContext.Provider;


// src/suspense.ts
var $fef20b4412cd8be3$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $fef20b4412cd8be3$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (defaultedOptions.staleTime === void 0) defaultedOptions.staleTime = 1e3;
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $fef20b4412cd8be3$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $fef20b4412cd8be3$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $fef20b4412cd8be3$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



"use client";
function $2fb6130d25c5c367$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const client = (0, $03084753dc39ab74$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $01805541a5bdaf82$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $a6328341275426c2$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $fef20b4412cd8be3$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $59b50d57e17405de$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $59b50d57e17405de$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $6cds3.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $6cds3.useSyncExternalStore($6cds3.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $5d35a9f3710b2512$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $6cds3.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $fef20b4412cd8be3$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $fef20b4412cd8be3$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $59b50d57e17405de$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $96e46b4f8c8392c0$export$6acf61af03e62db) && (0, $fef20b4412cd8be3$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $fef20b4412cd8be3$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $e59130a3f3aaa0f4$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $8c81402e2b240f7d$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $2fb6130d25c5c367$export$fff0865807e996c5)(options, (0, $c9b2e87c81c45f80$export$a06cf8c0066f0d4c), queryClient);
}


var $a862c984cf1c01c0$exports = {};

$a862c984cf1c01c0$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "Air-Jordan-4-Seafoam-AQ9129-103-04.6020dc6a.jpg";



function $9d53e9399f65a2ff$var$HomePage() {
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const { data: sneakerData = [] } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "sneakerData",
            "featured"
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$8134c072fddab6a5)()
    });
    const { data: bestsellersData = [] } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "sneakerData",
            "bestsellers"
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$8bd21d103ad1522b)()
    });
    const detailedViewHandler = (id)=>{
        navigate(`/items/${id}`);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "home__container",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "home__banner"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "home__new",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                        children: "Freshly added"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "home__tiles",
                        children: sneakerData.map((element)=>{
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                onClick: ()=>{
                                    detailedViewHandler(element._id);
                                },
                                className: "home__tile",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "home__image-wrap",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "home__sneaker-image",
                                            src: element.img,
                                            alt: "Sneaker preview"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: element.name
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: element.price
                                    })
                                ]
                            }, element._id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "home__coming",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                        children: "Coming soon"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "home__coming-content",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: "AIR JORDAN 4"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                className: "home__coming-image",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a862c984cf1c01c0$exports))),
                                alt: "Coming soon sneaker"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: "SEA FOAM"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "home__bestsellers",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                        children: "Bestsellers"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "home__tiles",
                        children: bestsellersData.map((element)=>{
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                onClick: ()=>{
                                    detailedViewHandler(element._id);
                                },
                                className: "home__tile",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "home__image-wrap",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "home__sneaker-image",
                                            src: element.img,
                                            alt: "Sneaker preview"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: element.name
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: element.price
                                    })
                                ]
                            }, element._id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$910ae8079b2c2852), {})
        ]
    });
}
var $9d53e9399f65a2ff$export$2e2bcd8739ae039 = $9d53e9399f65a2ff$var$HomePage;





var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
class $c72c7bc7645a2629$export$b9721ef022f71a68 extends Error {
}
$c72c7bc7645a2629$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $c72c7bc7645a2629$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $c72c7bc7645a2629$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $c72c7bc7645a2629$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $c72c7bc7645a2629$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $c72c7bc7645a2629$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $c72c7bc7645a2629$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $c72c7bc7645a2629$var$base64UrlDecode(part);
    } catch (e) {
        throw new $c72c7bc7645a2629$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $c72c7bc7645a2629$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}





var $a568370b823db503$exports = {};

$a568370b823db503$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "avatar.acc0e891.svg";


const $4dc90d0483af932c$var$defaultUserInfo = {
    name: "Admin",
    surname: "Adminowski",
    email: "admin@gmail.com",
    profilePicture: (0, (/*@__PURE__*/$parcel$interopDefault($a568370b823db503$exports)))
};
const $4dc90d0483af932c$export$6a3407924052ab65 = /*#__PURE__*/ (0, $6cds3.createContext)({
    userData: $4dc90d0483af932c$var$defaultUserInfo,
    setUserData: ()=>{}
});
const $4dc90d0483af932c$export$951f08dc7fcffbbe = ({ children: children })=>{
    const { auth: auth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    const [userData, setUserData] = (0, $6cds3.useState)($4dc90d0483af932c$var$defaultUserInfo);
    const { id: id } = (0, $c72c7bc7645a2629$export$fa1e2fb699b7861e)(auth.token);
    const { data: data } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "userData",
            id
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$3f90b926bc531097)(id, auth.token),
        refetchOnWindowFocus: false
    });
    (0, $6cds3.useEffect)(()=>{
        if (data) setUserData(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($4dc90d0483af932c$export$6a3407924052ab65.Provider, {
        value: {
            userData: userData,
            setUserData: setUserData
        },
        children: children
    });
};


const $9412e09b930162b2$export$52a7e4f3f505b7fa = ()=>{
    return (0, $6cds3.useContext)((0, $4dc90d0483af932c$export$6a3407924052ab65));
};



const $d7f08636a42002bd$export$17b07c660794dc13 = (parcelRequire("aYv9L"));

const $d7f08636a42002bd$export$18f430e15f133060 = (parcelRequire("gyiKh"));

const $d7f08636a42002bd$export$d658018a9147579e = (parcelRequire("4izHh"));

const $d7f08636a42002bd$export$a5a6e0b888b2c992 = (parcelRequire("fo5QP"));

const $d7f08636a42002bd$export$52adb308ec5c4bb4 = (parcelRequire("cmHZg"));



function $c4024906b579fc24$var$Profile() {
    const { userData: userData } = (0, $9412e09b930162b2$export$52a7e4f3f505b7fa)();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "profile",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "profile__dashboard-wrap",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "profile__avatar",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "avatar__image-wrap",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "profile__avatar-img",
                                    src: userData.profilePicture,
                                    alt: "Profile picture"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "profile__name",
                                children: userData.name + " " + userData.surname
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "profile__action-box",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("h2", {
                                className: "profile__headline margin-bottom",
                                children: [
                                    "Hi, ",
                                    userData.name,
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "profile__with-us",
                                children: "With us since 2018!"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "profile__menu-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "profile__menu-item",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "profile__menu-img",
                                                src: $d7f08636a42002bd$export$17b07c660794dc13,
                                                alt: "Saved addresses"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/settings",
                                                className: "profile__menu-link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Saved addresses"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "profile__menu-item",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "profile__menu-img",
                                                src: $d7f08636a42002bd$export$52adb308ec5c4bb4,
                                                alt: "Orders"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/orders",
                                                className: "profile__menu-link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Orders"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "profile__menu-item",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "profile__menu-img",
                                                src: $d7f08636a42002bd$export$d658018a9147579e,
                                                alt: "Favourites"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/favourites",
                                                className: "profile__menu-link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Favourites"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "profile__menu-item",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "profile__menu-img",
                                                src: $d7f08636a42002bd$export$18f430e15f133060,
                                                alt: "Payment methods"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/settings",
                                                className: "profile__menu-link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Saved payment methods"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "profile__menu-item",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "profile__menu-img",
                                                src: $d7f08636a42002bd$export$a5a6e0b888b2c992,
                                                alt: "Settings"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/profile/settings",
                                                className: "profile__menu-link",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Settings"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "profile__last-orders",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                        className: "profile__headline",
                        children: "Last orders"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "profile__orders-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "profile__order"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "profile__order"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $c4024906b579fc24$export$2e2bcd8739ae039 = $c4024906b579fc24$var$Profile;





var $6cds3 = parcelRequire("6cds3");


parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

const $5daf4519c9d7de51$export$77124b5afc0389ab = (parcelRequire("9yd5C"));

const $5daf4519c9d7de51$export$79dd2d8976cc2062 = (parcelRequire("cUin7"));

const $5daf4519c9d7de51$export$3a92b3e185e77400 = (parcelRequire("4myvM"));

const $5daf4519c9d7de51$export$c7113aead8874e9f = (parcelRequire("f4cpI"));

const $5daf4519c9d7de51$export$f59d5eab15587ea7 = (parcelRequire("4DTTn"));

const $5daf4519c9d7de51$export$9183c26c73ae5683 = (parcelRequire("aHxV5"));

const $5daf4519c9d7de51$export$6a15347669230f6b = (parcelRequire("860s1"));

const $5daf4519c9d7de51$export$e98652cea9b09aa = (parcelRequire("iEFTJ"));

const $5daf4519c9d7de51$export$87453108c2dd3831 = (parcelRequire("XjDIu"));

const $5daf4519c9d7de51$export$c5552dfdbc7cec71 = (parcelRequire("dgvCr"));

const $5daf4519c9d7de51$export$f61feb65ec56823b = (parcelRequire("4IMgc"));



function $454da9c1f61206da$var$Collapsible(props) {
    const [isExpanded, setIsExpanded] = (0, $6cds3.useState)(false);
    const endDivRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        if (isExpanded) setTimeout(()=>{
            endDivRef.current?.scrollIntoView({
                behavior: "smooth"
            });
        }, 100);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "collapsible",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "collapsible__header",
                onClick: ()=>setIsExpanded(!isExpanded),
                children: [
                    props.title,
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: `collapsible__collapse-arrow ${isExpanded ? "collapsible__collapse-arrow--down" : "collapsible__collapse-arrow--up"}`,
                        src: $5daf4519c9d7de51$export$f61feb65ec56823b,
                        alt: "Arrow down"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                ref: endDivRef,
                className: `collapsible__content ${isExpanded ? "collapsible--expanded" : ""}`,
                children: props.children
            })
        ]
    });
}
var $454da9c1f61206da$export$2e2bcd8739ae039 = $454da9c1f61206da$var$Collapsible;




function $41d6a4e60e5858e7$var$FooterMobile() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "footer-mobile",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $454da9c1f61206da$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                    children: "Customer Service"
                }),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                    className: "footer-mobile__list",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "Size Guide"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "Order Tracking"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "Shipping & Delivery"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $454da9c1f61206da$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                    children: "About The Sneakers"
                }),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                    className: "footer-mobile__list",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "About Us"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                            children: "Careers"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $454da9c1f61206da$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                    children: "Socials"
                }),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "footer-mobile__socials",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$87453108c2dd3831,
                            alt: "Twitter"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$e98652cea9b09aa,
                            alt: "Facebook"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$6a15347669230f6b,
                            alt: "Instagram"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$9183c26c73ae5683,
                            alt: "TikTok"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $454da9c1f61206da$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                    children: "Join The Pack"
                }),
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: "Turn daily notifications via e-mail to be up to date with our freshly added sneakers."
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "footer-mobile__form",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                placeholder: "Enter your email"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "footer-mobile__button-icon",
                                    src: $5daf4519c9d7de51$export$c5552dfdbc7cec71,
                                    alt: "Sign into newsletter"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $454da9c1f61206da$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                    children: "Payments Methods"
                }),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "footer-mobile__payments",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$f59d5eab15587ea7,
                            alt: "Mastercard"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$c7113aead8874e9f,
                            alt: "Visa"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$77124b5afc0389ab,
                            alt: "Amex"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$79dd2d8976cc2062,
                            alt: "Apple Pay"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: $5daf4519c9d7de51$export$3a92b3e185e77400,
                            alt: "Pay Pall"
                        })
                    ]
                })
            })
        ]
    });
}
var $41d6a4e60e5858e7$export$2e2bcd8739ae039 = $41d6a4e60e5858e7$var$FooterMobile;




function $031e0d82e9f3387e$var$Footer() {
    const [width, setWidth] = (0, $6cds3.useState)(window.innerWidth);
    const [newsletter, setNewsletter] = (0, $6cds3.useState)("");
    (0, $6cds3.useEffect)(()=>{
        const handleWindowResize = ()=>{
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    const newsletterSubmit = async (event)=>{
        event.preventDefault();
        if (newsletter) await (0, $a9b114d4c5390c4c$export$2835898f2b1b1017)(newsletter);
        else return;
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: width > 776 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "footer",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "footer__main-row",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    children: "Customer Service"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                                    className: "footer__list",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "Size Guide"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "Order Tracking"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "Shipping & Delivery"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    children: "About The Sneakers"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ul", {
                                    className: "footer__list",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "About Us"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            children: "Careers"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    children: "Socials"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "footer__socials",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: $5daf4519c9d7de51$export$87453108c2dd3831,
                                            alt: "Twitter"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: $5daf4519c9d7de51$export$e98652cea9b09aa,
                                            alt: "Facebook"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: $5daf4519c9d7de51$export$6a15347669230f6b,
                                            alt: "Instagram"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: $5daf4519c9d7de51$export$9183c26c73ae5683,
                                            alt: "TikTok"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    children: "Join The Pack"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    children: "Turn daily notifications via e-mail to be up to date with our freshly added sneakers."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "footer__form",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                                        onSubmit: newsletterSubmit,
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                value: newsletter,
                                                onChange: (e)=>{
                                                    setNewsletter(e.target.value);
                                                },
                                                placeholder: "Enter your email"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "footer__button-icon",
                                                    src: $5daf4519c9d7de51$export$c5552dfdbc7cec71,
                                                    alt: "Sign into newsletter"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "footer__payments",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                            children: "Payments Methods"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "footer__payments-icons",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: $5daf4519c9d7de51$export$f59d5eab15587ea7,
                                    alt: "Mastercard"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: $5daf4519c9d7de51$export$c7113aead8874e9f,
                                    alt: "Visa"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: $5daf4519c9d7de51$export$77124b5afc0389ab,
                                    alt: "Amex"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: $5daf4519c9d7de51$export$79dd2d8976cc2062,
                                    alt: "Apple Pay"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: $5daf4519c9d7de51$export$3a92b3e185e77400,
                                    alt: "Pay Pall"
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $41d6a4e60e5858e7$export$2e2bcd8739ae039), {})
    });
}
var $031e0d82e9f3387e$export$2e2bcd8739ae039 = $031e0d82e9f3387e$var$Footer;




var $6cds3 = parcelRequire("6cds3");



const $51ee6af9f38ebb77$export$3c6853bf0ddaf163 = ()=>{
    const { setAuth: setAuth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    return async ()=>{
        const data = await (0, $a9b114d4c5390c4c$export$318ed307220606e)();
        setAuth({
            token: data.accessToken
        });
        return data.accessToken;
    };
};



const $12aae65bde46d705$var$UserStatus = ()=>{
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(true);
    const [error, setError] = (0, $6cds3.useState)(null);
    const refresh = (0, $51ee6af9f38ebb77$export$3c6853bf0ddaf163)();
    const { auth: auth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    (0, $6cds3.useEffect)(()=>{
        let isMounted = true;
        const verify = async ()=>{
            try {
                await refresh();
            } catch (err) {
                setError(err);
            } finally{
                isMounted && setIsLoading(false);
            }
        };
        !auth?.token ? verify() : setIsLoading(false);
        return ()=>{
            isMounted = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$910ae8079b2c2852), {})
    });
};
var $12aae65bde46d705$export$2e2bcd8739ae039 = $12aae65bde46d705$var$UserStatus;








var $6cds3 = parcelRequire("6cds3");
var $169d6c2f0e131389$exports = {};

$169d6c2f0e131389$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "broken-heart.646e257c.svg";



function $80a0b0c02dacf1a6$var$Favourites() {
    const { auth: auth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    const [faves, setFaves] = (0, $38a3408ff9214f5d$export$86e2cef2561044ac)("faves", {});
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const [toggleFaves, setToggleFaves] = (0, $6cds3.useState)("filter-red");
    const detailedViewHandler = (id)=>{
        navigate(`/items/${id}`);
    };
    const favesHandler = (e, id)=>{
        e.stopPropagation();
        if (toggleFaves === "filter-red") {
            const { [id]: _, ...remainingFaves } = faves;
            setFaves(remainingFaves);
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "favourites",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "collection__headline",
                children: "Favourites"
            }),
            auth.token && Object.entries(faves).length > 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "favourites__container",
                children: Object.entries(faves).map((item)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        onClick: ()=>{
                            detailedViewHandler(item[1]._id);
                        },
                        className: "favourites__item",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "favourites__image-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        className: "favourites__image",
                                        src: item[1].img,
                                        alt: "Favourites sneaker"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                        className: "favourites__icon-heart",
                                        onClick: (e)=>{
                                            favesHandler(e, item[1]._id);
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                                            className: `favourites__heart ${toggleFaves}`,
                                            viewBox: "0 0 24 24",
                                            role: "img",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-labelledby": "favouriteIconTitle",
                                            stroke: "#000000",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            fill: "none",
                                            color: "#000000",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                                                    id: "favouriteIconTitle",
                                                    children: "Favourite"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                    d: "M12,21 L10.55,19.7051771 C5.4,15.1242507 2,12.1029973 2,8.39509537 C2,5.37384196 4.42,3 7.5,3 C9.24,3 10.91,3.79455041 12,5.05013624 C13.09,3.79455041 14.76,3 16.5,3 C19.58,3 22,5.37384196 22,8.39509537 C22,12.1029973 18.6,15.1242507 13.45,19.7149864 L12,21 Z"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "favourites__desc",
                                children: item[1].name
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "favourites__desc",
                                children: item[1].price
                            })
                        ]
                    }, item[1]._id))
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "favourites__container empty",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "favourites__empty-content",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            className: "favourites__image-empty",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($169d6c2f0e131389$exports))),
                            alt: "Broken heart"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "favourites__headline",
                            children: auth.token ? "Nothing to display here!" : "You have to login first!"
                        })
                    ]
                })
            })
        ]
    });
}
var $80a0b0c02dacf1a6$export$2e2bcd8739ae039 = $80a0b0c02dacf1a6$var$Favourites;





const $eef4bddb5d352632$export$1221790706ba044f = ()=>{
    const { auth: auth } = (0, $147aa0cfde8ae0b9$export$1d39dc5b47e56ff0)();
    const location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    return auth?.token ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$444b3ab0cb9aec40), {
        to: "/",
        state: {
            from: location
        },
        replace: true
    });
};






var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c2a37736a53c5f6$var$extendStatics = function(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c2a37736a53c5f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c2a37736a53c5f6$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c2a37736a53c5f6$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c2a37736a53c5f6$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c2a37736a53c5f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, p);
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c2a37736a53c5f6$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c2a37736a53c5f6$export$45d3717a4c69092e(result, mod, k);
    }
    $5c2a37736a53c5f6$var$__setModuleDefault(result, mod);
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c2a37736a53c5f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c2a37736a53c5f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c2a37736a53c5f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c2a37736a53c5f6$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c2a37736a53c5f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c2a37736a53c5f6$export$2e2bcd8739ae039 = {
    __extends: $5c2a37736a53c5f6$export$a8ba968b8961cb8a,
    __assign: $5c2a37736a53c5f6$export$18ce0697a983be9b,
    __rest: $5c2a37736a53c5f6$export$3c9a16f847548506,
    __decorate: $5c2a37736a53c5f6$export$29e00dfd3077644b,
    __param: $5c2a37736a53c5f6$export$d5ad3fd78186038f,
    __metadata: $5c2a37736a53c5f6$export$f1db080c865becb9,
    __awaiter: $5c2a37736a53c5f6$export$1050f835b63b671e,
    __generator: $5c2a37736a53c5f6$export$67ebef60e6f28a6,
    __createBinding: $5c2a37736a53c5f6$export$45d3717a4c69092e,
    __exportStar: $5c2a37736a53c5f6$export$f33643c0debef087,
    __values: $5c2a37736a53c5f6$export$19a8beecd37a4c45,
    __read: $5c2a37736a53c5f6$export$8d051b38c9118094,
    __spread: $5c2a37736a53c5f6$export$afc72e2116322959,
    __spreadArrays: $5c2a37736a53c5f6$export$6388937ca91ccae8,
    __spreadArray: $5c2a37736a53c5f6$export$1216008129fb82ed,
    __await: $5c2a37736a53c5f6$export$10c90e4f7922046c,
    __asyncGenerator: $5c2a37736a53c5f6$export$e427f37a30a4de9b,
    __asyncDelegator: $5c2a37736a53c5f6$export$bbd80228419bb833,
    __asyncValues: $5c2a37736a53c5f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c2a37736a53c5f6$export$4fb47efe1390b86f,
    __importStar: $5c2a37736a53c5f6$export$c21735bcef00d192,
    __importDefault: $5c2a37736a53c5f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c2a37736a53c5f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c2a37736a53c5f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c2a37736a53c5f6$export$81fdc39f203e4e04,
    __addDisposableResource: $5c2a37736a53c5f6$export$88ac25d8e944e405,
    __disposeResources: $5c2a37736a53c5f6$export$8f076105dc360e92
};


parcelRequire("eWCkp");

var $6cds3 = parcelRequire("6cds3");
var $37b3ef32bfd5cb93$exports = {};
//
$37b3ef32bfd5cb93$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $55fca618e7164f46$export$71ad59f2e432cfe8 = "-ms-";
var $55fca618e7164f46$export$2c0f367103c8d01c = "-moz-";
var $55fca618e7164f46$export$39dfd62a25e0fe93 = "-webkit-";
var $55fca618e7164f46$export$a29989082612d0d9 = "comm";
var $55fca618e7164f46$export$aa3a2e812ca8570d = "rule";
var $55fca618e7164f46$export$527d108ccf083c2b = "decl";
var $55fca618e7164f46$export$d3d35020fa5b54f0 = "@page";
var $55fca618e7164f46$export$500415a86c544f73 = "@media";
var $55fca618e7164f46$export$a763edbf796b780a = "@import";
var $55fca618e7164f46$export$2790aeb8b4e5c826 = "@charset";
var $55fca618e7164f46$export$1cc683e23b84b133 = "@viewport";
var $55fca618e7164f46$export$9447a5efea57e862 = "@supports";
var $55fca618e7164f46$export$ef011b4e114b1fba = "@document";
var $55fca618e7164f46$export$6aad947bda0f3f46 = "@namespace";
var $55fca618e7164f46$export$b44a8529a35fcb60 = "@keyframes";
var $55fca618e7164f46$export$2c16de31893252e6 = "@font-face";
var $55fca618e7164f46$export$3d846dd52e150c6f = "@counter-style";
var $55fca618e7164f46$export$22314bfbb57653fe = "@font-feature-values";
var $55fca618e7164f46$export$d773506282b3cfe6 = "@layer";
var $55fca618e7164f46$export$1c5a554c78c0cd12 = "@scope";
var $55fca618e7164f46$export$2335f513bbd82c6d = Math.abs;
var $55fca618e7164f46$export$6788812c4e6611e6 = String.fromCharCode;
var $55fca618e7164f46$export$e6e34fd1f2686227 = Object.assign;
function $55fca618e7164f46$export$d6af199866bfb566(e, r) {
    return $55fca618e7164f46$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 0)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 1)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 2)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 3) : 0;
}
function $55fca618e7164f46$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $55fca618e7164f46$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $55fca618e7164f46$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $55fca618e7164f46$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $55fca618e7164f46$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $55fca618e7164f46$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $55fca618e7164f46$export$36776f635604f274(e) {
    return e.length;
}
function $55fca618e7164f46$export$f9084667e487ed46(e) {
    return e.length;
}
function $55fca618e7164f46$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $55fca618e7164f46$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $55fca618e7164f46$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$55fca618e7164f46$export$4659b591c19bdf3d(e, r);
    });
}
var $55fca618e7164f46$export$53f1d5ea8de3d7c = 1;
var $55fca618e7164f46$export$4e0c71f277ca26b3 = 1;
var $55fca618e7164f46$export$f24224f1c91d8156 = 0;
var $55fca618e7164f46$export$5880b8b5730aff45 = 0;
var $55fca618e7164f46$export$c0306caf338ac095 = 0;
var $55fca618e7164f46$export$30a86d91af8ff6e6 = "";
function $55fca618e7164f46$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $55fca618e7164f46$export$53f1d5ea8de3d7c,
        column: $55fca618e7164f46$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $55fca618e7164f46$export$784d13d8ee351f07(e, r) {
    return $55fca618e7164f46$export$e6e34fd1f2686227($55fca618e7164f46$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $55fca618e7164f46$export$590e8b2c435046d9(e) {
    while(e.root)e = $55fca618e7164f46$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $55fca618e7164f46$export$10d8903dec122b9d(e, e.siblings);
}
function $55fca618e7164f46$export$eba6f6f03b0a92e7() {
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$232faf9add678146() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 > 0 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, --$55fca618e7164f46$export$5880b8b5730aff45) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3--, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c--;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$48cfd1e771a65c4f() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 < $55fca618e7164f46$export$f24224f1c91d8156 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45++) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3++, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c++;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$4d3fb11e950abb9e() {
    return $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$e88cb2efb12ae807() {
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$58adb3bec8346d0f(e, r) {
    return $55fca618e7164f46$export$2f35ab04d2335697($55fca618e7164f46$export$30a86d91af8ff6e6, e, r);
}
function $55fca618e7164f46$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $55fca618e7164f46$export$2de70f21292aac9e(e) {
    return $55fca618e7164f46$export$53f1d5ea8de3d7c = $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$f24224f1c91d8156 = $55fca618e7164f46$export$36776f635604f274($55fca618e7164f46$export$30a86d91af8ff6e6 = e), $55fca618e7164f46$export$5880b8b5730aff45 = 0, [];
}
function $55fca618e7164f46$export$45918ac1574455b1(e) {
    return $55fca618e7164f46$export$30a86d91af8ff6e6 = "", e;
}
function $55fca618e7164f46$export$410ac95b9ec204b8(e) {
    return $55fca618e7164f46$export$87c2784dc9fc4ab($55fca618e7164f46$export$58adb3bec8346d0f($55fca618e7164f46$export$5880b8b5730aff45 - 1, $55fca618e7164f46$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $55fca618e7164f46$export$660b2ee2d4fb4eff(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$5f8c09e3ae6f64e1($55fca618e7164f46$export$2de70f21292aac9e(e)));
}
function $55fca618e7164f46$export$7af1228ff777d175(e) {
    while($55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$4d3fb11e950abb9e())if ($55fca618e7164f46$export$c0306caf338ac095 < 33) $55fca618e7164f46$export$48cfd1e771a65c4f();
    else break;
    return $55fca618e7164f46$export$9e1725a4cfeada27(e) > 2 || $55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $55fca618e7164f46$export$5f8c09e3ae6f64e1(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095)){
        case 0:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$c0306caf338ac095), e);
            break;
        default:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$c0306caf338ac095), e);
    }
    return e;
}
function $55fca618e7164f46$export$955ba06d119e085e(e, r) {
    while(--r && $55fca618e7164f46$export$48cfd1e771a65c4f())if ($55fca618e7164f46$export$c0306caf338ac095 < 48 || $55fca618e7164f46$export$c0306caf338ac095 > 102 || $55fca618e7164f46$export$c0306caf338ac095 > 57 && $55fca618e7164f46$export$c0306caf338ac095 < 65 || $55fca618e7164f46$export$c0306caf338ac095 > 70 && $55fca618e7164f46$export$c0306caf338ac095 < 97) break;
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$e88cb2efb12ae807() + (r < 6 && $55fca618e7164f46$export$4d3fb11e950abb9e() == 32 && $55fca618e7164f46$export$48cfd1e771a65c4f() == 32));
}
function $55fca618e7164f46$export$c889f2fcc19dbf12(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$c0306caf338ac095){
        case e:
            return $55fca618e7164f46$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $55fca618e7164f46$export$c889f2fcc19dbf12($55fca618e7164f46$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $55fca618e7164f46$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $55fca618e7164f46$export$48cfd1e771a65c4f();
            break;
    }
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$4254d4e2b3745c4c(e, r) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())if (e + $55fca618e7164f46$export$c0306caf338ac095 === 57) break;
    else if (e + $55fca618e7164f46$export$c0306caf338ac095 === 84 && $55fca618e7164f46$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $55fca618e7164f46$export$58adb3bec8346d0f(r, $55fca618e7164f46$export$5880b8b5730aff45 - 1) + "*" + $55fca618e7164f46$export$6788812c4e6611e6(e === 47 ? e : $55fca618e7164f46$export$48cfd1e771a65c4f());
}
function $55fca618e7164f46$export$c2ab62c7bf24634(e) {
    while(!$55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$4d3fb11e950abb9e()))$55fca618e7164f46$export$48cfd1e771a65c4f();
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$ef7acd7185315e22(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $55fca618e7164f46$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $55fca618e7164f46$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $55fca618e7164f46$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $55fca618e7164f46$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($55fca618e7164f46$export$f8e21b1e77979a08(z += $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $55fca618e7164f46$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $55fca618e7164f46$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $55fca618e7164f46$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $55fca618e7164f46$export$955ba06d119e085e($55fca618e7164f46$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($55fca618e7164f46$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$4a34f930e789283c($55fca618e7164f46$export$4254d4e2b3745c4c($55fca618e7164f46$export$48cfd1e771a65c4f(), $55fca618e7164f46$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $55fca618e7164f46$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $55fca618e7164f46$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $55fca618e7164f46$export$36776f635604f274(z) - l) $55fca618e7164f46$export$10d8903dec122b9d(p > 32 ? $55fca618e7164f46$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $55fca618e7164f46$export$f8483753829ec8f3($55fca618e7164f46$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $55fca618e7164f46$export$10d8903dec122b9d(j = $55fca618e7164f46$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $55fca618e7164f46$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $55fca618e7164f46$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $55fca618e7164f46$export$98e6a39c04603d36(e, j, j, n && $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $55fca618e7164f46$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $55fca618e7164f46$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $55fca618e7164f46$export$232faf9add678146() == 125) continue;
            }
            switch(z += $55fca618e7164f46$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($55fca618e7164f46$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($55fca618e7164f46$export$4d3fb11e950abb9e() === 45) z += $55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$48cfd1e771a65c4f());
                    v = $55fca618e7164f46$export$4d3fb11e950abb9e(), o = l = $55fca618e7164f46$export$36776f635604f274(k = z += $55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $55fca618e7164f46$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $55fca618e7164f46$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $55fca618e7164f46$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $55fca618e7164f46$export$2f35ab04d2335697(e, p + 1, p = $55fca618e7164f46$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $55fca618e7164f46$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $55fca618e7164f46$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, s === 0 ? $55fca618e7164f46$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $55fca618e7164f46$export$4a34f930e789283c(e, r, a, c) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$a29989082612d0d9, $55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$eba6f6f03b0a92e7()), $55fca618e7164f46$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $55fca618e7164f46$export$f8483753829ec8f3(e, r, a, n, c) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$527d108ccf083c2b, $55fca618e7164f46$export$2f35ab04d2335697(e, 0, n), $55fca618e7164f46$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $55fca618e7164f46$export$82e9f45cca5ba907(n, c, s) {
    switch($55fca618e7164f46$export$d6af199866bfb566(n, c)){
        case 5103:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $55fca618e7164f46$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$2c0f367103c8d01c + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-$1$2" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-item-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-line-pack" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-grow", "") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-pack:$3" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-column-align" + $55fca618e7164f46$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$55fca618e7164f46$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$55fca618e7164f46$export$f8e21b1e77979a08(s, "span", 0) ? $55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) : +$55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) - +$55fca618e7164f46$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($55fca618e7164f46$export$36776f635604f274(n) - 1 - c > 6) switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $55fca618e7164f46$export$2c0f367103c8d01c + ($55fca618e7164f46$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$55fca618e7164f46$export$f8e21b1e77979a08(n, "stretch", 0) ? $55fca618e7164f46$export$82e9f45cca5ba907($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $55fca618e7164f46$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $55fca618e7164f46$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 6) === 121) return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, $55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + ($55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $55fca618e7164f46$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $55fca618e7164f46$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $55fca618e7164f46$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $55fca618e7164f46$export$a763edbf796b780a:
        case $55fca618e7164f46$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $55fca618e7164f46$export$a29989082612d0d9:
            return "";
        case $55fca618e7164f46$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            if (!$55fca618e7164f46$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $55fca618e7164f46$export$36776f635604f274(a = $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $55fca618e7164f46$export$5a7767152ae0305f(e) {
    var r = $55fca618e7164f46$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $55fca618e7164f46$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $55fca618e7164f46$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $55fca618e7164f46$export$527d108ccf083c2b:
                n.return = $55fca618e7164f46$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $55fca618e7164f46$export$b44a8529a35fcb60:
                return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                    $55fca618e7164f46$export$784d13d8ee351f07(n, {
                        value: $55fca618e7164f46$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $55fca618e7164f46$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $55fca618e7164f46$export$aa3a2e812ca8570d:
                if (n.length) return $55fca618e7164f46$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($55fca618e7164f46$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $55fca618e7164f46$export$e6e34fd1f2686227(n, {
                                props: $55fca618e7164f46$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $55fca618e7164f46$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $55fca618e7164f46$export$590e8b2c435046d9($55fca618e7164f46$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $55fca618e7164f46$export$e6e34fd1f2686227(n, {
                                props: $55fca618e7164f46$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $55fca618e7164f46$export$76a88f7de6507443(e) {
    switch(e.type){
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $55fca618e7164f46$export$1be1fc439b849fdf($55fca618e7164f46$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($55fca618e7164f46$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $55fca618e7164f46$export$2f35ab04d2335697(r, 1, $55fca618e7164f46$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $55fca618e7164f46$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $55fca618e7164f46$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $55fca618e7164f46$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $b62f2dc75e2ff17e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $79658495443aecda$exports = {};
"use strict";


var $e94f79f42775c5f5$var$f = ("undefined" != typeof $79658495443aecda$exports && void 0 !== $79658495443aecda$exports.env && undefined, "data-styled"), $e94f79f42775c5f5$var$m = "active", $e94f79f42775c5f5$var$y = "data-styled-version", $e94f79f42775c5f5$export$83d89fbfd8236492 = "6.1.13", $e94f79f42775c5f5$var$g = "/*!sc*/\n", $e94f79f42775c5f5$var$S = "undefined" != typeof window && "HTMLElement" in window, $e94f79f42775c5f5$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $79658495443aecda$exports && $79658495443aecda$exports.env, "undefined" != typeof $79658495443aecda$exports && $79658495443aecda$exports.env, false)), $e94f79f42775c5f5$var$b = {}, $e94f79f42775c5f5$var$E = /invalid hook call/i, $e94f79f42775c5f5$var$N = new Set, $e94f79f42775c5f5$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e94f79f42775c5f5$var$_ = Object.freeze([]), $e94f79f42775c5f5$var$C = Object.freeze({});
function $e94f79f42775c5f5$var$I(e, t, n) {
    return void 0 === n && (n = $e94f79f42775c5f5$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e94f79f42775c5f5$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e94f79f42775c5f5$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e94f79f42775c5f5$var$D = /(^-|-$)/g;
function $e94f79f42775c5f5$var$R(e) {
    return e.replace($e94f79f42775c5f5$var$O, "-").replace($e94f79f42775c5f5$var$D, "");
}
var $e94f79f42775c5f5$var$T = /(a)(d)/gi, $e94f79f42775c5f5$var$k = 52, $e94f79f42775c5f5$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e94f79f42775c5f5$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e94f79f42775c5f5$var$k; t = t / $e94f79f42775c5f5$var$k | 0)n = $e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n;
    return ($e94f79f42775c5f5$var$j(t % $e94f79f42775c5f5$var$k) + n).replace($e94f79f42775c5f5$var$T, "$1-$2");
}
var $e94f79f42775c5f5$var$V, $e94f79f42775c5f5$var$F = 5381, $e94f79f42775c5f5$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e94f79f42775c5f5$var$z = function(e) {
    return $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$F, e);
};
function $e94f79f42775c5f5$var$$(e) {
    return $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$z(e) >>> 0);
}
function $e94f79f42775c5f5$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e94f79f42775c5f5$var$L(e) {
    return "string" == typeof e && true;
}
var $e94f79f42775c5f5$var$G = "function" == typeof Symbol && Symbol.for, $e94f79f42775c5f5$var$Y = $e94f79f42775c5f5$var$G ? Symbol.for("react.memo") : 60115, $e94f79f42775c5f5$var$W = $e94f79f42775c5f5$var$G ? Symbol.for("react.forward_ref") : 60112, $e94f79f42775c5f5$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e94f79f42775c5f5$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e94f79f42775c5f5$var$J = (($e94f79f42775c5f5$var$V = {})[$e94f79f42775c5f5$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e94f79f42775c5f5$var$V[$e94f79f42775c5f5$var$Y] = $e94f79f42775c5f5$var$U, $e94f79f42775c5f5$var$V);
function $e94f79f42775c5f5$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e94f79f42775c5f5$var$Y ? $e94f79f42775c5f5$var$U : "$$typeof" in e ? $e94f79f42775c5f5$var$J[e.$$typeof] : $e94f79f42775c5f5$var$q;
}
var $e94f79f42775c5f5$var$Z = Object.defineProperty, $e94f79f42775c5f5$var$K = Object.getOwnPropertyNames, $e94f79f42775c5f5$var$Q = Object.getOwnPropertySymbols, $e94f79f42775c5f5$var$ee = Object.getOwnPropertyDescriptor, $e94f79f42775c5f5$var$te = Object.getPrototypeOf, $e94f79f42775c5f5$var$ne = Object.prototype;
function $e94f79f42775c5f5$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e94f79f42775c5f5$var$ne) {
            var o = $e94f79f42775c5f5$var$te(t);
            o && o !== $e94f79f42775c5f5$var$ne && $e94f79f42775c5f5$var$oe(e, o, n);
        }
        var r = $e94f79f42775c5f5$var$K(t);
        $e94f79f42775c5f5$var$Q && (r = r.concat($e94f79f42775c5f5$var$Q(t)));
        for(var s = $e94f79f42775c5f5$var$X(e), i = $e94f79f42775c5f5$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e94f79f42775c5f5$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e94f79f42775c5f5$var$ee(t, c);
                try {
                    $e94f79f42775c5f5$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e94f79f42775c5f5$var$re(e) {
    return "function" == typeof e;
}
function $e94f79f42775c5f5$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e94f79f42775c5f5$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e94f79f42775c5f5$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e94f79f42775c5f5$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e94f79f42775c5f5$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e94f79f42775c5f5$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    else if ($e94f79f42775c5f5$var$ce(t)) for(var o in t)e[o] = $e94f79f42775c5f5$var$le(e[o], t[o]);
    return e;
}
function $e94f79f42775c5f5$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e94f79f42775c5f5$var$pe = {};
function $e94f79f42775c5f5$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e94f79f42775c5f5$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e94f79f42775c5f5$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e94f79f42775c5f5$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e94f79f42775c5f5$var$g);
        return t;
    }, e;
}(), $e94f79f42775c5f5$var$me = 1073741824, $e94f79f42775c5f5$var$ye = new Map, $e94f79f42775c5f5$var$ve = new Map, $e94f79f42775c5f5$var$ge = 1, $e94f79f42775c5f5$var$Se = function(e) {
    if ($e94f79f42775c5f5$var$ye.has(e)) return $e94f79f42775c5f5$var$ye.get(e);
    for(; $e94f79f42775c5f5$var$ve.has($e94f79f42775c5f5$var$ge);)$e94f79f42775c5f5$var$ge++;
    var t = $e94f79f42775c5f5$var$ge++;
    return $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e), t;
}, $e94f79f42775c5f5$var$we = function(e, t) {
    $e94f79f42775c5f5$var$ge = t + 1, $e94f79f42775c5f5$var$ye.set(e, t), $e94f79f42775c5f5$var$ve.set(t, e);
}, $e94f79f42775c5f5$var$be = "style[".concat($e94f79f42775c5f5$var$f, "][").concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"]'), $e94f79f42775c5f5$var$Ee = new RegExp("^".concat($e94f79f42775c5f5$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e94f79f42775c5f5$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e94f79f42775c5f5$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e94f79f42775c5f5$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e94f79f42775c5f5$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e94f79f42775c5f5$var$we(u, l), $e94f79f42775c5f5$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e94f79f42775c5f5$var$_e = function(e) {
    for(var t = document.querySelectorAll($e94f79f42775c5f5$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e94f79f42775c5f5$var$f) !== $e94f79f42775c5f5$var$m && ($e94f79f42775c5f5$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e94f79f42775c5f5$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e94f79f42775c5f5$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e94f79f42775c5f5$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e94f79f42775c5f5$var$f, $e94f79f42775c5f5$var$m), o.setAttribute($e94f79f42775c5f5$var$y, $e94f79f42775c5f5$export$83d89fbfd8236492);
    var i = $e94f79f42775c5f5$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e94f79f42775c5f5$var$Ae = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e94f79f42775c5f5$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e94f79f42775c5f5$var$Oe = function() {
    function e(e) {
        this.element = $e94f79f42775c5f5$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e94f79f42775c5f5$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e94f79f42775c5f5$var$Re = $e94f79f42775c5f5$var$S, $e94f79f42775c5f5$var$Te = {
    isServer: !$e94f79f42775c5f5$var$S,
    useCSSOMInjection: !$e94f79f42775c5f5$var$w
}, $e94f79f42775c5f5$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e94f79f42775c5f5$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, $e94f79f42775c5f5$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$Re && ($e94f79f42775c5f5$var$Re = !1, $e94f79f42775c5f5$var$_e(this)), $e94f79f42775c5f5$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e94f79f42775c5f5$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e94f79f42775c5f5$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e94f79f42775c5f5$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e94f79f42775c5f5$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e94f79f42775c5f5$var$S && $e94f79f42775c5f5$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e94f79f42775c5f5$var$De(n) : t ? new $e94f79f42775c5f5$var$Ae(n) : new $e94f79f42775c5f5$var$Oe(n);
        }(this.options), new $e94f79f42775c5f5$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e94f79f42775c5f5$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e94f79f42775c5f5$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e94f79f42775c5f5$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e94f79f42775c5f5$var$je = /&/g, $e94f79f42775c5f5$var$xe = /^\s*\/\/.*$/gm;
function $e94f79f42775c5f5$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e94f79f42775c5f5$var$Ve(e.children, t)), e;
    });
}
function $e94f79f42775c5f5$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e94f79f42775c5f5$var$C : e, s = r.options, i = void 0 === s ? $e94f79f42775c5f5$var$C : s, a = r.plugins, c = void 0 === a ? $e94f79f42775c5f5$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $55fca618e7164f46$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e94f79f42775c5f5$var$je, n).replace(o, l));
    }), i.prefix && u.push($55fca618e7164f46$export$e08c7d021b829b7a), u.push($55fca618e7164f46$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e94f79f42775c5f5$var$xe, ""), l = $55fca618e7164f46$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e94f79f42775c5f5$var$Ve(l, i.namespace));
        var p = [];
        return $55fca618e7164f46$export$dfdc1655ccc5b9cb(l, $55fca618e7164f46$export$5a7767152ae0305f(u.concat($55fca618e7164f46$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e94f79f42775c5f5$var$he(15), $e94f79f42775c5f5$var$M(e, t.name);
    }, $e94f79f42775c5f5$var$F).toString() : "", p;
}
var $e94f79f42775c5f5$var$Me = new $e94f79f42775c5f5$var$ke, $e94f79f42775c5f5$var$ze = $e94f79f42775c5f5$var$Fe(), $e94f79f42775c5f5$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e94f79f42775c5f5$var$Me,
    stylis: $e94f79f42775c5f5$var$ze
}), $e94f79f42775c5f5$export$91317688fc694efa = $e94f79f42775c5f5$export$8c190ef828af4c86.Consumer, $e94f79f42775c5f5$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0);
function $e94f79f42775c5f5$var$Ge() {
    return (0, $6cds3.useContext)($e94f79f42775c5f5$export$8c190ef828af4c86);
}
function $e94f79f42775c5f5$export$a473771da2f0ff7c(e) {
    var t = (0, $6cds3.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e94f79f42775c5f5$var$Ge().styleSheet, l = (0, $6cds3.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $6cds3.useMemo)(function() {
        return $e94f79f42775c5f5$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $6cds3.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($37b3ef32bfd5cb93$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $6cds3.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e94f79f42775c5f5$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e94f79f42775c5f5$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e94f79f42775c5f5$var$ue(this, function() {
            throw $e94f79f42775c5f5$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e94f79f42775c5f5$var$ze), this.name + e.hash;
    }, e;
}(), $e94f79f42775c5f5$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e94f79f42775c5f5$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e94f79f42775c5f5$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e94f79f42775c5f5$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e94f79f42775c5f5$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e94f79f42775c5f5$var$Ue(i) && (Array.isArray(i) && i.isCss || $e94f79f42775c5f5$var$re(i) ? r.push("".concat($e94f79f42775c5f5$var$He(s), ":"), i, ";") : $e94f79f42775c5f5$var$ce(i) ? r.push.apply(r, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e94f79f42775c5f5$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e94f79f42775c5f5$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b62f2dc75e2ff17e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e94f79f42775c5f5$var$Xe(e, t, n, o) {
    if ($e94f79f42775c5f5$var$Ue(e)) return [];
    if ($e94f79f42775c5f5$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e94f79f42775c5f5$var$re(e)) {
        if (!$e94f79f42775c5f5$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e94f79f42775c5f5$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e94f79f42775c5f5$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e94f79f42775c5f5$var$ce(e) ? $e94f79f42775c5f5$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e94f79f42775c5f5$var$_, e.map(function(e) {
        return $e94f79f42775c5f5$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e94f79f42775c5f5$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e94f79f42775c5f5$var$re(n) && !$e94f79f42775c5f5$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e94f79f42775c5f5$var$Ke = $e94f79f42775c5f5$var$z($e94f79f42775c5f5$export$83d89fbfd8236492), $e94f79f42775c5f5$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e94f79f42775c5f5$var$Ze(e), this.componentId = t, this.baseHash = $e94f79f42775c5f5$var$M($e94f79f42775c5f5$var$Ke, t), this.baseStyle = n, $e94f79f42775c5f5$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e94f79f42775c5f5$var$ie(o, this.staticRulesId);
            else {
                var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, e, t, n)), s = $e94f79f42775c5f5$var$x($e94f79f42775c5f5$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e94f79f42775c5f5$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e94f79f42775c5f5$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(u, e, t, n));
                    a = $e94f79f42775c5f5$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e94f79f42775c5f5$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e94f79f42775c5f5$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e94f79f42775c5f5$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(void 0), $e94f79f42775c5f5$export$b631efc24e9d5e2f = $e94f79f42775c5f5$export$2c657da244d00bd6.Consumer;
function $e94f79f42775c5f5$export$93d4e7f90805808f() {
    var e = (0, $6cds3.useContext)($e94f79f42775c5f5$export$2c657da244d00bd6);
    if (!e) throw $e94f79f42775c5f5$var$he(18);
    return e;
}
function $e94f79f42775c5f5$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, $6cds3.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e94f79f42775c5f5$var$he(14);
            if ($e94f79f42775c5f5$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e94f79f42775c5f5$var$he(8);
            return n ? (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e94f79f42775c5f5$var$rt = {}, $e94f79f42775c5f5$var$st = new Set;
function $e94f79f42775c5f5$var$it(e, r, s) {
    var i = $e94f79f42775c5f5$export$7ba318d8d2f06c76(e), a = e, c = !$e94f79f42775c5f5$var$L(e), p = r.attrs, d = void 0 === p ? $e94f79f42775c5f5$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e94f79f42775c5f5$var$R(e);
        $e94f79f42775c5f5$var$rt[n] = ($e94f79f42775c5f5$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e94f79f42775c5f5$var$$($e94f79f42775c5f5$export$83d89fbfd8236492 + n + $e94f79f42775c5f5$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e94f79f42775c5f5$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e94f79f42775c5f5$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e94f79f42775c5f5$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e94f79f42775c5f5$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), m = $e94f79f42775c5f5$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e94f79f42775c5f5$var$I(r, f, c) || $e94f79f42775c5f5$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e94f79f42775c5f5$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e94f79f42775c5f5$var$ie(s[c], a[c]) : "style" === c ? (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e94f79f42775c5f5$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e94f79f42775c5f5$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e94f79f42775c5f5$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e94f79f42775c5f5$var$L(S) && !$e94f79f42775c5f5$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $6cds3.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e94f79f42775c5f5$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e94f79f42775c5f5$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e94f79f42775c5f5$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e94f79f42775c5f5$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e94f79f42775c5f5$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e94f79f42775c5f5$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e94f79f42775c5f5$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e94f79f42775c5f5$var$re(t) || $e94f79f42775c5f5$var$ce(t)) return $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at($e94f79f42775c5f5$var$_, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e94f79f42775c5f5$var$Xe(r) : $e94f79f42775c5f5$var$ct($e94f79f42775c5f5$var$Xe($e94f79f42775c5f5$var$at(r, n)));
}
function $e94f79f42775c5f5$var$ut(n, o, r) {
    if (void 0 === r && (r = $e94f79f42775c5f5$var$C), !o) throw $e94f79f42775c5f5$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e94f79f42775c5f5$var$ut(n, o, (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e94f79f42775c5f5$var$pt = function(e) {
    return $e94f79f42775c5f5$var$ut($e94f79f42775c5f5$var$it, e);
}, $e94f79f42775c5f5$export$2e2bcd8739ae039 = $e94f79f42775c5f5$var$pt;
$e94f79f42775c5f5$var$A.forEach(function(e) {
    $e94f79f42775c5f5$export$2e2bcd8739ae039[e] = $e94f79f42775c5f5$var$pt(e);
});
var $e94f79f42775c5f5$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e94f79f42775c5f5$var$Ze(e), $e94f79f42775c5f5$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e94f79f42775c5f5$var$ae($e94f79f42775c5f5$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e94f79f42775c5f5$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e94f79f42775c5f5$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e94f79f42775c5f5$var$$(JSON.stringify(i))), c = new $e94f79f42775c5f5$var$ht(i, a);
    var l = function(e) {
        var t = $e94f79f42775c5f5$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e94f79f42775c5f5$var$b, o, s);
        else {
            var i = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, n), {
                theme: $e94f79f42775c5f5$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).memo(l);
}
function $e94f79f42775c5f5$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e94f79f42775c5f5$var$ae($e94f79f42775c5f5$export$dbf350e5966cf602.apply(void 0, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e94f79f42775c5f5$var$$(r);
    return new $e94f79f42775c5f5$var$We(s, r);
}
function $e94f79f42775c5f5$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(n, r) {
        var s = $e94f79f42775c5f5$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($e94f79f42775c5f5$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(e, (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e94f79f42775c5f5$var$B(e), ")"), $e94f79f42775c5f5$var$oe(n, e);
}
var $e94f79f42775c5f5$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e94f79f42775c5f5$var$Ce(), o = $e94f79f42775c5f5$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e94f79f42775c5f5$var$f, '="true"'),
                "".concat($e94f79f42775c5f5$var$y, '="').concat($e94f79f42775c5f5$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e94f79f42775c5f5$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e94f79f42775c5f5$var$f] = "", n[$e94f79f42775c5f5$var$y] = $e94f79f42775c5f5$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e94f79f42775c5f5$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("style", (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e94f79f42775c5f5$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e94f79f42775c5f5$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($e94f79f42775c5f5$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e94f79f42775c5f5$var$he(3);
    }, e;
}(), $e94f79f42775c5f5$export$5c87cfe6c475f500 = {
    StyleSheet: $e94f79f42775c5f5$var$ke,
    mainSheet: $e94f79f42775c5f5$var$Me
};
var $e94f79f42775c5f5$var$St = "__sc-".concat($e94f79f42775c5f5$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $a26d72e4b0b47d7e$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$time = 1.6;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$anim = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$Path = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$anim} ${$a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $a26d72e4b0b47d7e$export$8009d4483dfda42 = ({ color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $a26d72e4b0b47d7e$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: $a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$getPath($a26d72e4b0b47d7e$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $a26d72e4b0b47d7e$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $a26d72e4b0b47d7e$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $a26d72e4b0b47d7e$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$spin = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$Svg = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).svg`
  animation: ${$a26d72e4b0b47d7e$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $a26d72e4b0b47d7e$var$$5819da83a926266a$var$Polyline = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $a26d72e4b0b47d7e$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $6cds3.useCallback)(()=>$a26d72e4b0b47d7e$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$5819da83a926266a$var$Svg, {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $a26d72e4b0b47d7e$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$dash = (0, $e94f79f42775c5f5$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$Polygon = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$SVG = (0, $e94f79f42775c5f5$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $a26d72e4b0b47d7e$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $a26d72e4b0b47d7e$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $fba0f23e9e6a11bb$exports.jsx)($a26d72e4b0b47d7e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $a26d72e4b0b47d7e$export$1ed1943372cc63a9 = ({ color: color = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $a26d72e4b0b47d7e$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $a26d72e4b0b47d7e$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $a26d72e4b0b47d7e$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $a26d72e4b0b47d7e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $a26d72e4b0b47d7e$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$a26d72e4b0b47d7e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("g", {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




function $4f88dce39ae11126$var$Stock() {
    const urlParameter = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const itemRef = (0, $6cds3.useRef)(null);
    const { data: stockData = [], isLoading: isLoading } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "stockData",
            urlParameter
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$4a24d6ea857d784a)(urlParameter),
        enabled: !!urlParameter
    });
    const detailedViewHandler = (id)=>{
        navigate(`/items/${id}`);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "collection",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "collection__headline",
                children: `${urlParameter.gender?.charAt(0).toUpperCase()}${urlParameter.gender?.slice(1)}`
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `collection__container ${isLoading ? "collection__container--override" : ""}`,
                children: isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$67ad50c48ca3ede4), {
                    visible: true,
                    height: "80",
                    width: "80",
                    color: "#6d8f6d",
                    ariaLabel: "oval-loading",
                    wrapperStyle: {},
                    wrapperClass: ""
                }) : stockData.map((item)=>{
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        onClick: ()=>{
                            detailedViewHandler(item._id);
                        },
                        className: "collection__item",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "collection__image-wrap",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "collection__image",
                                    src: item.img,
                                    alt: "Sneaker preview"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                ref: itemRef,
                                className: "collection__desc",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "collection__desc",
                                children: item.price
                            })
                        ]
                    }, item._id);
                })
            })
        ]
    });
}
var $4f88dce39ae11126$export$2e2bcd8739ae039 = $4f88dce39ae11126$var$Stock;








function $d3bf2884a8716152$var$SearchView() {
    const { name: name } = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const { data: searchData = [], isLoading: isLoading } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "searchData",
            name
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$ef4373c7e62b2278)(name),
        enabled: !!name
    });
    const detailedViewHandler = (id)=>{
        navigate(`/items/${id}`);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "search",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "search__headline",
                children: `Results for "${name?.replaceAll("+", " ")}"`
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `search__container ${isLoading || searchData?.length === 0 ? "search__container--override" : ""}`,
                children: isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$67ad50c48ca3ede4), {
                    visible: true,
                    height: "80",
                    width: "80",
                    color: "#6d8f6d",
                    ariaLabel: "oval-loading",
                    wrapperStyle: {},
                    wrapperClass: ""
                }) : searchData && searchData.length > 0 ? searchData.map((item)=>{
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        onClick: ()=>{
                            detailedViewHandler(item._id);
                        },
                        className: "search__item",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "search__image-wrap",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "search__image",
                                    src: item.img,
                                    alt: "Searched sneaker preview"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "search__desc",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "search__desc",
                                children: item.price
                            })
                        ]
                    }, item._id);
                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    children: "There is nothing to display here!"
                })
            })
        ]
    });
}
var $d3bf2884a8716152$export$2e2bcd8739ae039 = $d3bf2884a8716152$var$SearchView;





var $6cds3 = parcelRequire("6cds3");
var $e36f971cd4ef7844$exports = {};

$e36f971cd4ef7844$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "cart.d49277c3.svg";



var $cQfsc = parcelRequire("cQfsc");

function $0dade00bf701e501$var$ShoppingCart() {
    const [cart, setCart] = (0, $38a3408ff9214f5d$export$86e2cef2561044ac)("cart", {});
    const [cartPrice, setCartPrice] = (0, $6cds3.useState)(0);
    const [cartItemsCounter, setCartItemsCounter] = (0, $6cds3.useState)();
    const cartItems = ()=>Object.values(cart || {});
    const removeItem = (id, size)=>{
        const key = `${id}_${size}`;
        delete cart[key];
        setCart(cart);
    };
    const changeQuantity = (e, id)=>{
        cart[id].quantity = Number(e.target.value);
        setCart({
            ...cart
        });
    };
    (0, $6cds3.useEffect)(()=>{
        let price = 0;
        let semiPrice = 0;
        let items = 0;
        cartItems().map((item)=>{
            semiPrice = Number(item.price.split(" ")[0].replace(",", "."));
            semiPrice *= Number(item.quantity);
            price += semiPrice;
        });
        setCartPrice(price);
        setCartItemsCounter(items);
    }, [
        cart
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "cart",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "cart__headline-main",
                children: "Shopping Cart"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "cart__container",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "cart__items",
                        children: cartItems().length > 0 ? cartItems().map((item)=>{
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "cart__item",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        onClick: ()=>{
                                            removeItem(item.id, item.size);
                                        },
                                        className: "cart__remove-button",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "cart__remove-icon",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cQfsc))),
                                            alt: "Close button"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "cart__item-image",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: item.img,
                                            className: "cart__item-preview",
                                            alt: "Shoe preview"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "cart__delimiter"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "cart__description",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                className: "cart__description-bold",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                                className: "cart__description-small",
                                                children: [
                                                    "Color: ",
                                                    item.color
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                                className: "cart__description-small",
                                                children: [
                                                    "Size: ",
                                                    item.size
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "cart__item-price",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                className: "cart__price-paragraph",
                                                children: `${(Number(item.price.split(" ")[0].replace(",", ".")) * Number(item.quantity)).toFixed(2)} z\u{142}`
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                                onChange: (e)=>changeQuantity(e, `${item.id}_${item.size}`),
                                                className: "cart__quantity",
                                                value: item.quantity,
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "4"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "5"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "6"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "7"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "8"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "9"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                        children: "10"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, item.id + item.size);
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    className: "cart__headline",
                                    children: "Your cart is empty!"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                    className: "cart__empty-wrap",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e36f971cd4ef7844$exports))),
                                        alt: "Cart"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "cart__summary",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "cart__summary-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                                    className: "cart__summary-headline",
                                    children: "Order summary"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "cart__price-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "cart__price",
                                            children: "Subtotal"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                            className: "cart__price",
                                            children: [
                                                cartPrice.toFixed(2),
                                                " z\u0142"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "cart__price-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "cart__price",
                                            children: "Shipping"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "cart__price",
                                            children: "17.99 z\u0142"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "cart__price-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "cart__price cart__price-bold",
                                            children: "Total"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                            className: "cart__price cart__price-bold",
                                            children: [
                                                (cartPrice + 17.99).toFixed(2),
                                                " z\u0142"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "cart__promo-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "cart__promo",
                                            children: "Have a promo code?"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "cart__promo-form",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                    className: "cart__input",
                                                    type: "text"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                    className: "cart__promo-button",
                                                    children: "Apply"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    className: "cart__button-submit",
                                    children: "Checkout"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $0dade00bf701e501$export$2e2bcd8739ae039 = $0dade00bf701e501$var$ShoppingCart;





var $6cds3 = parcelRequire("6cds3");






function $a0ae7717168e7fb9$var$DetailedView() {
    const { name: name } = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const sizeArray = [
        36,
        36.5,
        37.5,
        38,
        38.5,
        39,
        40,
        40.5,
        41,
        42,
        42.5,
        43,
        44,
        44.5,
        45,
        45.5,
        46,
        46.5,
        47,
        47.5
    ];
    const [toggleFaves, setToggleFaves] = (0, $6cds3.useState)("");
    const [selected, setSelected] = (0, $6cds3.useState)(0);
    const [cart, setCart] = (0, $38a3408ff9214f5d$export$86e2cef2561044ac)("cart", {});
    const [faves, setFaves] = (0, $38a3408ff9214f5d$export$86e2cef2561044ac)("faves", {});
    (0, $6cds3.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const { data: data, isLoading: isLoading } = (0, $8c81402e2b240f7d$export$dd0a697e1782aedd)({
        queryKey: [
            "itemData",
            name
        ],
        queryFn: ()=>(0, $a9b114d4c5390c4c$export$878a0e4415d4b711)(name),
        enabled: !!name
    });
    const itemData = data?.[0];
    const favesHandler = ()=>{
        if (itemData) {
            if (toggleFaves === "") {
                setToggleFaves("filter-red ");
                setFaves({
                    ...faves,
                    [itemData._id]: itemData
                });
            }
            if (toggleFaves === "filter-red ") {
                setToggleFaves("");
                const { [itemData._id]: _, ...remainingFaves } = faves;
                setFaves(remainingFaves);
            }
        }
    };
    const addToCart = (itemData)=>{
        if (selected !== 0) setCart((prevCart)=>{
            const key = `${itemData._id}_${selected}`;
            if (prevCart[key]) {
                if (prevCart[key].quantity < 10) return {
                    ...prevCart,
                    [key]: {
                        ...prevCart[key],
                        quantity: prevCart[key].quantity + 1
                    }
                };
                else return prevCart;
            } else return {
                ...prevCart,
                [key]: {
                    id: itemData._id,
                    name: itemData.name,
                    color: itemData.color,
                    price: itemData.price,
                    img: itemData.img,
                    size: selected,
                    quantity: 1
                }
            };
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("main", {
        className: "detailed",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: `detailed__content ${isLoading ? "detailed__content--override" : ""}`,
            children: isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a26d72e4b0b47d7e$export$67ad50c48ca3ede4), {
                visible: true,
                height: "80",
                width: "80",
                color: "#6d8f6d",
                ariaLabel: "oval-loading",
                wrapperStyle: {},
                wrapperClass: ""
            }) : itemData && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "detailed__image-wrap",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            className: "detailed__image",
                            src: itemData.img,
                            alt: "Sneaker"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "detailed__info-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                        className: "detailed__name",
                                        children: itemData.name
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "detailed__price-tag",
                                        children: itemData.price
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                        className: "detailed__color-tag",
                                        children: [
                                            "Color: ",
                                            itemData.color
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "detailed__size-desc",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: "Choose size"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: "Size chart"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "detailed__size-table",
                                children: sizeArray.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: `detailed__size-item ${selected === item ? "detailed__size-item--active" : ""}`,
                                        onClick: ()=>{
                                            if (item === selected) setSelected(0);
                                            else setSelected(item);
                                        },
                                        children: item
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "detailed__buttons-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                        className: "detailed__favourites",
                                        onClick: favesHandler,
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                children: "Favourites"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
                                                className: `detailed__button-icon ${toggleFaves}`,
                                                width: "25px",
                                                height: "25px",
                                                viewBox: "0 0 24 24",
                                                role: "img",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                "aria-labelledby": "favouriteIconTitle",
                                                stroke: "#000000",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                fill: "none",
                                                color: "#000000",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("title", {
                                                        id: "favouriteIconTitle",
                                                        children: "Favourite"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                        d: "M12,21 L10.55,19.7051771 C5.4,15.1242507 2,12.1029973 2,8.39509537 C2,5.37384196 4.42,3 7.5,3 C9.24,3 10.91,3.79455041 12,5.05013624 C13.09,3.79455041 14.76,3 16.5,3 C19.58,3 22,5.37384196 22,8.39509537 C22,12.1029973 18.6,15.1242507 13.45,19.7149864 L12,21 Z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                        onClick: ()=>{
                                            addToCart(itemData);
                                        },
                                        className: "detailed__button-basket",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                children: "Add to Bag"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: `detailed__button-icon filter-white`,
                                                src: $c35849160b22084d$export$ecf8513b200c5cc6,
                                                alt: "Add to basket icon"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $a0ae7717168e7fb9$export$2e2bcd8739ae039 = $a0ae7717168e7fb9$var$DetailedView;




var $6cds3 = parcelRequire("6cds3");




const $26878aed7bc4968b$export$12d45ee5c2161b75 = (parcelRequire("JLGTD"));

const $26878aed7bc4968b$export$e1a8e267487c59d1 = (parcelRequire("kGTY5"));

const $26878aed7bc4968b$export$c7113aead8874e9f = (parcelRequire("aX0ER"));

const $26878aed7bc4968b$export$f59d5eab15587ea7 = (parcelRequire("bgWyS"));

const $26878aed7bc4968b$export$a3c8e1472dc2ed84 = (parcelRequire("iKWwa"));



function $7587dba1a2c8e5b0$var$Settings() {
    const [imagePreview, setImagePreview] = (0, $6cds3.useState)();
    const [isDisabled, setIsDisabled] = (0, $6cds3.useState)(true);
    const [userDetails, setUserDetails] = (0, $6cds3.useState)({
        email: "",
        name: "",
        profilePicture: "",
        surname: ""
    });
    const [image, setImage] = (0, $6cds3.useState)({
        preview: "",
        raw: ""
    });
    const surnameRef = (0, $6cds3.useRef)(null);
    const emailRef = (0, $6cds3.useRef)(null);
    const passwordRef = (0, $6cds3.useRef)(null);
    const repPasswordRef = (0, $6cds3.useRef)(null);
    const nameRef = (0, $6cds3.useRef)(null);
    const { userData: userData, setUserData: setUserData } = (0, $9412e09b930162b2$export$52a7e4f3f505b7fa)();
    (0, $6cds3.useEffect)(()=>{
        setUserDetails(userData);
        setImagePreview(userData.profilePicture);
    }, [
        userData
    ]);
    const updateRefs = {
        name: nameRef,
        surname: surnameRef,
        email: emailRef,
        password: passwordRef,
        confirmPassword: repPasswordRef
    };
    const changeStyle = (event)=>{
        const ref = updateRefs[event.target.name];
        if (ref?.current) ref?.current.classList.remove("settings__input--invalid");
    };
    const passwordReg = new RegExp(/^(?=.*[0-9])(?=.*[- ?!@#$%^&*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\/\\]{8,30}$/);
    const emailReg = new RegExp(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/);
    const editSchema = $9369df28be89e88b$export$be5493f9613cbbe({
        name: $9369df28be89e88b$export$22b082955e083ec3().min(1).max(20).required("Name is required"),
        surname: $9369df28be89e88b$export$22b082955e083ec3().min(1).max(20).required("Surname is required"),
        email: $9369df28be89e88b$export$22b082955e083ec3().email().min(5).max(30).matches(emailReg, "Invalid email"),
        password: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).matches(passwordReg, "Invalid password"),
        confirmPassword: $9369df28be89e88b$export$22b082955e083ec3().min(8).max(30).test("password-should-match", "Passwords doesn't match", function(value) {
            return this.parent.password === value;
        })
    });
    const updateUserDetails = (event)=>{
        const { name: name, value: value } = event.target;
        setUserDetails({
            ...userDetails,
            [name]: value
        });
    };
    const fileHandler = async (e)=>{
        const file = e.target?.files?.[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setImage({
                preview: previewUrl,
                raw: file
            });
            setImagePreview(previewUrl);
        }
    };
    const editPersonalData = async ()=>{
        setIsDisabled(false);
    };
    const updatePersonalData = async (e)=>{
        e.preventDefault();
        const formData = new FormData();
        try {
            await editSchema.validate(userDetails, {
                abortEarly: false
            });
            if (image.raw) formData.append("image", image.raw);
            formData.append("email", userData.email);
            formData.append("userData", JSON.stringify(userDetails));
            await (0, $a9b114d4c5390c4c$export$e3ac7a5d19605772)(formData);
            setIsDisabled(true);
            setUserData(userDetails);
        } catch (err) {
            err.inner.forEach((item)=>{
                if (item.path in updateRefs) {
                    const ref = updateRefs[item.path].current;
                    ref?.classList.add("settings__input--invalid");
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "settings__container",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("section", {
                className: "settings__addresses",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                        className: "settings__headline",
                        children: "Saved addresses"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "settings__address-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "settings__address",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Admin Adminowski"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "admin@gmail.com"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Adminowa 47b"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "47-321"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Adminowo"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "settings__icons",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                                className: "settings__icon-wrap",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "settings__icon",
                                                    src: $26878aed7bc4968b$export$12d45ee5c2161b75,
                                                    alt: "Delete"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                                className: "settings__icon-wrap",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "settings__icon",
                                                    src: $26878aed7bc4968b$export$e1a8e267487c59d1,
                                                    alt: "Edit"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "settings__address",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Admin Adminowski"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "admin@gmail.com"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Adminowa 47b"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "47-321"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__paragraph",
                                        children: "Adminowo"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "settings__icons",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                                className: "settings__icon-wrap",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "settings__icon",
                                                    src: $26878aed7bc4968b$export$12d45ee5c2161b75,
                                                    alt: "Delete"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                                className: "settings__icon-wrap",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "settings__icon",
                                                    src: $26878aed7bc4968b$export$e1a8e267487c59d1,
                                                    alt: "Edit"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("section", {
                className: "settings__payments",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                        className: "settings__headline",
                        children: "Saved payment methods"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "settings__payments-wrap",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "settings__payment",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                        className: "settings__icon-wrap",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "settings__icon settings__icon-large",
                                            src: $26878aed7bc4968b$export$f59d5eab15587ea7,
                                            alt: "Delete"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__payment-p",
                                        children: "**** **** **** 7462"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "settings__payment",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                        className: "settings__icon-wrap",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "settings__icon settings__icon-large",
                                            src: $26878aed7bc4968b$export$c7113aead8874e9f,
                                            alt: "Delete"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "settings__payment-p",
                                        children: "**** **** **** 4722"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "settings__headline",
                children: "Personal details"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "settings__details",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "settings__details-wrap",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    ref: emailRef,
                                    className: "settings__input",
                                    type: "text",
                                    onChange: (e)=>{
                                        updateUserDetails(e);
                                        changeStyle(e);
                                    },
                                    id: "email",
                                    name: "email",
                                    value: userDetails.email || "",
                                    placeholder: "E-mail",
                                    disabled: isDisabled
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "email",
                                    children: "E-mail"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    ref: passwordRef,
                                    className: "settings__input",
                                    type: "password",
                                    onChange: (e)=>{
                                        updateUserDetails(e);
                                        changeStyle(e);
                                    },
                                    id: "password",
                                    name: "password",
                                    value: "placeholder",
                                    placeholder: "Password",
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "password",
                                    children: "Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    ref: repPasswordRef,
                                    className: "settings__input",
                                    type: "password",
                                    onChange: (e)=>{
                                        updateUserDetails(e);
                                        changeStyle(e);
                                    },
                                    id: "confirmPassword",
                                    name: "confirmPassword",
                                    value: "placeholder",
                                    placeholder: "Password",
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "password",
                                    children: "Confirm Password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    ref: nameRef,
                                    className: "settings__input",
                                    type: "text",
                                    onChange: (e)=>{
                                        updateUserDetails(e);
                                        changeStyle(e);
                                    },
                                    id: "name",
                                    name: "name",
                                    value: userDetails.name || "",
                                    placeholder: "Name",
                                    disabled: isDisabled
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "name",
                                    children: "Name"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    ref: surnameRef,
                                    className: "settings__input",
                                    type: "text",
                                    onChange: (e)=>{
                                        updateUserDetails(e);
                                        changeStyle(e);
                                    },
                                    id: "surname",
                                    name: "surname",
                                    value: userDetails.surname || "",
                                    placeholder: "Surname",
                                    disabled: isDisabled
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "surname",
                                    children: "Surname"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "settings__input-wrap",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "settings__input",
                                    type: "date",
                                    name: "dateOfBirth",
                                    id: "dateOfBirth",
                                    value: "2002-01-12",
                                    placeholder: "Date of birth",
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                    className: "settings__label",
                                    htmlFor: "dateOfBirth",
                                    children: "Date of birth"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "setting__last-row",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "settings__avatar-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("figure", {
                                            className: "settings__avatar",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "settings__avatar-img",
                                                src: imagePreview,
                                                alt: "Avatar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("label", {
                                            htmlFor: "file-upload",
                                            className: "settings__file-upload",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    src: $26878aed7bc4968b$export$a3c8e1472dc2ed84,
                                                    className: "settings__icon-sm",
                                                    alt: "Upload profile"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "settings__file-p",
                                                    children: "Upload"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            onChange: fileHandler,
                                            accept: ".png,.jpg, .svg",
                                            className: "settings__file-hidden",
                                            id: "file-upload",
                                            type: "file"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "settings__submit-wrap",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "settings__button--wrap",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                className: "setting__submit",
                                                onClick: editPersonalData,
                                                children: "Edit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "settings__button--wrap",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                className: "setting__submit",
                                                onClick: updatePersonalData,
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $7587dba1a2c8e5b0$export$2e2bcd8739ae039 = $7587dba1a2c8e5b0$var$Settings;





const $77b0835fd89f7b0c$var$UserData = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4dc90d0483af932c$export$951f08dc7fcffbbe), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$910ae8079b2c2852), {})
    });
};
var $77b0835fd89f7b0c$export$2e2bcd8739ae039 = $77b0835fd89f7b0c$var$UserData;



var $e4cef39bc51afcac$exports = {};

$e4cef39bc51afcac$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "empty-box.855ad577.svg";



function $49e403af0dd1ebad$var$Orders() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("main", {
        className: "orders__container",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h4", {
                className: "orders__headline",
                children: "Orders"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "orders__container empty",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "orders__empty-content",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            className: "orders__image-empty",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e4cef39bc51afcac$exports))),
                            alt: "Package box"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "orders__headline",
                            children: "No orders yet!"
                        })
                    ]
                })
            })
        ]
    });
}
var $49e403af0dd1ebad$export$2e2bcd8739ae039 = $49e403af0dd1ebad$var$Orders;









var $3658d0592ab712cd$var$_queries;
var $3658d0592ab712cd$export$5dde0cd941da8468 = class extends (0, $2bdd4a402e6e5ce5$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $3658d0592ab712cd$var$_queries, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $3658d0592ab712cd$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $96e46b4f8c8392c0$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $e434149c2a85bd85$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).has(query.queryHash)) {
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $3658d0592ab712cd$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $96e46b4f8c8392c0$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $96e46b4f8c8392c0$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$3658d0592ab712cd$var$_queries = new WeakMap();








var $0266bef73fb2d289$var$_observers, $0266bef73fb2d289$var$_mutationCache, $0266bef73fb2d289$var$_retryer, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn;
var $0266bef73fb2d289$export$17b8b19c814bcf56 = class extends (0, $0403a4a3b9013de6$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $0266bef73fb2d289$var$_dispatch);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $0266bef73fb2d289$var$_observers, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $0266bef73fb2d289$var$_mutationCache, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $0266bef73fb2d289$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0266bef73fb2d289$var$_mutationCache, config.mutationCache);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0266bef73fb2d289$var$_observers, []);
        this.state = config.state || $0266bef73fb2d289$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_observers).includes(observer)) {
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0266bef73fb2d289$var$_observers, (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $0266bef73fb2d289$var$_retryer, (0, $e2683b672d9da063$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_retryer).start();
            await ((_f = (_e = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $e0532d8d0a9557f5$export$fa92d15b718fce20)(this, $0266bef73fb2d289$var$_dispatch, $0266bef73fb2d289$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).runNext(this);
        }
    }
};
$0266bef73fb2d289$var$_observers = new WeakMap();
$0266bef73fb2d289$var$_mutationCache = new WeakMap();
$0266bef73fb2d289$var$_retryer = new WeakMap();
$0266bef73fb2d289$var$_dispatch = new WeakSet();
$0266bef73fb2d289$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $0266bef73fb2d289$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $0266bef73fb2d289$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $58fb1d4399d1f625$var$_mutations, $58fb1d4399d1f625$var$_mutationId;
var $58fb1d4399d1f625$export$1fcfd9a244434844 = class extends (0, $2bdd4a402e6e5ce5$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $58fb1d4399d1f625$var$_mutations, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $58fb1d4399d1f625$var$_mutationId, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $58fb1d4399d1f625$var$_mutations, /* @__PURE__ */ new Map());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $58fb1d4399d1f625$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $0266bef73fb2d289$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $e0532d8d0a9557f5$export$b1fe7cbb4502036b)(this, $58fb1d4399d1f625$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $58fb1d4399d1f625$var$scopeFor(mutation);
        const mutations = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $58fb1d4399d1f625$var$scopeFor(mutation);
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).delete(scope);
                else (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).get($58fb1d4399d1f625$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).get($58fb1d4399d1f625$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $58fb1d4399d1f625$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $96e46b4f8c8392c0$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $96e46b4f8c8392c0$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $96e46b4f8c8392c0$export$8793edee2d425525)))));
    }
};
$58fb1d4399d1f625$var$_mutations = new WeakMap();
$58fb1d4399d1f625$var$_mutationId = new WeakMap();
function $58fb1d4399d1f625$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}







function $24648b0aae85ff64$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $96e46b4f8c8392c0$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $96e46b4f8c8392c0$export$8c6246b73dd61f4a) : (0, $96e46b4f8c8392c0$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $24648b0aae85ff64$var$getPreviousPageParam : $24648b0aae85ff64$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $24648b0aae85ff64$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $24648b0aae85ff64$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $24648b0aae85ff64$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $24648b0aae85ff64$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $24648b0aae85ff64$var$getNextPageParam(options, data) != null;
}
function $24648b0aae85ff64$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $24648b0aae85ff64$var$getPreviousPageParam(options, data) != null;
}


var $09dd2c185428c008$var$_queryCache, $09dd2c185428c008$var$_mutationCache, $09dd2c185428c008$var$_defaultOptions, $09dd2c185428c008$var$_queryDefaults, $09dd2c185428c008$var$_mutationDefaults, $09dd2c185428c008$var$_mountCount, $09dd2c185428c008$var$_unsubscribeFocus, $09dd2c185428c008$var$_unsubscribeOnline;
var $09dd2c185428c008$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_queryCache, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_mutationCache, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_defaultOptions, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_queryDefaults, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_mutationDefaults, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_mountCount, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_unsubscribeFocus, void 0);
        (0, $e0532d8d0a9557f5$export$addf369becd23283)(this, $09dd2c185428c008$var$_unsubscribeOnline, void 0);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_queryCache, config.queryCache || new (0, $3658d0592ab712cd$export$5dde0cd941da8468)());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_mutationCache, config.mutationCache || new (0, $58fb1d4399d1f625$export$1fcfd9a244434844)());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_defaultOptions, config.defaultOptions || {});
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_mountCount, 0);
    }
    mount() {
        (0, $e0532d8d0a9557f5$export$b1fe7cbb4502036b)(this, $09dd2c185428c008$var$_mountCount)._++;
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mountCount) !== 1) return;
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_unsubscribeFocus, (0, $6baa0e82ffe3e9b9$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).onFocus();
            }
        }));
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_unsubscribeOnline, (0, $97f19485168d5510$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $e0532d8d0a9557f5$export$b1fe7cbb4502036b)(this, $09dd2c185428c008$var$_mountCount)._--;
        if ((0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mountCount) !== 0) return;
        (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_unsubscribeFocus, void 0);
        (_b = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime((0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $96e46b4f8c8392c0$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache);
        (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $96e46b4f8c8392c0$export$8793edee2d425525)).catch((0, $96e46b4f8c8392c0$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>{
            (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $5d35a9f3710b2512$export$520687f44db6e1ab).batch(()=>(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $96e46b4f8c8392c0$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $96e46b4f8c8392c0$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $96e46b4f8c8392c0$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $96e46b4f8c8392c0$export$8793edee2d425525)).catch((0, $96e46b4f8c8392c0$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $24648b0aae85ff64$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $96e46b4f8c8392c0$export$8793edee2d425525)).catch((0, $96e46b4f8c8392c0$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $24648b0aae85ff64$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $97f19485168d5510$export$b113e788b2dd3fdc).isOnline()) return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache);
    }
    getMutationCache() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $e0532d8d0a9557f5$export$42432efe6614d3b4)(this, $09dd2c185428c008$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryDefaults).set((0, $96e46b4f8c8392c0$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $96e46b4f8c8392c0$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationDefaults).set((0, $96e46b4f8c8392c0$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $96e46b4f8c8392c0$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $96e46b4f8c8392c0$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $96e46b4f8c8392c0$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_queryCache).clear();
        (0, $e0532d8d0a9557f5$export$18a094aefa070634)(this, $09dd2c185428c008$var$_mutationCache).clear();
    }
};
$09dd2c185428c008$var$_queryCache = new WeakMap();
$09dd2c185428c008$var$_mutationCache = new WeakMap();
$09dd2c185428c008$var$_defaultOptions = new WeakMap();
$09dd2c185428c008$var$_queryDefaults = new WeakMap();
$09dd2c185428c008$var$_mutationDefaults = new WeakMap();
$09dd2c185428c008$var$_mountCount = new WeakMap();
$09dd2c185428c008$var$_unsubscribeFocus = new WeakMap();
$09dd2c185428c008$var$_unsubscribeOnline = new WeakMap();


const $18cb66d1e7a58135$var$queryClient = new (0, $09dd2c185428c008$export$405d0624ed55a03f)();
function $18cb66d1e7a58135$var$App() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $03084753dc39ab74$export$45604f0cc8ae667b), {
        client: $18cb66d1e7a58135$var$queryClient,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $37be56838633f7f9$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$3565eb3d00ca5a74), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $12aae65bde46d705$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9d53e9399f65a2ff$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/reset-password/:token",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9d53e9399f65a2ff$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/favourites",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $80a0b0c02dacf1a6$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/stock/:gender",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4f88dce39ae11126$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/search/:name",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d3bf2884a8716152$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/items/:name",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a0ae7717168e7fb9$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                path: "/cart",
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0dade00bf701e501$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $eef4bddb5d352632$export$1221790706ba044f), {}),
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $77b0835fd89f7b0c$export$2e2bcd8739ae039), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                            path: "/profile",
                                            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c4024906b579fc24$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                            path: "profile/settings",
                                            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $7587dba1a2c8e5b0$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                                            path: "profile/orders",
                                            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $49e403af0dd1ebad$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $031e0d82e9f3387e$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;



const $993cd7b19eac2dad$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("86xDK")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $993cd7b19eac2dad$export$2e2bcd8739ae039 = $993cd7b19eac2dad$var$reportWebVitals;



function $db91821ee08a0a16$export$f6e2535fb5126e54(obj) {
    return typeof obj === "function";
}
function $db91821ee08a0a16$export$a6cdc56e425d0d0a(obj) {
    const type = typeof obj;
    return type === "function" || type === "object" && !!obj;
}
function $db91821ee08a0a16$export$e1ced524db55e52e() {
    return typeof window !== "undefined" && window.document;
}


function $2a8f8d39e883d963$export$a4475784d419ac3b() {
    if ((0, $db91821ee08a0a16$export$e1ced524db55e52e)()) {
        // Ensure the React Developer Tools global hook exists
        if (!(0, $db91821ee08a0a16$export$a6cdc56e425d0d0a)(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) return;
        // Replace all global hook properties with a no-op function or a null value
        for(const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__){
            if (prop === "renderers") {
                // prevents console error when dev tools try to iterate of renderers
                window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = new Map();
                continue;
            }
            window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = (0, $db91821ee08a0a16$export$f6e2535fb5126e54)(window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop]) ? Function.prototype : null;
        }
    }
}


const $7dfc410149830cad$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root"));
(0, $2a8f8d39e883d963$export$a4475784d419ac3b)();
$7dfc410149830cad$var$root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f321b107431e002f$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $18cb66d1e7a58135$export$2e2bcd8739ae039), {})
    })
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $993cd7b19eac2dad$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.07fbd9d2.js.map
